/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/+root'
import { Route as Char43HomeRouteImport } from './pages/+Home'
import { Route as adminChar43LayoutRouteImport } from './pages/admin/+Layout'
import { Route as campaignsChar43LayoutRouteImport } from './pages/campaigns/+Layout'
import { Route as dashboardChar43LayoutRouteImport } from './pages/dashboard/+Layout'
import { Route as demoChar43routeRouteImport } from './pages/demo/+route'
import { Route as forgotPasswordIndexRouteImport } from './pages/forgot-password/index'
import { Route as newAccountIndexRouteImport } from './pages/new-account/index'
import { Route as newSupplierIndexRouteImport } from './pages/new-supplier/index'
import { Route as signInIndexRouteImport } from './pages/sign-in/index'
import { Route as adminChar43AdminHomeRouteImport } from './pages/admin/+AdminHome'
import { Route as adminAccountOwnersIndexRouteImport } from './pages/admin/account-owners/index'
import { Route as adminCategoriesIndexRouteImport } from './pages/admin/categories/index'
import { Route as adminCountriesIndexRouteImport } from './pages/admin/countries/index'
import { Route as adminDevtoolsChar43LayoutRouteImport } from './pages/admin/devtools/+Layout'
import { Route as adminChar43expiryRouteImport } from './pages/admin/+expiry'
import { Route as adminLegalIndexRouteImport } from './pages/admin/legal/index'
import { Route as adminListingReviewIndexRouteImport } from './pages/admin/listing-review/index'
import { Route as adminMembersIndexRouteImport } from './pages/admin/members/index'
import { Route as adminResourceCategoriesIndexRouteImport } from './pages/admin/resource-categories/index'
import { Route as adminResourcesIndexRouteImport } from './pages/admin/resources/index'
import { Route as adminStaffChar43routeRouteImport } from './pages/admin/staff/+route'
import { Route as adminSuppliersIndexRouteImport } from './pages/admin/suppliers/index'
import { Route as adminSupportersIndexRouteImport } from './pages/admin/supporters/index'
import { Route as adminSurplusesIndexRouteImport } from './pages/admin/surpluses/index'
import { Route as adminThemesIndexRouteImport } from './pages/admin/themes/index'
import { Route as adminUserSettingsIndexRouteImport } from './pages/admin/user-settings/index'
import { Route as campaignsChar43CampaignsOverviewRouteImport } from './pages/campaigns/+CampaignsOverview'
import { Route as dashboardChar43DashboardRouteImport } from './pages/dashboard/+Dashboard'
import { Route as dashboardChar43cashFlowRouteImport } from './pages/dashboard/+cash-flow'
import { Route as dashboardChar43CostsDashboardRouteImport } from './pages/dashboard/+CostsDashboard'
import { Route as dashboardCoverageChar43CoverageDashboardRouteImport } from './pages/dashboard/coverage/+CoverageDashboard'
import { Route as dashboardChar43eapUtilisationRouteImport } from './pages/dashboard/+eap-utilisation'
import { Route as dashboardChar43listingPricesRouteImport } from './pages/dashboard/+listing-prices'
import { Route as dashboardChar43MRRRouteImport } from './pages/dashboard/+MRR'
import { Route as dashboardChar43spendingRouteImport } from './pages/dashboard/+spending'
import { Route as dashboardChar43TVRouteImport } from './pages/dashboard/+TV'
import { Route as dashboardChar43tv2RouteImport } from './pages/dashboard/+tv2'
import { Route as dashboardChar43UsageDashboardRouteImport } from './pages/dashboard/+UsageDashboard'
import { Route as dashboardChar43utilisationRouteImport } from './pages/dashboard/+utilisation'
import { Route as invitationActivateIndexRouteImport } from './pages/invitation/activate/index'
import { Route as policiesChar43eapSupplierRouteImport } from './pages/policies/+eap-supplier'
import { Route as supplierChar43LayoutRouteImport } from './pages/supplier/+Layout'
import { Route as supporterChar43LayoutRouteImport } from './pages/supporter/+Layout'
import { Route as adminClaimsIndexRouteImport } from './pages/admin/claims/index'
import { Route as adminClaimsChar91claimIdChar93IndexRouteImport } from './pages/admin/claims/[claimId]/index'
import { Route as adminDevtoolsChar43DevToolsRouteImport } from './pages/admin/devtools/+DevTools'
import { Route as adminDevtoolsAirwallexIndexRouteImport } from './pages/admin/devtools/airwallex/index'
import { Route as adminDevtoolsBillingSimIndexRouteImport } from './pages/admin/devtools/billing-sim/index'
import { Route as adminDevtoolsListingSelectorIndexRouteImport } from './pages/admin/devtools/listing-selector/index'
import { Route as adminDevtoolsMemberLookupIndexRouteImport } from './pages/admin/devtools/member-lookup/index'
import { Route as adminDevtoolsUiIndexRouteImport } from './pages/admin/devtools/ui/index'
import { Route as adminLegalChar43LegalTermsListPageRouteImport } from './pages/admin/legal/+LegalTermsListPage'
import { Route as adminLegalChar91termsIdChar93IndexRouteImport } from './pages/admin/legal/[termsId]/index'
import { Route as adminLegalNewIndexRouteImport } from './pages/admin/legal/new/index'
import { Route as adminListingReviewChar43ListingReviewOverviewPageRouteImport } from './pages/admin/listing-review/+ListingReviewOverviewPage'
import { Route as adminMembersChar43MembersPageRouteImport } from './pages/admin/members/+MembersPage'
import { Route as adminMembersChar91memberIdChar93IndexRouteImport } from './pages/admin/members/[memberId]/index'
import { Route as adminReportsIndexRouteImport } from './pages/admin/reports/index'
import { Route as adminResourcesChar43ResourcesPageRouteImport } from './pages/admin/resources/+ResourcesPage'
import { Route as adminResourcesChar91resourceIdChar93IndexRouteImport } from './pages/admin/resources/[resourceId]/index'
import { Route as adminSuppliersChar43SuppliersPageRouteImport } from './pages/admin/suppliers/+SuppliersPage'
import { Route as adminSuppliersChar91supplierIdChar93IndexRouteImport } from './pages/admin/suppliers/[supplierId]/index'
import { Route as adminSupportersChar43SupportersPageRouteImport } from './pages/admin/supporters/+SupportersPage'
import { Route as adminSupportersChar91supporterIdChar93IndexRouteImport } from './pages/admin/supporters/[supporterId]/index'
import { Route as campaignsSegmentsChar43SegmentsPageRouteImport } from './pages/campaigns/segments/+SegmentsPage'
import { Route as campaignsSegmentsChar43SegmentEditorRouteImport } from './pages/campaigns/segments/+SegmentEditor'
import { Route as campaignsSendsChar43SendsPageRouteImport } from './pages/campaigns/sends/+SendsPage'
import { Route as campaignsSendsChar43SendDetailRouteImport } from './pages/campaigns/sends/+SendDetail'
import { Route as campaignsSendsChar43CreateSendRouteImport } from './pages/campaigns/sends/+CreateSend'
import { Route as campaignsTemplatesChar43TemplatesPageRouteImport } from './pages/campaigns/templates/+TemplatesPage'
import { Route as campaignsTemplatesChar43TemplateEditorRouteImport } from './pages/campaigns/templates/+TemplateEditor'
import { Route as campaignsSuppressionChar43UnsubscribedListRouteImport } from './pages/campaigns/suppression/+UnsubscribedList'
import { Route as supplierChar43SupplierHomeRouteImport } from './pages/supplier/+SupplierHome'
import { Route as supplierBookingsIndexRouteImport } from './pages/supplier/bookings/index'
import { Route as supplierEapIndexRouteImport } from './pages/supplier/eap/index'
import { Route as supplierEapReviewChar43ReviewListRouteImport } from './pages/supplier/eap-review/+ReviewList'
import { Route as supplierListingsIndexRouteImport } from './pages/supplier/listings/index'
import { Route as supplierMessagesIndexRouteImport } from './pages/supplier/messages/index'
import { Route as supplierOrdersIndexRouteImport } from './pages/supplier/orders/index'
import { Route as supplierPassesIndexRouteImport } from './pages/supplier/passes/index'
import { Route as supplierPaymentsIndexRouteImport } from './pages/supplier/payments/index'
import { Route as supplierSalesIndexRouteImport } from './pages/supplier/sales/index'
import { Route as supplierSettingsIndexRouteImport } from './pages/supplier/settings/index'
import { Route as supplierSkuIndexRouteImport } from './pages/supplier/sku/index'
import { Route as supplierSubscriptionsIndexRouteImport } from './pages/supplier/subscriptions/index'
import { Route as supplierUserSettingsIndexRouteImport } from './pages/supplier/user-settings/index'
import { Route as supporterChar43SupporterHomeRouteImport } from './pages/supporter/+SupporterHome'
import { Route as supporterAdminsIndexRouteImport } from './pages/supporter/admins/index'
import { Route as supporterAllowanceReportsChar43LayoutRouteImport } from './pages/supporter/allowance-reports/+Layout'
import { Route as supporterAllowancesIndexRouteImport } from './pages/supporter/allowances/index'
import { Route as supporterEapIndexRouteImport } from './pages/supporter/eap/index'
import { Route as supporterFinancialReportsChar43reportsRouteImport } from './pages/supporter/financial-reports/+reports'
import { Route as supporterHistoryIndexRouteImport } from './pages/supporter/history/index'
import { Route as supporterReportsIndexRouteImport } from './pages/supporter/reports/index'
import { Route as supporterSettingsChar43routeRouteImport } from './pages/supporter/settings/+route'
import { Route as supporterTeamIndexRouteImport } from './pages/supporter/team/index'
import { Route as supporterUserSettingsIndexRouteImport } from './pages/supporter/user-settings/index'
import { Route as adminListingReviewChar43ListingReviewPageRouteImport } from './pages/admin/listing-review/+ListingReviewPage'
import { Route as adminMembersChar91memberIdChar93NewClaimIndexRouteImport } from './pages/admin/members/[memberId]/new-claim/index'
import { Route as adminMembersChar91memberIdChar93NewPurchaseIndexRouteImport } from './pages/admin/members/[memberId]/new-purchase/index'
import { Route as adminMembersChar91memberIdChar93TransactionsIndexRouteImport } from './pages/admin/members/[memberId]/transactions/index'
import { Route as adminReportsChar43cardPaymentsRouteImport } from './pages/admin/reports/+card-payments'
import { Route as adminReportsChar43CurrentSupportersReportPageRouteImport } from './pages/admin/reports/+CurrentSupportersReportPage'
import { Route as adminReportsDailyPayoutsChar43layoutRouteImport } from './pages/admin/reports/daily-payouts/+layout'
import { Route as adminReportsEapChar43SupporterEapArrearsPageRouteImport } from './pages/admin/reports/eap/+SupporterEapArrearsPage'
import { Route as adminReportsEapChar43EapListingQuailityReviewRouteImport } from './pages/admin/reports/eap/+EapListingQuailityReview'
import { Route as adminReportsEapChar43EapSessionRequestsPageRouteImport } from './pages/admin/reports/eap/+EapSessionRequestsPage'
import { Route as adminReportsEapChar43EapUnclosedSessionsPageRouteImport } from './pages/admin/reports/eap/+EapUnclosedSessionsPage'
import { Route as adminReportsChar43MemberSubscriptionsReportPageRouteImport } from './pages/admin/reports/+MemberSubscriptionsReportPage'
import { Route as adminReportsChar43projectedMrrRouteImport } from './pages/admin/reports/+projected-mrr'
import { Route as adminReportsChar43SupporterMonthlyStatsReportPageRouteImport } from './pages/admin/reports/+SupporterMonthlyStatsReportPage'
import { Route as adminReportsChar43SupporterSalesReportPageRouteImport } from './pages/admin/reports/+SupporterSalesReportPage'
import { Route as adminSuppliersChar91supplierIdChar93Char43SupplierPageRouteImport } from './pages/admin/suppliers/[supplierId]/+SupplierPage'
import { Route as adminSuppliersChar91supplierIdChar93CalendarsIndexRouteImport } from './pages/admin/suppliers/[supplierId]/calendars/index'
import { Route as adminSuppliersChar91supplierIdChar93LocationsIndexRouteImport } from './pages/admin/suppliers/[supplierId]/locations/index'
import { Route as adminSuppliersChar91supplierIdChar93SettingsIndexRouteImport } from './pages/admin/suppliers/[supplierId]/settings/index'
import { Route as adminSupportersChar91supporterIdChar93Char43SupporterPageRouteImport } from './pages/admin/supporters/[supporterId]/+SupporterPage'
import { Route as adminSupportersChar91supporterIdChar93Char43BillingPageRouteImport } from './pages/admin/supporters/[supporterId]/+BillingPage'
import { Route as adminSupportersChar91supporterIdChar93Char43EAPPageRouteImport } from './pages/admin/supporters/[supporterId]/+EAPPage'
import { Route as adminSupportersChar91supporterIdChar93Char43NotePageRouteImport } from './pages/admin/supporters/[supporterId]/+NotePage'
import { Route as adminSupportersChar91supporterIdChar93Char43SettingsPageRouteImport } from './pages/admin/supporters/[supporterId]/+SettingsPage'
import { Route as supplierEapReviewIndexRouteImport } from './pages/supplier/eap-review/index'
import { Route as supplierEapReviewChar91purchaseIdChar93IndexRouteImport } from './pages/supplier/eap-review/[purchaseId]/index'
import { Route as supplierEapChar43EAPListRouteImport } from './pages/supplier/eap/+EAPList'
import { Route as supplierEapNewIndexRouteImport } from './pages/supplier/eap/new/index'
import { Route as supplierListingsChar43ListingsPageRouteImport } from './pages/supplier/listings/+ListingsPage'
import { Route as supplierListingsNewIndexRouteImport } from './pages/supplier/listings/new/index'
import { Route as supplierMessagesChar43MessagesRouteImport } from './pages/supplier/messages/+Messages'
import { Route as supplierMessagesChar91conversationIdChar93IndexRouteImport } from './pages/supplier/messages/[conversationId]/index'
import { Route as supplierSalesChar43SupplierSalesRouteImport } from './pages/supplier/sales/+SupplierSales'
import { Route as supplierSalesChar91purchaseIdChar93IndexRouteImport } from './pages/supplier/sales/[purchaseId]/index'
import { Route as supplierSettingsProfileIndexRouteImport } from './pages/supplier/settings/profile/index'
import { Route as supplierSettingsAutomationsIndexRouteImport } from './pages/supplier/settings/automations/index'
import { Route as supplierSettingsBusinessIndexRouteImport } from './pages/supplier/settings/business/index'
import { Route as supplierSettingsCalendarsIndexRouteImport } from './pages/supplier/settings/calendars/index'
import { Route as supplierSettingsGivenwellTermsIndexRouteImport } from './pages/supplier/settings/givenwell-terms/index'
import { Route as supplierSettingsLegalIndexRouteImport } from './pages/supplier/settings/legal/index'
import { Route as supplierSettingsLocationsIndexRouteImport } from './pages/supplier/settings/locations/index'
import { Route as supplierSettingsMarketsIndexRouteImport } from './pages/supplier/settings/markets/index'
import { Route as supplierSettingsPaymentIndexRouteImport } from './pages/supplier/settings/payment/index'
import { Route as supplierSettingsRefundIndexRouteImport } from './pages/supplier/settings/refund/index'
import { Route as supplierSettingsTeamIndexRouteImport } from './pages/supplier/settings/team/index'
import { Route as supporterAdminsChar91userIdChar93IndexRouteImport } from './pages/supporter/admins/[userId]/index'
import { Route as supporterAllowanceReportsChar43indexRouteImport } from './pages/supporter/allowance-reports/+index'
import { Route as supporterAllowanceReportsForecastIndexRouteImport } from './pages/supporter/allowance-reports/forecast/index'
import { Route as supporterAllowanceReportsInsightsIndexRouteImport } from './pages/supporter/allowance-reports/insights/index'
import { Route as supporterAllowanceReportsSpendIndexRouteImport } from './pages/supporter/allowance-reports/spend/index'
import { Route as supporterAllowanceReportsUtilisationIndexRouteImport } from './pages/supporter/allowance-reports/utilisation/index'
import { Route as supporterEapChar43EAPRouteImport } from './pages/supporter/eap/+EAP'
import { Route as supporterEapSettingsIndexRouteImport } from './pages/supporter/eap/settings/index'
import { Route as supporterFinancialReportsChar43indexRouteImport } from './pages/supporter/financial-reports/+index'
import { Route as supporterFinancialReportsInvoicesIndexRouteImport } from './pages/supporter/financial-reports/invoices/index'
import { Route as supporterFinancialReportsTransactionsIndexRouteImport } from './pages/supporter/financial-reports/transactions/index'
import { Route as supporterSettingsChar43indexRouteImport } from './pages/supporter/settings/+index'
import { Route as supporterSettingsBillingIndexRouteImport } from './pages/supporter/settings/billing/index'
import { Route as supporterSettingsCountriesIndexRouteImport } from './pages/supporter/settings/countries/index'
import { Route as supporterSettingsGivenwellTermsIndexRouteImport } from './pages/supporter/settings/givenwell-terms/index'
import { Route as adminReportsDailyPayoutsChar43DailyPayoutsRouteImport } from './pages/admin/reports/daily-payouts/+DailyPayouts'
import { Route as adminReportsDailyPayoutsChar43DailyPayoutsDetailRouteImport } from './pages/admin/reports/daily-payouts/+DailyPayoutsDetail'
import { Route as supplierEapChar91listingIdChar93Char43pageRouteImport } from './pages/supplier/eap/[listingId]/+page'
import { Route as supplierListingsChar91listingIdChar93Char43EditListingPageRouteImport } from './pages/supplier/listings/[listingId]/+EditListingPage'
import { Route as supplierSettingsCalendarsChar43CalendarSettingsRouteImport } from './pages/supplier/settings/calendars/+CalendarSettings'
import { Route as supplierSettingsCalendarsChar91calendarIdChar93IndexRouteImport } from './pages/supplier/settings/calendars/[calendarId]/index'
import { Route as supplierSettingsRefundChar43RefundSettingsRouteImport } from './pages/supplier/settings/refund/+RefundSettings'
import { Route as supplierSettingsTeamChar43TeamTableRouteImport } from './pages/supplier/settings/team/+TeamTable'
import { Route as supporterEapRequestsIndexRouteImport } from './pages/supporter/eap/requests/index'
import { Route as supporterEapRequestsChar91requestIdChar93IndexRouteImport } from './pages/supporter/eap/requests/[requestId]/index'
import { Route as supporterFinancialReportsTransactionsChar43WalletRouteImport } from './pages/supporter/financial-reports/transactions/+Wallet'
import { Route as supplierListingsChar91listingIdChar93Char43indexRouteImport } from './pages/supplier/listings/[listingId]/+index'
import { Route as supplierListingsChar91listingIdChar93Char43variantsRouteImport } from './pages/supplier/listings/[listingId]/+variants'
import { Route as supplierSettingsCalendarsChar91calendarIdChar93Char43EditCalendarSettingsRouteImport } from './pages/supplier/settings/calendars/[calendarId]/+EditCalendarSettings'
import { Route as supplierSettingsCalendarsChar91calendarIdChar93ConnectIndexRouteImport } from './pages/supplier/settings/calendars/[calendarId]/connect/index'
import { Route as supplierSettingsCalendarsChar91calendarIdChar93DisconnectIndexRouteImport } from './pages/supplier/settings/calendars/[calendarId]/disconnect/index'
import { Route as supplierSettingsCalendarsChar91calendarIdChar93ExternalIndexRouteImport } from './pages/supplier/settings/calendars/[calendarId]/external/index'
import { Route as supplierSettingsRefundCancellationPolicyChar91policyIdChar93IndexRouteImport } from './pages/supplier/settings/refund/cancellation-policy/[policyId]/index'
import { Route as supporterFinancialReportsTransactionsAllowanceChar91batchIdChar93IndexRouteImport } from './pages/supporter/financial-reports/transactions/allowance/[batchId]/index'
import { Route as supporterFinancialReportsTransactionsDetailsChar91versionChar93IndexRouteImport } from './pages/supporter/financial-reports/transactions/details/[version]/index'
import { Route as supplierListingsChar91listingIdChar93Char43variantRouteImport } from './pages/supplier/listings/[listingId]/+variant'

const Char43HomeRoute = Char43HomeRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const adminChar43LayoutRoute = adminChar43LayoutRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const campaignsChar43LayoutRoute = campaignsChar43LayoutRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardChar43LayoutRoute = dashboardChar43LayoutRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const demoChar43routeRoute = demoChar43routeRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const forgotPasswordIndexRoute = forgotPasswordIndexRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const newAccountIndexRoute = newAccountIndexRouteImport.update({
  id: '/new-account',
  path: '/new-account',
  getParentRoute: () => rootRouteImport,
} as any)
const newSupplierIndexRoute = newSupplierIndexRouteImport.update({
  id: '/new-supplier',
  path: '/new-supplier',
  getParentRoute: () => rootRouteImport,
} as any)
const signInIndexRoute = signInIndexRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const adminChar43AdminHomeRoute = adminChar43AdminHomeRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminAccountOwnersIndexRoute = adminAccountOwnersIndexRouteImport.update({
  id: '/account-owners',
  path: '/account-owners',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminCategoriesIndexRoute = adminCategoriesIndexRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminCountriesIndexRoute = adminCountriesIndexRouteImport.update({
  id: '/countries',
  path: '/countries',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminDevtoolsChar43LayoutRoute =
  adminDevtoolsChar43LayoutRouteImport.update({
    id: '/devtools',
    path: '/devtools',
    getParentRoute: () => adminChar43LayoutRoute,
  } as any)
const adminChar43expiryRoute = adminChar43expiryRouteImport.update({
  id: '/expiry',
  path: '/expiry',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminLegalIndexRoute = adminLegalIndexRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminListingReviewIndexRoute = adminListingReviewIndexRouteImport.update({
  id: '/listing-review',
  path: '/listing-review',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminMembersIndexRoute = adminMembersIndexRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminResourceCategoriesIndexRoute =
  adminResourceCategoriesIndexRouteImport.update({
    id: '/resource-categories',
    path: '/resource-categories',
    getParentRoute: () => adminChar43LayoutRoute,
  } as any)
const adminResourcesIndexRoute = adminResourcesIndexRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminStaffChar43routeRoute = adminStaffChar43routeRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminSuppliersIndexRoute = adminSuppliersIndexRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminSupportersIndexRoute = adminSupportersIndexRouteImport.update({
  id: '/supporters',
  path: '/supporters',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminSurplusesIndexRoute = adminSurplusesIndexRouteImport.update({
  id: '/surpluses',
  path: '/surpluses',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminThemesIndexRoute = adminThemesIndexRouteImport.update({
  id: '/themes',
  path: '/themes',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminUserSettingsIndexRoute = adminUserSettingsIndexRouteImport.update({
  id: '/user-settings',
  path: '/user-settings',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const campaignsChar43CampaignsOverviewRoute =
  campaignsChar43CampaignsOverviewRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => campaignsChar43LayoutRoute,
  } as any)
const dashboardChar43DashboardRoute =
  dashboardChar43DashboardRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardChar43LayoutRoute,
  } as any)
const dashboardChar43cashFlowRoute = dashboardChar43cashFlowRouteImport.update({
  id: '/cash-flow',
  path: '/cash-flow',
  getParentRoute: () => dashboardChar43LayoutRoute,
} as any)
const dashboardChar43CostsDashboardRoute =
  dashboardChar43CostsDashboardRouteImport.update({
    id: '/costs',
    path: '/costs',
    getParentRoute: () => dashboardChar43LayoutRoute,
  } as any)
const dashboardCoverageChar43CoverageDashboardRoute =
  dashboardCoverageChar43CoverageDashboardRouteImport.update({
    id: '/coverage',
    path: '/coverage',
    getParentRoute: () => dashboardChar43LayoutRoute,
  } as any)
const dashboardChar43eapUtilisationRoute =
  dashboardChar43eapUtilisationRouteImport.update({
    id: '/eap-utilisation',
    path: '/eap-utilisation',
    getParentRoute: () => dashboardChar43LayoutRoute,
  } as any)
const dashboardChar43listingPricesRoute =
  dashboardChar43listingPricesRouteImport.update({
    id: '/listing-prices',
    path: '/listing-prices',
    getParentRoute: () => dashboardChar43LayoutRoute,
  } as any)
const dashboardChar43MRRRoute = dashboardChar43MRRRouteImport.update({
  id: '/mrr',
  path: '/mrr',
  getParentRoute: () => dashboardChar43LayoutRoute,
} as any)
const dashboardChar43spendingRoute = dashboardChar43spendingRouteImport.update({
  id: '/spending',
  path: '/spending',
  getParentRoute: () => dashboardChar43LayoutRoute,
} as any)
const dashboardChar43TVRoute = dashboardChar43TVRouteImport.update({
  id: '/tv',
  path: '/tv',
  getParentRoute: () => dashboardChar43LayoutRoute,
} as any)
const dashboardChar43tv2Route = dashboardChar43tv2RouteImport.update({
  id: '/tv2',
  path: '/tv2',
  getParentRoute: () => dashboardChar43LayoutRoute,
} as any)
const dashboardChar43UsageDashboardRoute =
  dashboardChar43UsageDashboardRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => dashboardChar43LayoutRoute,
  } as any)
const dashboardChar43utilisationRoute =
  dashboardChar43utilisationRouteImport.update({
    id: '/utilisation',
    path: '/utilisation',
    getParentRoute: () => dashboardChar43LayoutRoute,
  } as any)
const invitationActivateIndexRoute = invitationActivateIndexRouteImport.update({
  id: '/invitation/activate',
  path: '/invitation/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const policiesChar43eapSupplierRoute =
  policiesChar43eapSupplierRouteImport.update({
    id: '/policies/eap-supplier',
    path: '/policies/eap-supplier',
    getParentRoute: () => rootRouteImport,
  } as any)
const supplierChar43LayoutRoute = supplierChar43LayoutRouteImport.update({
  id: '/supplier/$supplierId',
  path: '/supplier/$supplierId',
  getParentRoute: () => rootRouteImport,
} as any)
const supporterChar43LayoutRoute = supporterChar43LayoutRouteImport.update({
  id: '/supporter/$supporterId',
  path: '/supporter/$supporterId',
  getParentRoute: () => rootRouteImport,
} as any)
const adminClaimsIndexRoute = adminClaimsIndexRouteImport.update({
  id: '/claims/',
  path: '/claims/',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminClaimsChar91claimIdChar93IndexRoute =
  adminClaimsChar91claimIdChar93IndexRouteImport.update({
    id: '/claims/$claimId',
    path: '/claims/$claimId',
    getParentRoute: () => adminChar43LayoutRoute,
  } as any)
const adminDevtoolsChar43DevToolsRoute =
  adminDevtoolsChar43DevToolsRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminDevtoolsChar43LayoutRoute,
  } as any)
const adminDevtoolsAirwallexIndexRoute =
  adminDevtoolsAirwallexIndexRouteImport.update({
    id: '/airwallex',
    path: '/airwallex',
    getParentRoute: () => adminDevtoolsChar43LayoutRoute,
  } as any)
const adminDevtoolsBillingSimIndexRoute =
  adminDevtoolsBillingSimIndexRouteImport.update({
    id: '/billing-sim',
    path: '/billing-sim',
    getParentRoute: () => adminDevtoolsChar43LayoutRoute,
  } as any)
const adminDevtoolsListingSelectorIndexRoute =
  adminDevtoolsListingSelectorIndexRouteImport.update({
    id: '/listing-selector',
    path: '/listing-selector',
    getParentRoute: () => adminDevtoolsChar43LayoutRoute,
  } as any)
const adminDevtoolsMemberLookupIndexRoute =
  adminDevtoolsMemberLookupIndexRouteImport.update({
    id: '/member-lookup',
    path: '/member-lookup',
    getParentRoute: () => adminDevtoolsChar43LayoutRoute,
  } as any)
const adminDevtoolsUiIndexRoute = adminDevtoolsUiIndexRouteImport.update({
  id: '/ui',
  path: '/ui',
  getParentRoute: () => adminDevtoolsChar43LayoutRoute,
} as any)
const adminLegalChar43LegalTermsListPageRoute =
  adminLegalChar43LegalTermsListPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminLegalIndexRoute,
  } as any)
const adminLegalChar91termsIdChar93IndexRoute =
  adminLegalChar91termsIdChar93IndexRouteImport.update({
    id: '/$termsId',
    path: '/$termsId',
    getParentRoute: () => adminLegalIndexRoute,
  } as any)
const adminLegalNewIndexRoute = adminLegalNewIndexRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => adminLegalIndexRoute,
} as any)
const adminListingReviewChar43ListingReviewOverviewPageRoute =
  adminListingReviewChar43ListingReviewOverviewPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminListingReviewIndexRoute,
  } as any)
const adminMembersChar43MembersPageRoute =
  adminMembersChar43MembersPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminMembersIndexRoute,
  } as any)
const adminMembersChar91memberIdChar93IndexRoute =
  adminMembersChar91memberIdChar93IndexRouteImport.update({
    id: '/$memberId',
    path: '/$memberId',
    getParentRoute: () => adminMembersIndexRoute,
  } as any)
const adminReportsIndexRoute = adminReportsIndexRouteImport.update({
  id: '/reports/$countryCode',
  path: '/reports/$countryCode',
  getParentRoute: () => adminChar43LayoutRoute,
} as any)
const adminResourcesChar43ResourcesPageRoute =
  adminResourcesChar43ResourcesPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminResourcesIndexRoute,
  } as any)
const adminResourcesChar91resourceIdChar93IndexRoute =
  adminResourcesChar91resourceIdChar93IndexRouteImport.update({
    id: '/$resourceId',
    path: '/$resourceId',
    getParentRoute: () => adminResourcesIndexRoute,
  } as any)
const adminSuppliersChar43SuppliersPageRoute =
  adminSuppliersChar43SuppliersPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminSuppliersIndexRoute,
  } as any)
const adminSuppliersChar91supplierIdChar93IndexRoute =
  adminSuppliersChar91supplierIdChar93IndexRouteImport.update({
    id: '/$supplierId',
    path: '/$supplierId',
    getParentRoute: () => adminSuppliersIndexRoute,
  } as any)
const adminSupportersChar43SupportersPageRoute =
  adminSupportersChar43SupportersPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminSupportersIndexRoute,
  } as any)
const adminSupportersChar91supporterIdChar93IndexRoute =
  adminSupportersChar91supporterIdChar93IndexRouteImport.update({
    id: '/$supporterId',
    path: '/$supporterId',
    getParentRoute: () => adminSupportersIndexRoute,
  } as any)
const campaignsSegmentsChar43SegmentsPageRoute =
  campaignsSegmentsChar43SegmentsPageRouteImport.update({
    id: '/segments/',
    path: '/segments/',
    getParentRoute: () => campaignsChar43LayoutRoute,
  } as any)
const campaignsSegmentsChar43SegmentEditorRoute =
  campaignsSegmentsChar43SegmentEditorRouteImport.update({
    id: '/segments/$segmentId',
    path: '/segments/$segmentId',
    getParentRoute: () => campaignsChar43LayoutRoute,
  } as any)
const campaignsSendsChar43SendsPageRoute =
  campaignsSendsChar43SendsPageRouteImport.update({
    id: '/sends/',
    path: '/sends/',
    getParentRoute: () => campaignsChar43LayoutRoute,
  } as any)
const campaignsSendsChar43SendDetailRoute =
  campaignsSendsChar43SendDetailRouteImport.update({
    id: '/sends/$sendId',
    path: '/sends/$sendId',
    getParentRoute: () => campaignsChar43LayoutRoute,
  } as any)
const campaignsSendsChar43CreateSendRoute =
  campaignsSendsChar43CreateSendRouteImport.update({
    id: '/sends/new',
    path: '/sends/new',
    getParentRoute: () => campaignsChar43LayoutRoute,
  } as any)
const campaignsTemplatesChar43TemplatesPageRoute =
  campaignsTemplatesChar43TemplatesPageRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => campaignsChar43LayoutRoute,
  } as any)
const campaignsTemplatesChar43TemplateEditorRoute =
  campaignsTemplatesChar43TemplateEditorRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => campaignsChar43LayoutRoute,
  } as any)
const campaignsSuppressionChar43UnsubscribedListRoute =
  campaignsSuppressionChar43UnsubscribedListRouteImport.update({
    id: '/unsubscribed/',
    path: '/unsubscribed/',
    getParentRoute: () => campaignsChar43LayoutRoute,
  } as any)
const supplierChar43SupplierHomeRoute =
  supplierChar43SupplierHomeRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supplierChar43LayoutRoute,
  } as any)
const supplierBookingsIndexRoute = supplierBookingsIndexRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => supplierChar43LayoutRoute,
} as any)
const supplierEapIndexRoute = supplierEapIndexRouteImport.update({
  id: '/eap',
  path: '/eap',
  getParentRoute: () => supplierChar43LayoutRoute,
} as any)
const supplierEapReviewChar43ReviewListRoute =
  supplierEapReviewChar43ReviewListRouteImport.update({
    id: '/eap-review',
    path: '/eap-review',
    getParentRoute: () => supplierChar43LayoutRoute,
  } as any)
const supplierListingsIndexRoute = supplierListingsIndexRouteImport.update({
  id: '/listings',
  path: '/listings',
  getParentRoute: () => supplierChar43LayoutRoute,
} as any)
const supplierMessagesIndexRoute = supplierMessagesIndexRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => supplierChar43LayoutRoute,
} as any)
const supplierOrdersIndexRoute = supplierOrdersIndexRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => supplierChar43LayoutRoute,
} as any)
const supplierPassesIndexRoute = supplierPassesIndexRouteImport.update({
  id: '/passes',
  path: '/passes',
  getParentRoute: () => supplierChar43LayoutRoute,
} as any)
const supplierPaymentsIndexRoute = supplierPaymentsIndexRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => supplierChar43LayoutRoute,
} as any)
const supplierSalesIndexRoute = supplierSalesIndexRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => supplierChar43LayoutRoute,
} as any)
const supplierSettingsIndexRoute = supplierSettingsIndexRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => supplierChar43LayoutRoute,
} as any)
const supplierSkuIndexRoute = supplierSkuIndexRouteImport.update({
  id: '/sku',
  path: '/sku',
  getParentRoute: () => supplierChar43LayoutRoute,
} as any)
const supplierSubscriptionsIndexRoute =
  supplierSubscriptionsIndexRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => supplierChar43LayoutRoute,
  } as any)
const supplierUserSettingsIndexRoute =
  supplierUserSettingsIndexRouteImport.update({
    id: '/user-settings',
    path: '/user-settings',
    getParentRoute: () => supplierChar43LayoutRoute,
  } as any)
const supporterChar43SupporterHomeRoute =
  supporterChar43SupporterHomeRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supporterChar43LayoutRoute,
  } as any)
const supporterAdminsIndexRoute = supporterAdminsIndexRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => supporterChar43LayoutRoute,
} as any)
const supporterAllowanceReportsChar43LayoutRoute =
  supporterAllowanceReportsChar43LayoutRouteImport.update({
    id: '/allowance-reports',
    path: '/allowance-reports',
    getParentRoute: () => supporterChar43LayoutRoute,
  } as any)
const supporterAllowancesIndexRoute =
  supporterAllowancesIndexRouteImport.update({
    id: '/allowances',
    path: '/allowances',
    getParentRoute: () => supporterChar43LayoutRoute,
  } as any)
const supporterEapIndexRoute = supporterEapIndexRouteImport.update({
  id: '/eap',
  path: '/eap',
  getParentRoute: () => supporterChar43LayoutRoute,
} as any)
const supporterFinancialReportsChar43reportsRoute =
  supporterFinancialReportsChar43reportsRouteImport.update({
    id: '/financial-reports',
    path: '/financial-reports',
    getParentRoute: () => supporterChar43LayoutRoute,
  } as any)
const supporterHistoryIndexRoute = supporterHistoryIndexRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => supporterChar43LayoutRoute,
} as any)
const supporterReportsIndexRoute = supporterReportsIndexRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => supporterChar43LayoutRoute,
} as any)
const supporterSettingsChar43routeRoute =
  supporterSettingsChar43routeRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => supporterChar43LayoutRoute,
  } as any)
const supporterTeamIndexRoute = supporterTeamIndexRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => supporterChar43LayoutRoute,
} as any)
const supporterUserSettingsIndexRoute =
  supporterUserSettingsIndexRouteImport.update({
    id: '/user-settings',
    path: '/user-settings',
    getParentRoute: () => supporterChar43LayoutRoute,
  } as any)
const adminListingReviewChar43ListingReviewPageRoute =
  adminListingReviewChar43ListingReviewPageRouteImport.update({
    id: '/$listingId/$version',
    path: '/$listingId/$version',
    getParentRoute: () => adminListingReviewIndexRoute,
  } as any)
const adminMembersChar91memberIdChar93NewClaimIndexRoute =
  adminMembersChar91memberIdChar93NewClaimIndexRouteImport.update({
    id: '/members/$memberId/new-claim',
    path: '/members/$memberId/new-claim',
    getParentRoute: () => adminChar43LayoutRoute,
  } as any)
const adminMembersChar91memberIdChar93NewPurchaseIndexRoute =
  adminMembersChar91memberIdChar93NewPurchaseIndexRouteImport.update({
    id: '/members/$memberId/new-purchase',
    path: '/members/$memberId/new-purchase',
    getParentRoute: () => adminChar43LayoutRoute,
  } as any)
const adminMembersChar91memberIdChar93TransactionsIndexRoute =
  adminMembersChar91memberIdChar93TransactionsIndexRouteImport.update({
    id: '/members/$memberId/transactions',
    path: '/members/$memberId/transactions',
    getParentRoute: () => adminChar43LayoutRoute,
  } as any)
const adminReportsChar43cardPaymentsRoute =
  adminReportsChar43cardPaymentsRouteImport.update({
    id: '/card-payments',
    path: '/card-payments',
    getParentRoute: () => adminReportsIndexRoute,
  } as any)
const adminReportsChar43CurrentSupportersReportPageRoute =
  adminReportsChar43CurrentSupportersReportPageRouteImport.update({
    id: '/current-supporters',
    path: '/current-supporters',
    getParentRoute: () => adminReportsIndexRoute,
  } as any)
const adminReportsDailyPayoutsChar43layoutRoute =
  adminReportsDailyPayoutsChar43layoutRouteImport.update({
    id: '/daily-payouts',
    path: '/daily-payouts',
    getParentRoute: () => adminReportsIndexRoute,
  } as any)
const adminReportsEapChar43SupporterEapArrearsPageRoute =
  adminReportsEapChar43SupporterEapArrearsPageRouteImport.update({
    id: '/eap-arrears',
    path: '/eap-arrears',
    getParentRoute: () => adminReportsIndexRoute,
  } as any)
const adminReportsEapChar43EapListingQuailityReviewRoute =
  adminReportsEapChar43EapListingQuailityReviewRouteImport.update({
    id: '/eap-quality',
    path: '/eap-quality',
    getParentRoute: () => adminReportsIndexRoute,
  } as any)
const adminReportsEapChar43EapSessionRequestsPageRoute =
  adminReportsEapChar43EapSessionRequestsPageRouteImport.update({
    id: '/eap-requests',
    path: '/eap-requests',
    getParentRoute: () => adminReportsIndexRoute,
  } as any)
const adminReportsEapChar43EapUnclosedSessionsPageRoute =
  adminReportsEapChar43EapUnclosedSessionsPageRouteImport.update({
    id: '/eap-unclosed-sessions',
    path: '/eap-unclosed-sessions',
    getParentRoute: () => adminReportsIndexRoute,
  } as any)
const adminReportsChar43MemberSubscriptionsReportPageRoute =
  adminReportsChar43MemberSubscriptionsReportPageRouteImport.update({
    id: '/member-subscriptions',
    path: '/member-subscriptions',
    getParentRoute: () => adminReportsIndexRoute,
  } as any)
const adminReportsChar43projectedMrrRoute =
  adminReportsChar43projectedMrrRouteImport.update({
    id: '/projected-mrr',
    path: '/projected-mrr',
    getParentRoute: () => adminReportsIndexRoute,
  } as any)
const adminReportsChar43SupporterMonthlyStatsReportPageRoute =
  adminReportsChar43SupporterMonthlyStatsReportPageRouteImport.update({
    id: '/supporter',
    path: '/supporter',
    getParentRoute: () => adminReportsIndexRoute,
  } as any)
const adminReportsChar43SupporterSalesReportPageRoute =
  adminReportsChar43SupporterSalesReportPageRouteImport.update({
    id: '/supporter-sales',
    path: '/supporter-sales',
    getParentRoute: () => adminReportsIndexRoute,
  } as any)
const adminSuppliersChar91supplierIdChar93Char43SupplierPageRoute =
  adminSuppliersChar91supplierIdChar93Char43SupplierPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminSuppliersChar91supplierIdChar93IndexRoute,
  } as any)
const adminSuppliersChar91supplierIdChar93CalendarsIndexRoute =
  adminSuppliersChar91supplierIdChar93CalendarsIndexRouteImport.update({
    id: '/calendars',
    path: '/calendars',
    getParentRoute: () => adminSuppliersChar91supplierIdChar93IndexRoute,
  } as any)
const adminSuppliersChar91supplierIdChar93LocationsIndexRoute =
  adminSuppliersChar91supplierIdChar93LocationsIndexRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => adminSuppliersChar91supplierIdChar93IndexRoute,
  } as any)
const adminSuppliersChar91supplierIdChar93SettingsIndexRoute =
  adminSuppliersChar91supplierIdChar93SettingsIndexRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => adminSuppliersChar91supplierIdChar93IndexRoute,
  } as any)
const adminSupportersChar91supporterIdChar93Char43SupporterPageRoute =
  adminSupportersChar91supporterIdChar93Char43SupporterPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminSupportersChar91supporterIdChar93IndexRoute,
  } as any)
const adminSupportersChar91supporterIdChar93Char43BillingPageRoute =
  adminSupportersChar91supporterIdChar93Char43BillingPageRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => adminSupportersChar91supporterIdChar93IndexRoute,
  } as any)
const adminSupportersChar91supporterIdChar93Char43EAPPageRoute =
  adminSupportersChar91supporterIdChar93Char43EAPPageRouteImport.update({
    id: '/eap',
    path: '/eap',
    getParentRoute: () => adminSupportersChar91supporterIdChar93IndexRoute,
  } as any)
const adminSupportersChar91supporterIdChar93Char43NotePageRoute =
  adminSupportersChar91supporterIdChar93Char43NotePageRouteImport.update({
    id: '/note',
    path: '/note',
    getParentRoute: () => adminSupportersChar91supporterIdChar93IndexRoute,
  } as any)
const adminSupportersChar91supporterIdChar93Char43SettingsPageRoute =
  adminSupportersChar91supporterIdChar93Char43SettingsPageRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => adminSupportersChar91supporterIdChar93IndexRoute,
  } as any)
const supplierEapReviewIndexRoute = supplierEapReviewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => supplierEapReviewChar43ReviewListRoute,
} as any)
const supplierEapReviewChar91purchaseIdChar93IndexRoute =
  supplierEapReviewChar91purchaseIdChar93IndexRouteImport.update({
    id: '/$purchaseId',
    path: '/$purchaseId',
    getParentRoute: () => supplierEapReviewChar43ReviewListRoute,
  } as any)
const supplierEapChar43EAPListRoute =
  supplierEapChar43EAPListRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supplierEapIndexRoute,
  } as any)
const supplierEapNewIndexRoute = supplierEapNewIndexRouteImport.update({
  id: '/supplier/$supplierId/eap/new',
  path: '/supplier/$supplierId/eap/new',
  getParentRoute: () => rootRouteImport,
} as any)
const supplierListingsChar43ListingsPageRoute =
  supplierListingsChar43ListingsPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supplierListingsIndexRoute,
  } as any)
const supplierListingsNewIndexRoute =
  supplierListingsNewIndexRouteImport.update({
    id: '/supplier/$supplierId/listings/new',
    path: '/supplier/$supplierId/listings/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const supplierMessagesChar43MessagesRoute =
  supplierMessagesChar43MessagesRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supplierMessagesIndexRoute,
  } as any)
const supplierMessagesChar91conversationIdChar93IndexRoute =
  supplierMessagesChar91conversationIdChar93IndexRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => supplierMessagesIndexRoute,
  } as any)
const supplierSalesChar43SupplierSalesRoute =
  supplierSalesChar43SupplierSalesRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supplierSalesIndexRoute,
  } as any)
const supplierSalesChar91purchaseIdChar93IndexRoute =
  supplierSalesChar91purchaseIdChar93IndexRouteImport.update({
    id: '/$purchaseId',
    path: '/$purchaseId',
    getParentRoute: () => supplierSalesIndexRoute,
  } as any)
const supplierSettingsProfileIndexRoute =
  supplierSettingsProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supplierSettingsIndexRoute,
  } as any)
const supplierSettingsAutomationsIndexRoute =
  supplierSettingsAutomationsIndexRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => supplierSettingsIndexRoute,
  } as any)
const supplierSettingsBusinessIndexRoute =
  supplierSettingsBusinessIndexRouteImport.update({
    id: '/business',
    path: '/business',
    getParentRoute: () => supplierSettingsIndexRoute,
  } as any)
const supplierSettingsCalendarsIndexRoute =
  supplierSettingsCalendarsIndexRouteImport.update({
    id: '/calendars',
    path: '/calendars',
    getParentRoute: () => supplierSettingsIndexRoute,
  } as any)
const supplierSettingsGivenwellTermsIndexRoute =
  supplierSettingsGivenwellTermsIndexRouteImport.update({
    id: '/givenwell-terms',
    path: '/givenwell-terms',
    getParentRoute: () => supplierSettingsIndexRoute,
  } as any)
const supplierSettingsLegalIndexRoute =
  supplierSettingsLegalIndexRouteImport.update({
    id: '/legal',
    path: '/legal',
    getParentRoute: () => supplierSettingsIndexRoute,
  } as any)
const supplierSettingsLocationsIndexRoute =
  supplierSettingsLocationsIndexRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => supplierSettingsIndexRoute,
  } as any)
const supplierSettingsMarketsIndexRoute =
  supplierSettingsMarketsIndexRouteImport.update({
    id: '/markets',
    path: '/markets',
    getParentRoute: () => supplierSettingsIndexRoute,
  } as any)
const supplierSettingsPaymentIndexRoute =
  supplierSettingsPaymentIndexRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => supplierSettingsIndexRoute,
  } as any)
const supplierSettingsRefundIndexRoute =
  supplierSettingsRefundIndexRouteImport.update({
    id: '/refunds',
    path: '/refunds',
    getParentRoute: () => supplierSettingsIndexRoute,
  } as any)
const supplierSettingsTeamIndexRoute =
  supplierSettingsTeamIndexRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => supplierSettingsIndexRoute,
  } as any)
const supporterAdminsChar91userIdChar93IndexRoute =
  supporterAdminsChar91userIdChar93IndexRouteImport.update({
    id: '/admins/$userId',
    path: '/admins/$userId',
    getParentRoute: () => supporterChar43LayoutRoute,
  } as any)
const supporterAllowanceReportsChar43indexRoute =
  supporterAllowanceReportsChar43indexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supporterAllowanceReportsChar43LayoutRoute,
  } as any)
const supporterAllowanceReportsForecastIndexRoute =
  supporterAllowanceReportsForecastIndexRouteImport.update({
    id: '/forecast',
    path: '/forecast',
    getParentRoute: () => supporterAllowanceReportsChar43LayoutRoute,
  } as any)
const supporterAllowanceReportsInsightsIndexRoute =
  supporterAllowanceReportsInsightsIndexRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => supporterAllowanceReportsChar43LayoutRoute,
  } as any)
const supporterAllowanceReportsSpendIndexRoute =
  supporterAllowanceReportsSpendIndexRouteImport.update({
    id: '/spend',
    path: '/spend',
    getParentRoute: () => supporterAllowanceReportsChar43LayoutRoute,
  } as any)
const supporterAllowanceReportsUtilisationIndexRoute =
  supporterAllowanceReportsUtilisationIndexRouteImport.update({
    id: '/utilisation',
    path: '/utilisation',
    getParentRoute: () => supporterAllowanceReportsChar43LayoutRoute,
  } as any)
const supporterEapChar43EAPRoute = supporterEapChar43EAPRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => supporterEapIndexRoute,
} as any)
const supporterEapSettingsIndexRoute =
  supporterEapSettingsIndexRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => supporterEapIndexRoute,
  } as any)
const supporterFinancialReportsChar43indexRoute =
  supporterFinancialReportsChar43indexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supporterFinancialReportsChar43reportsRoute,
  } as any)
const supporterFinancialReportsInvoicesIndexRoute =
  supporterFinancialReportsInvoicesIndexRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => supporterFinancialReportsChar43reportsRoute,
  } as any)
const supporterFinancialReportsTransactionsIndexRoute =
  supporterFinancialReportsTransactionsIndexRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => supporterFinancialReportsChar43reportsRoute,
  } as any)
const supporterSettingsChar43indexRoute =
  supporterSettingsChar43indexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supporterSettingsChar43routeRoute,
  } as any)
const supporterSettingsBillingIndexRoute =
  supporterSettingsBillingIndexRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => supporterSettingsChar43routeRoute,
  } as any)
const supporterSettingsCountriesIndexRoute =
  supporterSettingsCountriesIndexRouteImport.update({
    id: '/countries',
    path: '/countries',
    getParentRoute: () => supporterSettingsChar43routeRoute,
  } as any)
const supporterSettingsGivenwellTermsIndexRoute =
  supporterSettingsGivenwellTermsIndexRouteImport.update({
    id: '/givenwell-terms',
    path: '/givenwell-terms',
    getParentRoute: () => supporterSettingsChar43routeRoute,
  } as any)
const adminReportsDailyPayoutsChar43DailyPayoutsRoute =
  adminReportsDailyPayoutsChar43DailyPayoutsRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminReportsDailyPayoutsChar43layoutRoute,
  } as any)
const adminReportsDailyPayoutsChar43DailyPayoutsDetailRoute =
  adminReportsDailyPayoutsChar43DailyPayoutsDetailRouteImport.update({
    id: '/detail',
    path: '/detail',
    getParentRoute: () => adminReportsDailyPayoutsChar43layoutRoute,
  } as any)
const supplierEapChar91listingIdChar93Char43pageRoute =
  supplierEapChar91listingIdChar93Char43pageRouteImport.update({
    id: '/$listingId/$version',
    path: '/$listingId/$version',
    getParentRoute: () => supplierEapIndexRoute,
  } as any)
const supplierListingsChar91listingIdChar93Char43EditListingPageRoute =
  supplierListingsChar91listingIdChar93Char43EditListingPageRouteImport.update({
    id: '/$listingId/$version',
    path: '/$listingId/$version',
    getParentRoute: () => supplierListingsIndexRoute,
  } as any)
const supplierSettingsCalendarsChar43CalendarSettingsRoute =
  supplierSettingsCalendarsChar43CalendarSettingsRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supplierSettingsCalendarsIndexRoute,
  } as any)
const supplierSettingsCalendarsChar91calendarIdChar93IndexRoute =
  supplierSettingsCalendarsChar91calendarIdChar93IndexRouteImport.update({
    id: '/$calendarId',
    path: '/$calendarId',
    getParentRoute: () => supplierSettingsCalendarsIndexRoute,
  } as any)
const supplierSettingsRefundChar43RefundSettingsRoute =
  supplierSettingsRefundChar43RefundSettingsRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supplierSettingsRefundIndexRoute,
  } as any)
const supplierSettingsTeamChar43TeamTableRoute =
  supplierSettingsTeamChar43TeamTableRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supplierSettingsTeamIndexRoute,
  } as any)
const supporterEapRequestsIndexRoute =
  supporterEapRequestsIndexRouteImport.update({
    id: '/requests/',
    path: '/requests/',
    getParentRoute: () => supporterEapIndexRoute,
  } as any)
const supporterEapRequestsChar91requestIdChar93IndexRoute =
  supporterEapRequestsChar91requestIdChar93IndexRouteImport.update({
    id: '/requests/$requestId',
    path: '/requests/$requestId',
    getParentRoute: () => supporterEapIndexRoute,
  } as any)
const supporterFinancialReportsTransactionsChar43WalletRoute =
  supporterFinancialReportsTransactionsChar43WalletRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => supporterFinancialReportsTransactionsIndexRoute,
  } as any)
const supplierListingsChar91listingIdChar93Char43indexRoute =
  supplierListingsChar91listingIdChar93Char43indexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      supplierListingsChar91listingIdChar93Char43EditListingPageRoute,
  } as any)
const supplierListingsChar91listingIdChar93Char43variantsRoute =
  supplierListingsChar91listingIdChar93Char43variantsRouteImport.update({
    id: '/variants',
    path: '/variants',
    getParentRoute: () =>
      supplierListingsChar91listingIdChar93Char43EditListingPageRoute,
  } as any)
const supplierSettingsCalendarsChar91calendarIdChar93Char43EditCalendarSettingsRoute =
  supplierSettingsCalendarsChar91calendarIdChar93Char43EditCalendarSettingsRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        supplierSettingsCalendarsChar91calendarIdChar93IndexRoute,
    } as any,
  )
const supplierSettingsCalendarsChar91calendarIdChar93ConnectIndexRoute =
  supplierSettingsCalendarsChar91calendarIdChar93ConnectIndexRouteImport.update(
    {
      id: '/connect',
      path: '/connect',
      getParentRoute: () =>
        supplierSettingsCalendarsChar91calendarIdChar93IndexRoute,
    } as any,
  )
const supplierSettingsCalendarsChar91calendarIdChar93DisconnectIndexRoute =
  supplierSettingsCalendarsChar91calendarIdChar93DisconnectIndexRouteImport.update(
    {
      id: '/disconnect',
      path: '/disconnect',
      getParentRoute: () =>
        supplierSettingsCalendarsChar91calendarIdChar93IndexRoute,
    } as any,
  )
const supplierSettingsCalendarsChar91calendarIdChar93ExternalIndexRoute =
  supplierSettingsCalendarsChar91calendarIdChar93ExternalIndexRouteImport.update(
    {
      id: '/external',
      path: '/external',
      getParentRoute: () =>
        supplierSettingsCalendarsChar91calendarIdChar93IndexRoute,
    } as any,
  )
const supplierSettingsRefundCancellationPolicyChar91policyIdChar93IndexRoute =
  supplierSettingsRefundCancellationPolicyChar91policyIdChar93IndexRouteImport.update(
    {
      id: '/cancellation-policy/$policyId',
      path: '/cancellation-policy/$policyId',
      getParentRoute: () => supplierSettingsRefundIndexRoute,
    } as any,
  )
const supporterFinancialReportsTransactionsAllowanceChar91batchIdChar93IndexRoute =
  supporterFinancialReportsTransactionsAllowanceChar91batchIdChar93IndexRouteImport.update(
    {
      id: '/allowance/$batchId',
      path: '/allowance/$batchId',
      getParentRoute: () => supporterFinancialReportsTransactionsIndexRoute,
    } as any,
  )
const supporterFinancialReportsTransactionsDetailsChar91versionChar93IndexRoute =
  supporterFinancialReportsTransactionsDetailsChar91versionChar93IndexRouteImport.update(
    {
      id: '/details/$version',
      path: '/details/$version',
      getParentRoute: () => supporterFinancialReportsTransactionsIndexRoute,
    } as any,
  )
const supplierListingsChar91listingIdChar93Char43variantRoute =
  supplierListingsChar91listingIdChar93Char43variantRouteImport.update({
    id: '/$variantId',
    path: '/$variantId',
    getParentRoute: () =>
      supplierListingsChar91listingIdChar93Char43variantsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof Char43HomeRoute
  '/admin': typeof adminChar43LayoutRouteWithChildren
  '/campaigns': typeof campaignsChar43LayoutRouteWithChildren
  '/dashboard': typeof dashboardChar43LayoutRouteWithChildren
  '/demo': typeof demoChar43routeRoute
  '/forgot-password': typeof forgotPasswordIndexRoute
  '/new-account': typeof newAccountIndexRoute
  '/new-supplier': typeof newSupplierIndexRoute
  '/sign-in': typeof signInIndexRoute
  '/admin/': typeof adminChar43AdminHomeRoute
  '/campaigns/': typeof campaignsChar43CampaignsOverviewRoute
  '/dashboard/': typeof dashboardChar43DashboardRoute
  '/admin/devtools': typeof adminDevtoolsChar43LayoutRouteWithChildren
  '/admin/expiry': typeof adminChar43expiryRoute
  '/admin/staff': typeof adminStaffChar43routeRoute
  '/dashboard/cash-flow': typeof dashboardChar43cashFlowRoute
  '/dashboard/costs': typeof dashboardChar43CostsDashboardRoute
  '/dashboard/coverage': typeof dashboardCoverageChar43CoverageDashboardRoute
  '/dashboard/eap-utilisation': typeof dashboardChar43eapUtilisationRoute
  '/dashboard/listing-prices': typeof dashboardChar43listingPricesRoute
  '/dashboard/mrr': typeof dashboardChar43MRRRoute
  '/dashboard/spending': typeof dashboardChar43spendingRoute
  '/dashboard/tv': typeof dashboardChar43TVRoute
  '/dashboard/tv2': typeof dashboardChar43tv2Route
  '/dashboard/usage': typeof dashboardChar43UsageDashboardRoute
  '/dashboard/utilisation': typeof dashboardChar43utilisationRoute
  '/policies/eap-supplier': typeof policiesChar43eapSupplierRoute
  '/supplier/$supplierId': typeof supplierChar43LayoutRouteWithChildren
  '/supporter/$supporterId': typeof supporterChar43LayoutRouteWithChildren
  '/admin/account-owners': typeof adminAccountOwnersIndexRoute
  '/admin/categories': typeof adminCategoriesIndexRoute
  '/admin/countries': typeof adminCountriesIndexRoute
  '/admin/legal': typeof adminLegalIndexRouteWithChildren
  '/admin/listing-review': typeof adminListingReviewIndexRouteWithChildren
  '/admin/members': typeof adminMembersIndexRouteWithChildren
  '/admin/resource-categories': typeof adminResourceCategoriesIndexRoute
  '/admin/resources': typeof adminResourcesIndexRouteWithChildren
  '/admin/suppliers': typeof adminSuppliersIndexRouteWithChildren
  '/admin/supporters': typeof adminSupportersIndexRouteWithChildren
  '/admin/surpluses': typeof adminSurplusesIndexRoute
  '/admin/themes': typeof adminThemesIndexRoute
  '/admin/user-settings': typeof adminUserSettingsIndexRoute
  '/invitation/activate': typeof invitationActivateIndexRoute
  '/admin/devtools/': typeof adminDevtoolsChar43DevToolsRoute
  '/admin/legal/': typeof adminLegalChar43LegalTermsListPageRoute
  '/admin/listing-review/': typeof adminListingReviewChar43ListingReviewOverviewPageRoute
  '/admin/members/': typeof adminMembersChar43MembersPageRoute
  '/admin/resources/': typeof adminResourcesChar43ResourcesPageRoute
  '/admin/suppliers/': typeof adminSuppliersChar43SuppliersPageRoute
  '/admin/supporters/': typeof adminSupportersChar43SupportersPageRoute
  '/campaigns/segments/': typeof campaignsSegmentsChar43SegmentsPageRoute
  '/campaigns/sends/': typeof campaignsSendsChar43SendsPageRoute
  '/campaigns/templates/': typeof campaignsTemplatesChar43TemplatesPageRoute
  '/campaigns/unsubscribed/': typeof campaignsSuppressionChar43UnsubscribedListRoute
  '/supplier/$supplierId/': typeof supplierChar43SupplierHomeRoute
  '/supporter/$supporterId/': typeof supporterChar43SupporterHomeRoute
  '/campaigns/segments/$segmentId': typeof campaignsSegmentsChar43SegmentEditorRoute
  '/campaigns/sends/$sendId': typeof campaignsSendsChar43SendDetailRoute
  '/campaigns/sends/new': typeof campaignsSendsChar43CreateSendRoute
  '/campaigns/templates/$templateId': typeof campaignsTemplatesChar43TemplateEditorRoute
  '/supplier/$supplierId/eap-review': typeof supplierEapReviewChar43ReviewListRouteWithChildren
  '/supporter/$supporterId/allowance-reports': typeof supporterAllowanceReportsChar43LayoutRouteWithChildren
  '/supporter/$supporterId/financial-reports': typeof supporterFinancialReportsChar43reportsRouteWithChildren
  '/supporter/$supporterId/settings': typeof supporterSettingsChar43routeRouteWithChildren
  '/admin/claims/': typeof adminClaimsIndexRoute
  '/admin/claims/$claimId': typeof adminClaimsChar91claimIdChar93IndexRoute
  '/admin/devtools/airwallex': typeof adminDevtoolsAirwallexIndexRoute
  '/admin/devtools/billing-sim': typeof adminDevtoolsBillingSimIndexRoute
  '/admin/devtools/listing-selector': typeof adminDevtoolsListingSelectorIndexRoute
  '/admin/devtools/member-lookup': typeof adminDevtoolsMemberLookupIndexRoute
  '/admin/devtools/ui': typeof adminDevtoolsUiIndexRoute
  '/admin/legal/$termsId': typeof adminLegalChar91termsIdChar93IndexRoute
  '/admin/legal/new': typeof adminLegalNewIndexRoute
  '/admin/members/$memberId': typeof adminMembersChar91memberIdChar93IndexRoute
  '/admin/reports/$countryCode': typeof adminReportsIndexRouteWithChildren
  '/admin/resources/$resourceId': typeof adminResourcesChar91resourceIdChar93IndexRoute
  '/admin/suppliers/$supplierId': typeof adminSuppliersChar91supplierIdChar93IndexRouteWithChildren
  '/admin/supporters/$supporterId': typeof adminSupportersChar91supporterIdChar93IndexRouteWithChildren
  '/supplier/$supplierId/bookings': typeof supplierBookingsIndexRoute
  '/supplier/$supplierId/eap': typeof supplierEapIndexRouteWithChildren
  '/supplier/$supplierId/listings': typeof supplierListingsIndexRouteWithChildren
  '/supplier/$supplierId/messages': typeof supplierMessagesIndexRouteWithChildren
  '/supplier/$supplierId/orders': typeof supplierOrdersIndexRoute
  '/supplier/$supplierId/passes': typeof supplierPassesIndexRoute
  '/supplier/$supplierId/payments': typeof supplierPaymentsIndexRoute
  '/supplier/$supplierId/sales': typeof supplierSalesIndexRouteWithChildren
  '/supplier/$supplierId/settings': typeof supplierSettingsIndexRouteWithChildren
  '/supplier/$supplierId/sku': typeof supplierSkuIndexRoute
  '/supplier/$supplierId/subscriptions': typeof supplierSubscriptionsIndexRoute
  '/supplier/$supplierId/user-settings': typeof supplierUserSettingsIndexRoute
  '/supporter/$supporterId/admins': typeof supporterAdminsIndexRoute
  '/supporter/$supporterId/allowances': typeof supporterAllowancesIndexRoute
  '/supporter/$supporterId/eap': typeof supporterEapIndexRouteWithChildren
  '/supporter/$supporterId/history': typeof supporterHistoryIndexRoute
  '/supporter/$supporterId/reports': typeof supporterReportsIndexRoute
  '/supporter/$supporterId/team': typeof supporterTeamIndexRoute
  '/supporter/$supporterId/user-settings': typeof supporterUserSettingsIndexRoute
  '/admin/suppliers/$supplierId/': typeof adminSuppliersChar91supplierIdChar93Char43SupplierPageRoute
  '/admin/supporters/$supporterId/': typeof adminSupportersChar91supporterIdChar93Char43SupporterPageRoute
  '/supplier/$supplierId/eap/': typeof supplierEapChar43EAPListRoute
  '/supplier/$supplierId/listings/': typeof supplierListingsChar43ListingsPageRoute
  '/supplier/$supplierId/messages/': typeof supplierMessagesChar43MessagesRoute
  '/supplier/$supplierId/sales/': typeof supplierSalesChar43SupplierSalesRoute
  '/supporter/$supporterId/allowance-reports/': typeof supporterAllowanceReportsChar43indexRoute
  '/supporter/$supporterId/eap/': typeof supporterEapChar43EAPRoute
  '/supporter/$supporterId/financial-reports/': typeof supporterFinancialReportsChar43indexRoute
  '/supporter/$supporterId/settings/': typeof supporterSettingsChar43indexRoute
  '/admin/listing-review/$listingId/$version': typeof adminListingReviewChar43ListingReviewPageRoute
  '/admin/reports/$countryCode/card-payments': typeof adminReportsChar43cardPaymentsRoute
  '/admin/reports/$countryCode/current-supporters': typeof adminReportsChar43CurrentSupportersReportPageRoute
  '/admin/reports/$countryCode/daily-payouts': typeof adminReportsDailyPayoutsChar43layoutRouteWithChildren
  '/admin/reports/$countryCode/eap-arrears': typeof adminReportsEapChar43SupporterEapArrearsPageRoute
  '/admin/reports/$countryCode/eap-quality': typeof adminReportsEapChar43EapListingQuailityReviewRoute
  '/admin/reports/$countryCode/eap-requests': typeof adminReportsEapChar43EapSessionRequestsPageRoute
  '/admin/reports/$countryCode/eap-unclosed-sessions': typeof adminReportsEapChar43EapUnclosedSessionsPageRoute
  '/admin/reports/$countryCode/member-subscriptions': typeof adminReportsChar43MemberSubscriptionsReportPageRoute
  '/admin/reports/$countryCode/projected-mrr': typeof adminReportsChar43projectedMrrRoute
  '/admin/reports/$countryCode/supporter': typeof adminReportsChar43SupporterMonthlyStatsReportPageRoute
  '/admin/reports/$countryCode/supporter-sales': typeof adminReportsChar43SupporterSalesReportPageRoute
  '/admin/supporters/$supporterId/billing': typeof adminSupportersChar91supporterIdChar93Char43BillingPageRoute
  '/admin/supporters/$supporterId/eap': typeof adminSupportersChar91supporterIdChar93Char43EAPPageRoute
  '/admin/supporters/$supporterId/note': typeof adminSupportersChar91supporterIdChar93Char43NotePageRoute
  '/admin/supporters/$supporterId/settings': typeof adminSupportersChar91supporterIdChar93Char43SettingsPageRoute
  '/supplier/$supplierId/eap-review/': typeof supplierEapReviewIndexRoute
  '/supplier/$supplierId/settings/': typeof supplierSettingsProfileIndexRoute
  '/admin/members/$memberId/new-claim': typeof adminMembersChar91memberIdChar93NewClaimIndexRoute
  '/admin/members/$memberId/new-purchase': typeof adminMembersChar91memberIdChar93NewPurchaseIndexRoute
  '/admin/members/$memberId/transactions': typeof adminMembersChar91memberIdChar93TransactionsIndexRoute
  '/admin/suppliers/$supplierId/calendars': typeof adminSuppliersChar91supplierIdChar93CalendarsIndexRoute
  '/admin/suppliers/$supplierId/locations': typeof adminSuppliersChar91supplierIdChar93LocationsIndexRoute
  '/admin/suppliers/$supplierId/settings': typeof adminSuppliersChar91supplierIdChar93SettingsIndexRoute
  '/supplier/$supplierId/eap-review/$purchaseId': typeof supplierEapReviewChar91purchaseIdChar93IndexRoute
  '/supplier/$supplierId/eap/new': typeof supplierEapNewIndexRoute
  '/supplier/$supplierId/listings/new': typeof supplierListingsNewIndexRoute
  '/supplier/$supplierId/messages/$conversationId': typeof supplierMessagesChar91conversationIdChar93IndexRoute
  '/supplier/$supplierId/sales/$purchaseId': typeof supplierSalesChar91purchaseIdChar93IndexRoute
  '/supplier/$supplierId/settings/automations': typeof supplierSettingsAutomationsIndexRoute
  '/supplier/$supplierId/settings/business': typeof supplierSettingsBusinessIndexRoute
  '/supplier/$supplierId/settings/calendars': typeof supplierSettingsCalendarsIndexRouteWithChildren
  '/supplier/$supplierId/settings/givenwell-terms': typeof supplierSettingsGivenwellTermsIndexRoute
  '/supplier/$supplierId/settings/legal': typeof supplierSettingsLegalIndexRoute
  '/supplier/$supplierId/settings/locations': typeof supplierSettingsLocationsIndexRoute
  '/supplier/$supplierId/settings/markets': typeof supplierSettingsMarketsIndexRoute
  '/supplier/$supplierId/settings/payment': typeof supplierSettingsPaymentIndexRoute
  '/supplier/$supplierId/settings/refunds': typeof supplierSettingsRefundIndexRouteWithChildren
  '/supplier/$supplierId/settings/team': typeof supplierSettingsTeamIndexRouteWithChildren
  '/supporter/$supporterId/admins/$userId': typeof supporterAdminsChar91userIdChar93IndexRoute
  '/supporter/$supporterId/allowance-reports/forecast': typeof supporterAllowanceReportsForecastIndexRoute
  '/supporter/$supporterId/allowance-reports/insights': typeof supporterAllowanceReportsInsightsIndexRoute
  '/supporter/$supporterId/allowance-reports/spend': typeof supporterAllowanceReportsSpendIndexRoute
  '/supporter/$supporterId/allowance-reports/utilisation': typeof supporterAllowanceReportsUtilisationIndexRoute
  '/supporter/$supporterId/eap/settings': typeof supporterEapSettingsIndexRoute
  '/supporter/$supporterId/financial-reports/invoices': typeof supporterFinancialReportsInvoicesIndexRoute
  '/supporter/$supporterId/financial-reports/transactions': typeof supporterFinancialReportsTransactionsIndexRouteWithChildren
  '/supporter/$supporterId/settings/billing': typeof supporterSettingsBillingIndexRoute
  '/supporter/$supporterId/settings/countries': typeof supporterSettingsCountriesIndexRoute
  '/supporter/$supporterId/settings/givenwell-terms': typeof supporterSettingsGivenwellTermsIndexRoute
  '/admin/reports/$countryCode/daily-payouts/': typeof adminReportsDailyPayoutsChar43DailyPayoutsRoute
  '/supplier/$supplierId/settings/calendars/': typeof supplierSettingsCalendarsChar43CalendarSettingsRoute
  '/supplier/$supplierId/settings/refunds/': typeof supplierSettingsRefundChar43RefundSettingsRoute
  '/supplier/$supplierId/settings/team/': typeof supplierSettingsTeamChar43TeamTableRoute
  '/supporter/$supporterId/financial-reports/transactions/': typeof supporterFinancialReportsTransactionsChar43WalletRoute
  '/admin/reports/$countryCode/daily-payouts/detail': typeof adminReportsDailyPayoutsChar43DailyPayoutsDetailRoute
  '/supplier/$supplierId/eap/$listingId/$version': typeof supplierEapChar91listingIdChar93Char43pageRoute
  '/supplier/$supplierId/listings/$listingId/$version': typeof supplierListingsChar91listingIdChar93Char43EditListingPageRouteWithChildren
  '/supporter/$supporterId/eap/requests/': typeof supporterEapRequestsIndexRoute
  '/supplier/$supplierId/settings/calendars/$calendarId': typeof supplierSettingsCalendarsChar91calendarIdChar93IndexRouteWithChildren
  '/supporter/$supporterId/eap/requests/$requestId': typeof supporterEapRequestsChar91requestIdChar93IndexRoute
  '/supplier/$supplierId/listings/$listingId/$version/': typeof supplierListingsChar91listingIdChar93Char43indexRoute
  '/supplier/$supplierId/settings/calendars/$calendarId/': typeof supplierSettingsCalendarsChar91calendarIdChar93Char43EditCalendarSettingsRoute
  '/supplier/$supplierId/listings/$listingId/$version/variants': typeof supplierListingsChar91listingIdChar93Char43variantsRouteWithChildren
  '/supplier/$supplierId/settings/calendars/$calendarId/connect': typeof supplierSettingsCalendarsChar91calendarIdChar93ConnectIndexRoute
  '/supplier/$supplierId/settings/calendars/$calendarId/disconnect': typeof supplierSettingsCalendarsChar91calendarIdChar93DisconnectIndexRoute
  '/supplier/$supplierId/settings/calendars/$calendarId/external': typeof supplierSettingsCalendarsChar91calendarIdChar93ExternalIndexRoute
  '/supplier/$supplierId/settings/refunds/cancellation-policy/$policyId': typeof supplierSettingsRefundCancellationPolicyChar91policyIdChar93IndexRoute
  '/supporter/$supporterId/financial-reports/transactions/allowance/$batchId': typeof supporterFinancialReportsTransactionsAllowanceChar91batchIdChar93IndexRoute
  '/supporter/$supporterId/financial-reports/transactions/details/$version': typeof supporterFinancialReportsTransactionsDetailsChar91versionChar93IndexRoute
  '/supplier/$supplierId/listings/$listingId/$version/variants/$variantId': typeof supplierListingsChar91listingIdChar93Char43variantRoute
}
export interface FileRoutesByTo {
  '/': typeof Char43HomeRoute
  '/demo': typeof demoChar43routeRoute
  '/forgot-password': typeof forgotPasswordIndexRoute
  '/new-account': typeof newAccountIndexRoute
  '/new-supplier': typeof newSupplierIndexRoute
  '/sign-in': typeof signInIndexRoute
  '/admin': typeof adminChar43AdminHomeRoute
  '/campaigns': typeof campaignsChar43CampaignsOverviewRoute
  '/dashboard': typeof dashboardChar43DashboardRoute
  '/admin/expiry': typeof adminChar43expiryRoute
  '/admin/staff': typeof adminStaffChar43routeRoute
  '/dashboard/cash-flow': typeof dashboardChar43cashFlowRoute
  '/dashboard/costs': typeof dashboardChar43CostsDashboardRoute
  '/dashboard/coverage': typeof dashboardCoverageChar43CoverageDashboardRoute
  '/dashboard/eap-utilisation': typeof dashboardChar43eapUtilisationRoute
  '/dashboard/listing-prices': typeof dashboardChar43listingPricesRoute
  '/dashboard/mrr': typeof dashboardChar43MRRRoute
  '/dashboard/spending': typeof dashboardChar43spendingRoute
  '/dashboard/tv': typeof dashboardChar43TVRoute
  '/dashboard/tv2': typeof dashboardChar43tv2Route
  '/dashboard/usage': typeof dashboardChar43UsageDashboardRoute
  '/dashboard/utilisation': typeof dashboardChar43utilisationRoute
  '/policies/eap-supplier': typeof policiesChar43eapSupplierRoute
  '/admin/account-owners': typeof adminAccountOwnersIndexRoute
  '/admin/categories': typeof adminCategoriesIndexRoute
  '/admin/countries': typeof adminCountriesIndexRoute
  '/admin/resource-categories': typeof adminResourceCategoriesIndexRoute
  '/admin/surpluses': typeof adminSurplusesIndexRoute
  '/admin/themes': typeof adminThemesIndexRoute
  '/admin/user-settings': typeof adminUserSettingsIndexRoute
  '/invitation/activate': typeof invitationActivateIndexRoute
  '/admin/devtools': typeof adminDevtoolsChar43DevToolsRoute
  '/admin/legal': typeof adminLegalChar43LegalTermsListPageRoute
  '/admin/listing-review': typeof adminListingReviewChar43ListingReviewOverviewPageRoute
  '/admin/members': typeof adminMembersChar43MembersPageRoute
  '/admin/resources': typeof adminResourcesChar43ResourcesPageRoute
  '/admin/suppliers': typeof adminSuppliersChar43SuppliersPageRoute
  '/admin/supporters': typeof adminSupportersChar43SupportersPageRoute
  '/campaigns/segments': typeof campaignsSegmentsChar43SegmentsPageRoute
  '/campaigns/sends': typeof campaignsSendsChar43SendsPageRoute
  '/campaigns/templates': typeof campaignsTemplatesChar43TemplatesPageRoute
  '/campaigns/unsubscribed': typeof campaignsSuppressionChar43UnsubscribedListRoute
  '/supplier/$supplierId': typeof supplierChar43SupplierHomeRoute
  '/supporter/$supporterId': typeof supporterChar43SupporterHomeRoute
  '/campaigns/segments/$segmentId': typeof campaignsSegmentsChar43SegmentEditorRoute
  '/campaigns/sends/$sendId': typeof campaignsSendsChar43SendDetailRoute
  '/campaigns/sends/new': typeof campaignsSendsChar43CreateSendRoute
  '/campaigns/templates/$templateId': typeof campaignsTemplatesChar43TemplateEditorRoute
  '/admin/claims': typeof adminClaimsIndexRoute
  '/admin/claims/$claimId': typeof adminClaimsChar91claimIdChar93IndexRoute
  '/admin/devtools/airwallex': typeof adminDevtoolsAirwallexIndexRoute
  '/admin/devtools/billing-sim': typeof adminDevtoolsBillingSimIndexRoute
  '/admin/devtools/listing-selector': typeof adminDevtoolsListingSelectorIndexRoute
  '/admin/devtools/member-lookup': typeof adminDevtoolsMemberLookupIndexRoute
  '/admin/devtools/ui': typeof adminDevtoolsUiIndexRoute
  '/admin/legal/$termsId': typeof adminLegalChar91termsIdChar93IndexRoute
  '/admin/legal/new': typeof adminLegalNewIndexRoute
  '/admin/members/$memberId': typeof adminMembersChar91memberIdChar93IndexRoute
  '/admin/reports/$countryCode': typeof adminReportsIndexRouteWithChildren
  '/admin/resources/$resourceId': typeof adminResourcesChar91resourceIdChar93IndexRoute
  '/supplier/$supplierId/bookings': typeof supplierBookingsIndexRoute
  '/supplier/$supplierId/orders': typeof supplierOrdersIndexRoute
  '/supplier/$supplierId/passes': typeof supplierPassesIndexRoute
  '/supplier/$supplierId/payments': typeof supplierPaymentsIndexRoute
  '/supplier/$supplierId/sku': typeof supplierSkuIndexRoute
  '/supplier/$supplierId/subscriptions': typeof supplierSubscriptionsIndexRoute
  '/supplier/$supplierId/user-settings': typeof supplierUserSettingsIndexRoute
  '/supporter/$supporterId/admins': typeof supporterAdminsIndexRoute
  '/supporter/$supporterId/allowances': typeof supporterAllowancesIndexRoute
  '/supporter/$supporterId/history': typeof supporterHistoryIndexRoute
  '/supporter/$supporterId/reports': typeof supporterReportsIndexRoute
  '/supporter/$supporterId/team': typeof supporterTeamIndexRoute
  '/supporter/$supporterId/user-settings': typeof supporterUserSettingsIndexRoute
  '/admin/suppliers/$supplierId': typeof adminSuppliersChar91supplierIdChar93Char43SupplierPageRoute
  '/admin/supporters/$supporterId': typeof adminSupportersChar91supporterIdChar93Char43SupporterPageRoute
  '/supplier/$supplierId/eap': typeof supplierEapChar43EAPListRoute
  '/supplier/$supplierId/listings': typeof supplierListingsChar43ListingsPageRoute
  '/supplier/$supplierId/messages': typeof supplierMessagesChar43MessagesRoute
  '/supplier/$supplierId/sales': typeof supplierSalesChar43SupplierSalesRoute
  '/supporter/$supporterId/allowance-reports': typeof supporterAllowanceReportsChar43indexRoute
  '/supporter/$supporterId/eap': typeof supporterEapChar43EAPRoute
  '/supporter/$supporterId/financial-reports': typeof supporterFinancialReportsChar43indexRoute
  '/supporter/$supporterId/settings': typeof supporterSettingsChar43indexRoute
  '/admin/listing-review/$listingId/$version': typeof adminListingReviewChar43ListingReviewPageRoute
  '/admin/reports/$countryCode/card-payments': typeof adminReportsChar43cardPaymentsRoute
  '/admin/reports/$countryCode/current-supporters': typeof adminReportsChar43CurrentSupportersReportPageRoute
  '/admin/reports/$countryCode/eap-arrears': typeof adminReportsEapChar43SupporterEapArrearsPageRoute
  '/admin/reports/$countryCode/eap-quality': typeof adminReportsEapChar43EapListingQuailityReviewRoute
  '/admin/reports/$countryCode/eap-requests': typeof adminReportsEapChar43EapSessionRequestsPageRoute
  '/admin/reports/$countryCode/eap-unclosed-sessions': typeof adminReportsEapChar43EapUnclosedSessionsPageRoute
  '/admin/reports/$countryCode/member-subscriptions': typeof adminReportsChar43MemberSubscriptionsReportPageRoute
  '/admin/reports/$countryCode/projected-mrr': typeof adminReportsChar43projectedMrrRoute
  '/admin/reports/$countryCode/supporter': typeof adminReportsChar43SupporterMonthlyStatsReportPageRoute
  '/admin/reports/$countryCode/supporter-sales': typeof adminReportsChar43SupporterSalesReportPageRoute
  '/admin/supporters/$supporterId/billing': typeof adminSupportersChar91supporterIdChar93Char43BillingPageRoute
  '/admin/supporters/$supporterId/eap': typeof adminSupportersChar91supporterIdChar93Char43EAPPageRoute
  '/admin/supporters/$supporterId/note': typeof adminSupportersChar91supporterIdChar93Char43NotePageRoute
  '/admin/supporters/$supporterId/settings': typeof adminSupportersChar91supporterIdChar93Char43SettingsPageRoute
  '/supplier/$supplierId/eap-review': typeof supplierEapReviewIndexRoute
  '/supplier/$supplierId/settings': typeof supplierSettingsProfileIndexRoute
  '/admin/members/$memberId/new-claim': typeof adminMembersChar91memberIdChar93NewClaimIndexRoute
  '/admin/members/$memberId/new-purchase': typeof adminMembersChar91memberIdChar93NewPurchaseIndexRoute
  '/admin/members/$memberId/transactions': typeof adminMembersChar91memberIdChar93TransactionsIndexRoute
  '/admin/suppliers/$supplierId/calendars': typeof adminSuppliersChar91supplierIdChar93CalendarsIndexRoute
  '/admin/suppliers/$supplierId/locations': typeof adminSuppliersChar91supplierIdChar93LocationsIndexRoute
  '/admin/suppliers/$supplierId/settings': typeof adminSuppliersChar91supplierIdChar93SettingsIndexRoute
  '/supplier/$supplierId/eap-review/$purchaseId': typeof supplierEapReviewChar91purchaseIdChar93IndexRoute
  '/supplier/$supplierId/eap/new': typeof supplierEapNewIndexRoute
  '/supplier/$supplierId/listings/new': typeof supplierListingsNewIndexRoute
  '/supplier/$supplierId/messages/$conversationId': typeof supplierMessagesChar91conversationIdChar93IndexRoute
  '/supplier/$supplierId/sales/$purchaseId': typeof supplierSalesChar91purchaseIdChar93IndexRoute
  '/supplier/$supplierId/settings/automations': typeof supplierSettingsAutomationsIndexRoute
  '/supplier/$supplierId/settings/business': typeof supplierSettingsBusinessIndexRoute
  '/supplier/$supplierId/settings/givenwell-terms': typeof supplierSettingsGivenwellTermsIndexRoute
  '/supplier/$supplierId/settings/legal': typeof supplierSettingsLegalIndexRoute
  '/supplier/$supplierId/settings/locations': typeof supplierSettingsLocationsIndexRoute
  '/supplier/$supplierId/settings/markets': typeof supplierSettingsMarketsIndexRoute
  '/supplier/$supplierId/settings/payment': typeof supplierSettingsPaymentIndexRoute
  '/supporter/$supporterId/admins/$userId': typeof supporterAdminsChar91userIdChar93IndexRoute
  '/supporter/$supporterId/allowance-reports/forecast': typeof supporterAllowanceReportsForecastIndexRoute
  '/supporter/$supporterId/allowance-reports/insights': typeof supporterAllowanceReportsInsightsIndexRoute
  '/supporter/$supporterId/allowance-reports/spend': typeof supporterAllowanceReportsSpendIndexRoute
  '/supporter/$supporterId/allowance-reports/utilisation': typeof supporterAllowanceReportsUtilisationIndexRoute
  '/supporter/$supporterId/eap/settings': typeof supporterEapSettingsIndexRoute
  '/supporter/$supporterId/financial-reports/invoices': typeof supporterFinancialReportsInvoicesIndexRoute
  '/supporter/$supporterId/settings/billing': typeof supporterSettingsBillingIndexRoute
  '/supporter/$supporterId/settings/countries': typeof supporterSettingsCountriesIndexRoute
  '/supporter/$supporterId/settings/givenwell-terms': typeof supporterSettingsGivenwellTermsIndexRoute
  '/admin/reports/$countryCode/daily-payouts': typeof adminReportsDailyPayoutsChar43DailyPayoutsRoute
  '/supplier/$supplierId/settings/calendars': typeof supplierSettingsCalendarsChar43CalendarSettingsRoute
  '/supplier/$supplierId/settings/refunds': typeof supplierSettingsRefundChar43RefundSettingsRoute
  '/supplier/$supplierId/settings/team': typeof supplierSettingsTeamChar43TeamTableRoute
  '/supporter/$supporterId/financial-reports/transactions': typeof supporterFinancialReportsTransactionsChar43WalletRoute
  '/admin/reports/$countryCode/daily-payouts/detail': typeof adminReportsDailyPayoutsChar43DailyPayoutsDetailRoute
  '/supplier/$supplierId/eap/$listingId/$version': typeof supplierEapChar91listingIdChar93Char43pageRoute
  '/supporter/$supporterId/eap/requests': typeof supporterEapRequestsIndexRoute
  '/supporter/$supporterId/eap/requests/$requestId': typeof supporterEapRequestsChar91requestIdChar93IndexRoute
  '/supplier/$supplierId/listings/$listingId/$version': typeof supplierListingsChar91listingIdChar93Char43indexRoute
  '/supplier/$supplierId/settings/calendars/$calendarId': typeof supplierSettingsCalendarsChar91calendarIdChar93Char43EditCalendarSettingsRoute
  '/supplier/$supplierId/listings/$listingId/$version/variants': typeof supplierListingsChar91listingIdChar93Char43variantsRouteWithChildren
  '/supplier/$supplierId/settings/calendars/$calendarId/connect': typeof supplierSettingsCalendarsChar91calendarIdChar93ConnectIndexRoute
  '/supplier/$supplierId/settings/calendars/$calendarId/disconnect': typeof supplierSettingsCalendarsChar91calendarIdChar93DisconnectIndexRoute
  '/supplier/$supplierId/settings/calendars/$calendarId/external': typeof supplierSettingsCalendarsChar91calendarIdChar93ExternalIndexRoute
  '/supplier/$supplierId/settings/refunds/cancellation-policy/$policyId': typeof supplierSettingsRefundCancellationPolicyChar91policyIdChar93IndexRoute
  '/supporter/$supporterId/financial-reports/transactions/allowance/$batchId': typeof supporterFinancialReportsTransactionsAllowanceChar91batchIdChar93IndexRoute
  '/supporter/$supporterId/financial-reports/transactions/details/$version': typeof supporterFinancialReportsTransactionsDetailsChar91versionChar93IndexRoute
  '/supplier/$supplierId/listings/$listingId/$version/variants/$variantId': typeof supplierListingsChar91listingIdChar93Char43variantRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof Char43HomeRoute
  '/admin': typeof adminChar43LayoutRouteWithChildren
  '/campaigns': typeof campaignsChar43LayoutRouteWithChildren
  '/dashboard': typeof dashboardChar43LayoutRouteWithChildren
  '/demo': typeof demoChar43routeRoute
  '/forgot-password': typeof forgotPasswordIndexRoute
  '/new-account': typeof newAccountIndexRoute
  '/new-supplier': typeof newSupplierIndexRoute
  '/sign-in': typeof signInIndexRoute
  '/admin/': typeof adminChar43AdminHomeRoute
  '/campaigns/': typeof campaignsChar43CampaignsOverviewRoute
  '/dashboard/': typeof dashboardChar43DashboardRoute
  '/admin/devtools': typeof adminDevtoolsChar43LayoutRouteWithChildren
  '/admin/expiry': typeof adminChar43expiryRoute
  '/admin/staff': typeof adminStaffChar43routeRoute
  '/dashboard/cash-flow': typeof dashboardChar43cashFlowRoute
  '/dashboard/costs': typeof dashboardChar43CostsDashboardRoute
  '/dashboard/coverage': typeof dashboardCoverageChar43CoverageDashboardRoute
  '/dashboard/eap-utilisation': typeof dashboardChar43eapUtilisationRoute
  '/dashboard/listing-prices': typeof dashboardChar43listingPricesRoute
  '/dashboard/mrr': typeof dashboardChar43MRRRoute
  '/dashboard/spending': typeof dashboardChar43spendingRoute
  '/dashboard/tv': typeof dashboardChar43TVRoute
  '/dashboard/tv2': typeof dashboardChar43tv2Route
  '/dashboard/usage': typeof dashboardChar43UsageDashboardRoute
  '/dashboard/utilisation': typeof dashboardChar43utilisationRoute
  '/policies/eap-supplier': typeof policiesChar43eapSupplierRoute
  '/supplier/$supplierId': typeof supplierChar43LayoutRouteWithChildren
  '/supporter/$supporterId': typeof supporterChar43LayoutRouteWithChildren
  '/admin/account-owners': typeof adminAccountOwnersIndexRoute
  '/admin/categories': typeof adminCategoriesIndexRoute
  '/admin/countries': typeof adminCountriesIndexRoute
  '/admin/legal': typeof adminLegalIndexRouteWithChildren
  '/admin/listing-review': typeof adminListingReviewIndexRouteWithChildren
  '/admin/members': typeof adminMembersIndexRouteWithChildren
  '/admin/resource-categories': typeof adminResourceCategoriesIndexRoute
  '/admin/resources': typeof adminResourcesIndexRouteWithChildren
  '/admin/suppliers': typeof adminSuppliersIndexRouteWithChildren
  '/admin/supporters': typeof adminSupportersIndexRouteWithChildren
  '/admin/surpluses': typeof adminSurplusesIndexRoute
  '/admin/themes': typeof adminThemesIndexRoute
  '/admin/user-settings': typeof adminUserSettingsIndexRoute
  '/invitation/activate': typeof invitationActivateIndexRoute
  '/admin/devtools/': typeof adminDevtoolsChar43DevToolsRoute
  '/admin/legal/': typeof adminLegalChar43LegalTermsListPageRoute
  '/admin/listing-review/': typeof adminListingReviewChar43ListingReviewOverviewPageRoute
  '/admin/members/': typeof adminMembersChar43MembersPageRoute
  '/admin/resources/': typeof adminResourcesChar43ResourcesPageRoute
  '/admin/suppliers/': typeof adminSuppliersChar43SuppliersPageRoute
  '/admin/supporters/': typeof adminSupportersChar43SupportersPageRoute
  '/campaigns/segments/': typeof campaignsSegmentsChar43SegmentsPageRoute
  '/campaigns/sends/': typeof campaignsSendsChar43SendsPageRoute
  '/campaigns/templates/': typeof campaignsTemplatesChar43TemplatesPageRoute
  '/campaigns/unsubscribed/': typeof campaignsSuppressionChar43UnsubscribedListRoute
  '/supplier/$supplierId/': typeof supplierChar43SupplierHomeRoute
  '/supporter/$supporterId/': typeof supporterChar43SupporterHomeRoute
  '/campaigns/segments/$segmentId': typeof campaignsSegmentsChar43SegmentEditorRoute
  '/campaigns/sends/$sendId': typeof campaignsSendsChar43SendDetailRoute
  '/campaigns/sends/new': typeof campaignsSendsChar43CreateSendRoute
  '/campaigns/templates/$templateId': typeof campaignsTemplatesChar43TemplateEditorRoute
  '/supplier/$supplierId/eap-review': typeof supplierEapReviewChar43ReviewListRouteWithChildren
  '/supporter/$supporterId/allowance-reports': typeof supporterAllowanceReportsChar43LayoutRouteWithChildren
  '/supporter/$supporterId/financial-reports': typeof supporterFinancialReportsChar43reportsRouteWithChildren
  '/supporter/$supporterId/settings': typeof supporterSettingsChar43routeRouteWithChildren
  '/admin/claims/': typeof adminClaimsIndexRoute
  '/admin/claims/$claimId': typeof adminClaimsChar91claimIdChar93IndexRoute
  '/admin/devtools/airwallex': typeof adminDevtoolsAirwallexIndexRoute
  '/admin/devtools/billing-sim': typeof adminDevtoolsBillingSimIndexRoute
  '/admin/devtools/listing-selector': typeof adminDevtoolsListingSelectorIndexRoute
  '/admin/devtools/member-lookup': typeof adminDevtoolsMemberLookupIndexRoute
  '/admin/devtools/ui': typeof adminDevtoolsUiIndexRoute
  '/admin/legal/$termsId': typeof adminLegalChar91termsIdChar93IndexRoute
  '/admin/legal/new': typeof adminLegalNewIndexRoute
  '/admin/members/$memberId': typeof adminMembersChar91memberIdChar93IndexRoute
  '/admin/reports/$countryCode': typeof adminReportsIndexRouteWithChildren
  '/admin/resources/$resourceId': typeof adminResourcesChar91resourceIdChar93IndexRoute
  '/admin/suppliers/$supplierId': typeof adminSuppliersChar91supplierIdChar93IndexRouteWithChildren
  '/admin/supporters/$supporterId': typeof adminSupportersChar91supporterIdChar93IndexRouteWithChildren
  '/supplier/$supplierId/bookings': typeof supplierBookingsIndexRoute
  '/supplier/$supplierId/eap': typeof supplierEapIndexRouteWithChildren
  '/supplier/$supplierId/listings': typeof supplierListingsIndexRouteWithChildren
  '/supplier/$supplierId/messages': typeof supplierMessagesIndexRouteWithChildren
  '/supplier/$supplierId/orders': typeof supplierOrdersIndexRoute
  '/supplier/$supplierId/passes': typeof supplierPassesIndexRoute
  '/supplier/$supplierId/payments': typeof supplierPaymentsIndexRoute
  '/supplier/$supplierId/sales': typeof supplierSalesIndexRouteWithChildren
  '/supplier/$supplierId/settings': typeof supplierSettingsIndexRouteWithChildren
  '/supplier/$supplierId/sku': typeof supplierSkuIndexRoute
  '/supplier/$supplierId/subscriptions': typeof supplierSubscriptionsIndexRoute
  '/supplier/$supplierId/user-settings': typeof supplierUserSettingsIndexRoute
  '/supporter/$supporterId/admins': typeof supporterAdminsIndexRoute
  '/supporter/$supporterId/allowances': typeof supporterAllowancesIndexRoute
  '/supporter/$supporterId/eap': typeof supporterEapIndexRouteWithChildren
  '/supporter/$supporterId/history': typeof supporterHistoryIndexRoute
  '/supporter/$supporterId/reports': typeof supporterReportsIndexRoute
  '/supporter/$supporterId/team': typeof supporterTeamIndexRoute
  '/supporter/$supporterId/user-settings': typeof supporterUserSettingsIndexRoute
  '/admin/suppliers/$supplierId/': typeof adminSuppliersChar91supplierIdChar93Char43SupplierPageRoute
  '/admin/supporters/$supporterId/': typeof adminSupportersChar91supporterIdChar93Char43SupporterPageRoute
  '/supplier/$supplierId/eap/': typeof supplierEapChar43EAPListRoute
  '/supplier/$supplierId/listings/': typeof supplierListingsChar43ListingsPageRoute
  '/supplier/$supplierId/messages/': typeof supplierMessagesChar43MessagesRoute
  '/supplier/$supplierId/sales/': typeof supplierSalesChar43SupplierSalesRoute
  '/supporter/$supporterId/allowance-reports/': typeof supporterAllowanceReportsChar43indexRoute
  '/supporter/$supporterId/eap/': typeof supporterEapChar43EAPRoute
  '/supporter/$supporterId/financial-reports/': typeof supporterFinancialReportsChar43indexRoute
  '/supporter/$supporterId/settings/': typeof supporterSettingsChar43indexRoute
  '/admin/listing-review/$listingId/$version': typeof adminListingReviewChar43ListingReviewPageRoute
  '/admin/reports/$countryCode/card-payments': typeof adminReportsChar43cardPaymentsRoute
  '/admin/reports/$countryCode/current-supporters': typeof adminReportsChar43CurrentSupportersReportPageRoute
  '/admin/reports/$countryCode/daily-payouts': typeof adminReportsDailyPayoutsChar43layoutRouteWithChildren
  '/admin/reports/$countryCode/eap-arrears': typeof adminReportsEapChar43SupporterEapArrearsPageRoute
  '/admin/reports/$countryCode/eap-quality': typeof adminReportsEapChar43EapListingQuailityReviewRoute
  '/admin/reports/$countryCode/eap-requests': typeof adminReportsEapChar43EapSessionRequestsPageRoute
  '/admin/reports/$countryCode/eap-unclosed-sessions': typeof adminReportsEapChar43EapUnclosedSessionsPageRoute
  '/admin/reports/$countryCode/member-subscriptions': typeof adminReportsChar43MemberSubscriptionsReportPageRoute
  '/admin/reports/$countryCode/projected-mrr': typeof adminReportsChar43projectedMrrRoute
  '/admin/reports/$countryCode/supporter': typeof adminReportsChar43SupporterMonthlyStatsReportPageRoute
  '/admin/reports/$countryCode/supporter-sales': typeof adminReportsChar43SupporterSalesReportPageRoute
  '/admin/supporters/$supporterId/billing': typeof adminSupportersChar91supporterIdChar93Char43BillingPageRoute
  '/admin/supporters/$supporterId/eap': typeof adminSupportersChar91supporterIdChar93Char43EAPPageRoute
  '/admin/supporters/$supporterId/note': typeof adminSupportersChar91supporterIdChar93Char43NotePageRoute
  '/admin/supporters/$supporterId/settings': typeof adminSupportersChar91supporterIdChar93Char43SettingsPageRoute
  '/supplier/$supplierId/eap-review/': typeof supplierEapReviewIndexRoute
  '/supplier/$supplierId/settings/': typeof supplierSettingsProfileIndexRoute
  '/admin/members/$memberId/new-claim': typeof adminMembersChar91memberIdChar93NewClaimIndexRoute
  '/admin/members/$memberId/new-purchase': typeof adminMembersChar91memberIdChar93NewPurchaseIndexRoute
  '/admin/members/$memberId/transactions': typeof adminMembersChar91memberIdChar93TransactionsIndexRoute
  '/admin/suppliers/$supplierId/calendars': typeof adminSuppliersChar91supplierIdChar93CalendarsIndexRoute
  '/admin/suppliers/$supplierId/locations': typeof adminSuppliersChar91supplierIdChar93LocationsIndexRoute
  '/admin/suppliers/$supplierId/settings': typeof adminSuppliersChar91supplierIdChar93SettingsIndexRoute
  '/supplier/$supplierId/eap-review/$purchaseId': typeof supplierEapReviewChar91purchaseIdChar93IndexRoute
  '/supplier/$supplierId/eap/new': typeof supplierEapNewIndexRoute
  '/supplier/$supplierId/listings/new': typeof supplierListingsNewIndexRoute
  '/supplier/$supplierId/messages/$conversationId': typeof supplierMessagesChar91conversationIdChar93IndexRoute
  '/supplier/$supplierId/sales/$purchaseId': typeof supplierSalesChar91purchaseIdChar93IndexRoute
  '/supplier/$supplierId/settings/automations': typeof supplierSettingsAutomationsIndexRoute
  '/supplier/$supplierId/settings/business': typeof supplierSettingsBusinessIndexRoute
  '/supplier/$supplierId/settings/calendars': typeof supplierSettingsCalendarsIndexRouteWithChildren
  '/supplier/$supplierId/settings/givenwell-terms': typeof supplierSettingsGivenwellTermsIndexRoute
  '/supplier/$supplierId/settings/legal': typeof supplierSettingsLegalIndexRoute
  '/supplier/$supplierId/settings/locations': typeof supplierSettingsLocationsIndexRoute
  '/supplier/$supplierId/settings/markets': typeof supplierSettingsMarketsIndexRoute
  '/supplier/$supplierId/settings/payment': typeof supplierSettingsPaymentIndexRoute
  '/supplier/$supplierId/settings/refunds': typeof supplierSettingsRefundIndexRouteWithChildren
  '/supplier/$supplierId/settings/team': typeof supplierSettingsTeamIndexRouteWithChildren
  '/supporter/$supporterId/admins/$userId': typeof supporterAdminsChar91userIdChar93IndexRoute
  '/supporter/$supporterId/allowance-reports/forecast': typeof supporterAllowanceReportsForecastIndexRoute
  '/supporter/$supporterId/allowance-reports/insights': typeof supporterAllowanceReportsInsightsIndexRoute
  '/supporter/$supporterId/allowance-reports/spend': typeof supporterAllowanceReportsSpendIndexRoute
  '/supporter/$supporterId/allowance-reports/utilisation': typeof supporterAllowanceReportsUtilisationIndexRoute
  '/supporter/$supporterId/eap/settings': typeof supporterEapSettingsIndexRoute
  '/supporter/$supporterId/financial-reports/invoices': typeof supporterFinancialReportsInvoicesIndexRoute
  '/supporter/$supporterId/financial-reports/transactions': typeof supporterFinancialReportsTransactionsIndexRouteWithChildren
  '/supporter/$supporterId/settings/billing': typeof supporterSettingsBillingIndexRoute
  '/supporter/$supporterId/settings/countries': typeof supporterSettingsCountriesIndexRoute
  '/supporter/$supporterId/settings/givenwell-terms': typeof supporterSettingsGivenwellTermsIndexRoute
  '/admin/reports/$countryCode/daily-payouts/': typeof adminReportsDailyPayoutsChar43DailyPayoutsRoute
  '/supplier/$supplierId/settings/calendars/': typeof supplierSettingsCalendarsChar43CalendarSettingsRoute
  '/supplier/$supplierId/settings/refunds/': typeof supplierSettingsRefundChar43RefundSettingsRoute
  '/supplier/$supplierId/settings/team/': typeof supplierSettingsTeamChar43TeamTableRoute
  '/supporter/$supporterId/financial-reports/transactions/': typeof supporterFinancialReportsTransactionsChar43WalletRoute
  '/admin/reports/$countryCode/daily-payouts/detail': typeof adminReportsDailyPayoutsChar43DailyPayoutsDetailRoute
  '/supplier/$supplierId/eap/$listingId/$version': typeof supplierEapChar91listingIdChar93Char43pageRoute
  '/supplier/$supplierId/listings/$listingId/$version': typeof supplierListingsChar91listingIdChar93Char43EditListingPageRouteWithChildren
  '/supporter/$supporterId/eap/requests/': typeof supporterEapRequestsIndexRoute
  '/supplier/$supplierId/settings/calendars/$calendarId': typeof supplierSettingsCalendarsChar91calendarIdChar93IndexRouteWithChildren
  '/supporter/$supporterId/eap/requests/$requestId': typeof supporterEapRequestsChar91requestIdChar93IndexRoute
  '/supplier/$supplierId/listings/$listingId/$version/': typeof supplierListingsChar91listingIdChar93Char43indexRoute
  '/supplier/$supplierId/settings/calendars/$calendarId/': typeof supplierSettingsCalendarsChar91calendarIdChar93Char43EditCalendarSettingsRoute
  '/supplier/$supplierId/listings/$listingId/$version/variants': typeof supplierListingsChar91listingIdChar93Char43variantsRouteWithChildren
  '/supplier/$supplierId/settings/calendars/$calendarId/connect': typeof supplierSettingsCalendarsChar91calendarIdChar93ConnectIndexRoute
  '/supplier/$supplierId/settings/calendars/$calendarId/disconnect': typeof supplierSettingsCalendarsChar91calendarIdChar93DisconnectIndexRoute
  '/supplier/$supplierId/settings/calendars/$calendarId/external': typeof supplierSettingsCalendarsChar91calendarIdChar93ExternalIndexRoute
  '/supplier/$supplierId/settings/refunds/cancellation-policy/$policyId': typeof supplierSettingsRefundCancellationPolicyChar91policyIdChar93IndexRoute
  '/supporter/$supporterId/financial-reports/transactions/allowance/$batchId': typeof supporterFinancialReportsTransactionsAllowanceChar91batchIdChar93IndexRoute
  '/supporter/$supporterId/financial-reports/transactions/details/$version': typeof supporterFinancialReportsTransactionsDetailsChar91versionChar93IndexRoute
  '/supplier/$supplierId/listings/$listingId/$version/variants/$variantId': typeof supplierListingsChar91listingIdChar93Char43variantRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/campaigns'
    | '/dashboard'
    | '/demo'
    | '/forgot-password'
    | '/new-account'
    | '/new-supplier'
    | '/sign-in'
    | '/admin/'
    | '/campaigns/'
    | '/dashboard/'
    | '/admin/devtools'
    | '/admin/expiry'
    | '/admin/staff'
    | '/dashboard/cash-flow'
    | '/dashboard/costs'
    | '/dashboard/coverage'
    | '/dashboard/eap-utilisation'
    | '/dashboard/listing-prices'
    | '/dashboard/mrr'
    | '/dashboard/spending'
    | '/dashboard/tv'
    | '/dashboard/tv2'
    | '/dashboard/usage'
    | '/dashboard/utilisation'
    | '/policies/eap-supplier'
    | '/supplier/$supplierId'
    | '/supporter/$supporterId'
    | '/admin/account-owners'
    | '/admin/categories'
    | '/admin/countries'
    | '/admin/legal'
    | '/admin/listing-review'
    | '/admin/members'
    | '/admin/resource-categories'
    | '/admin/resources'
    | '/admin/suppliers'
    | '/admin/supporters'
    | '/admin/surpluses'
    | '/admin/themes'
    | '/admin/user-settings'
    | '/invitation/activate'
    | '/admin/devtools/'
    | '/admin/legal/'
    | '/admin/listing-review/'
    | '/admin/members/'
    | '/admin/resources/'
    | '/admin/suppliers/'
    | '/admin/supporters/'
    | '/campaigns/segments/'
    | '/campaigns/sends/'
    | '/campaigns/templates/'
    | '/campaigns/unsubscribed/'
    | '/supplier/$supplierId/'
    | '/supporter/$supporterId/'
    | '/campaigns/segments/$segmentId'
    | '/campaigns/sends/$sendId'
    | '/campaigns/sends/new'
    | '/campaigns/templates/$templateId'
    | '/supplier/$supplierId/eap-review'
    | '/supporter/$supporterId/allowance-reports'
    | '/supporter/$supporterId/financial-reports'
    | '/supporter/$supporterId/settings'
    | '/admin/claims/'
    | '/admin/claims/$claimId'
    | '/admin/devtools/airwallex'
    | '/admin/devtools/billing-sim'
    | '/admin/devtools/listing-selector'
    | '/admin/devtools/member-lookup'
    | '/admin/devtools/ui'
    | '/admin/legal/$termsId'
    | '/admin/legal/new'
    | '/admin/members/$memberId'
    | '/admin/reports/$countryCode'
    | '/admin/resources/$resourceId'
    | '/admin/suppliers/$supplierId'
    | '/admin/supporters/$supporterId'
    | '/supplier/$supplierId/bookings'
    | '/supplier/$supplierId/eap'
    | '/supplier/$supplierId/listings'
    | '/supplier/$supplierId/messages'
    | '/supplier/$supplierId/orders'
    | '/supplier/$supplierId/passes'
    | '/supplier/$supplierId/payments'
    | '/supplier/$supplierId/sales'
    | '/supplier/$supplierId/settings'
    | '/supplier/$supplierId/sku'
    | '/supplier/$supplierId/subscriptions'
    | '/supplier/$supplierId/user-settings'
    | '/supporter/$supporterId/admins'
    | '/supporter/$supporterId/allowances'
    | '/supporter/$supporterId/eap'
    | '/supporter/$supporterId/history'
    | '/supporter/$supporterId/reports'
    | '/supporter/$supporterId/team'
    | '/supporter/$supporterId/user-settings'
    | '/admin/suppliers/$supplierId/'
    | '/admin/supporters/$supporterId/'
    | '/supplier/$supplierId/eap/'
    | '/supplier/$supplierId/listings/'
    | '/supplier/$supplierId/messages/'
    | '/supplier/$supplierId/sales/'
    | '/supporter/$supporterId/allowance-reports/'
    | '/supporter/$supporterId/eap/'
    | '/supporter/$supporterId/financial-reports/'
    | '/supporter/$supporterId/settings/'
    | '/admin/listing-review/$listingId/$version'
    | '/admin/reports/$countryCode/card-payments'
    | '/admin/reports/$countryCode/current-supporters'
    | '/admin/reports/$countryCode/daily-payouts'
    | '/admin/reports/$countryCode/eap-arrears'
    | '/admin/reports/$countryCode/eap-quality'
    | '/admin/reports/$countryCode/eap-requests'
    | '/admin/reports/$countryCode/eap-unclosed-sessions'
    | '/admin/reports/$countryCode/member-subscriptions'
    | '/admin/reports/$countryCode/projected-mrr'
    | '/admin/reports/$countryCode/supporter'
    | '/admin/reports/$countryCode/supporter-sales'
    | '/admin/supporters/$supporterId/billing'
    | '/admin/supporters/$supporterId/eap'
    | '/admin/supporters/$supporterId/note'
    | '/admin/supporters/$supporterId/settings'
    | '/supplier/$supplierId/eap-review/'
    | '/supplier/$supplierId/settings/'
    | '/admin/members/$memberId/new-claim'
    | '/admin/members/$memberId/new-purchase'
    | '/admin/members/$memberId/transactions'
    | '/admin/suppliers/$supplierId/calendars'
    | '/admin/suppliers/$supplierId/locations'
    | '/admin/suppliers/$supplierId/settings'
    | '/supplier/$supplierId/eap-review/$purchaseId'
    | '/supplier/$supplierId/eap/new'
    | '/supplier/$supplierId/listings/new'
    | '/supplier/$supplierId/messages/$conversationId'
    | '/supplier/$supplierId/sales/$purchaseId'
    | '/supplier/$supplierId/settings/automations'
    | '/supplier/$supplierId/settings/business'
    | '/supplier/$supplierId/settings/calendars'
    | '/supplier/$supplierId/settings/givenwell-terms'
    | '/supplier/$supplierId/settings/legal'
    | '/supplier/$supplierId/settings/locations'
    | '/supplier/$supplierId/settings/markets'
    | '/supplier/$supplierId/settings/payment'
    | '/supplier/$supplierId/settings/refunds'
    | '/supplier/$supplierId/settings/team'
    | '/supporter/$supporterId/admins/$userId'
    | '/supporter/$supporterId/allowance-reports/forecast'
    | '/supporter/$supporterId/allowance-reports/insights'
    | '/supporter/$supporterId/allowance-reports/spend'
    | '/supporter/$supporterId/allowance-reports/utilisation'
    | '/supporter/$supporterId/eap/settings'
    | '/supporter/$supporterId/financial-reports/invoices'
    | '/supporter/$supporterId/financial-reports/transactions'
    | '/supporter/$supporterId/settings/billing'
    | '/supporter/$supporterId/settings/countries'
    | '/supporter/$supporterId/settings/givenwell-terms'
    | '/admin/reports/$countryCode/daily-payouts/'
    | '/supplier/$supplierId/settings/calendars/'
    | '/supplier/$supplierId/settings/refunds/'
    | '/supplier/$supplierId/settings/team/'
    | '/supporter/$supporterId/financial-reports/transactions/'
    | '/admin/reports/$countryCode/daily-payouts/detail'
    | '/supplier/$supplierId/eap/$listingId/$version'
    | '/supplier/$supplierId/listings/$listingId/$version'
    | '/supporter/$supporterId/eap/requests/'
    | '/supplier/$supplierId/settings/calendars/$calendarId'
    | '/supporter/$supporterId/eap/requests/$requestId'
    | '/supplier/$supplierId/listings/$listingId/$version/'
    | '/supplier/$supplierId/settings/calendars/$calendarId/'
    | '/supplier/$supplierId/listings/$listingId/$version/variants'
    | '/supplier/$supplierId/settings/calendars/$calendarId/connect'
    | '/supplier/$supplierId/settings/calendars/$calendarId/disconnect'
    | '/supplier/$supplierId/settings/calendars/$calendarId/external'
    | '/supplier/$supplierId/settings/refunds/cancellation-policy/$policyId'
    | '/supporter/$supporterId/financial-reports/transactions/allowance/$batchId'
    | '/supporter/$supporterId/financial-reports/transactions/details/$version'
    | '/supplier/$supplierId/listings/$listingId/$version/variants/$variantId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/demo'
    | '/forgot-password'
    | '/new-account'
    | '/new-supplier'
    | '/sign-in'
    | '/admin'
    | '/campaigns'
    | '/dashboard'
    | '/admin/expiry'
    | '/admin/staff'
    | '/dashboard/cash-flow'
    | '/dashboard/costs'
    | '/dashboard/coverage'
    | '/dashboard/eap-utilisation'
    | '/dashboard/listing-prices'
    | '/dashboard/mrr'
    | '/dashboard/spending'
    | '/dashboard/tv'
    | '/dashboard/tv2'
    | '/dashboard/usage'
    | '/dashboard/utilisation'
    | '/policies/eap-supplier'
    | '/admin/account-owners'
    | '/admin/categories'
    | '/admin/countries'
    | '/admin/resource-categories'
    | '/admin/surpluses'
    | '/admin/themes'
    | '/admin/user-settings'
    | '/invitation/activate'
    | '/admin/devtools'
    | '/admin/legal'
    | '/admin/listing-review'
    | '/admin/members'
    | '/admin/resources'
    | '/admin/suppliers'
    | '/admin/supporters'
    | '/campaigns/segments'
    | '/campaigns/sends'
    | '/campaigns/templates'
    | '/campaigns/unsubscribed'
    | '/supplier/$supplierId'
    | '/supporter/$supporterId'
    | '/campaigns/segments/$segmentId'
    | '/campaigns/sends/$sendId'
    | '/campaigns/sends/new'
    | '/campaigns/templates/$templateId'
    | '/admin/claims'
    | '/admin/claims/$claimId'
    | '/admin/devtools/airwallex'
    | '/admin/devtools/billing-sim'
    | '/admin/devtools/listing-selector'
    | '/admin/devtools/member-lookup'
    | '/admin/devtools/ui'
    | '/admin/legal/$termsId'
    | '/admin/legal/new'
    | '/admin/members/$memberId'
    | '/admin/reports/$countryCode'
    | '/admin/resources/$resourceId'
    | '/supplier/$supplierId/bookings'
    | '/supplier/$supplierId/orders'
    | '/supplier/$supplierId/passes'
    | '/supplier/$supplierId/payments'
    | '/supplier/$supplierId/sku'
    | '/supplier/$supplierId/subscriptions'
    | '/supplier/$supplierId/user-settings'
    | '/supporter/$supporterId/admins'
    | '/supporter/$supporterId/allowances'
    | '/supporter/$supporterId/history'
    | '/supporter/$supporterId/reports'
    | '/supporter/$supporterId/team'
    | '/supporter/$supporterId/user-settings'
    | '/admin/suppliers/$supplierId'
    | '/admin/supporters/$supporterId'
    | '/supplier/$supplierId/eap'
    | '/supplier/$supplierId/listings'
    | '/supplier/$supplierId/messages'
    | '/supplier/$supplierId/sales'
    | '/supporter/$supporterId/allowance-reports'
    | '/supporter/$supporterId/eap'
    | '/supporter/$supporterId/financial-reports'
    | '/supporter/$supporterId/settings'
    | '/admin/listing-review/$listingId/$version'
    | '/admin/reports/$countryCode/card-payments'
    | '/admin/reports/$countryCode/current-supporters'
    | '/admin/reports/$countryCode/eap-arrears'
    | '/admin/reports/$countryCode/eap-quality'
    | '/admin/reports/$countryCode/eap-requests'
    | '/admin/reports/$countryCode/eap-unclosed-sessions'
    | '/admin/reports/$countryCode/member-subscriptions'
    | '/admin/reports/$countryCode/projected-mrr'
    | '/admin/reports/$countryCode/supporter'
    | '/admin/reports/$countryCode/supporter-sales'
    | '/admin/supporters/$supporterId/billing'
    | '/admin/supporters/$supporterId/eap'
    | '/admin/supporters/$supporterId/note'
    | '/admin/supporters/$supporterId/settings'
    | '/supplier/$supplierId/eap-review'
    | '/supplier/$supplierId/settings'
    | '/admin/members/$memberId/new-claim'
    | '/admin/members/$memberId/new-purchase'
    | '/admin/members/$memberId/transactions'
    | '/admin/suppliers/$supplierId/calendars'
    | '/admin/suppliers/$supplierId/locations'
    | '/admin/suppliers/$supplierId/settings'
    | '/supplier/$supplierId/eap-review/$purchaseId'
    | '/supplier/$supplierId/eap/new'
    | '/supplier/$supplierId/listings/new'
    | '/supplier/$supplierId/messages/$conversationId'
    | '/supplier/$supplierId/sales/$purchaseId'
    | '/supplier/$supplierId/settings/automations'
    | '/supplier/$supplierId/settings/business'
    | '/supplier/$supplierId/settings/givenwell-terms'
    | '/supplier/$supplierId/settings/legal'
    | '/supplier/$supplierId/settings/locations'
    | '/supplier/$supplierId/settings/markets'
    | '/supplier/$supplierId/settings/payment'
    | '/supporter/$supporterId/admins/$userId'
    | '/supporter/$supporterId/allowance-reports/forecast'
    | '/supporter/$supporterId/allowance-reports/insights'
    | '/supporter/$supporterId/allowance-reports/spend'
    | '/supporter/$supporterId/allowance-reports/utilisation'
    | '/supporter/$supporterId/eap/settings'
    | '/supporter/$supporterId/financial-reports/invoices'
    | '/supporter/$supporterId/settings/billing'
    | '/supporter/$supporterId/settings/countries'
    | '/supporter/$supporterId/settings/givenwell-terms'
    | '/admin/reports/$countryCode/daily-payouts'
    | '/supplier/$supplierId/settings/calendars'
    | '/supplier/$supplierId/settings/refunds'
    | '/supplier/$supplierId/settings/team'
    | '/supporter/$supporterId/financial-reports/transactions'
    | '/admin/reports/$countryCode/daily-payouts/detail'
    | '/supplier/$supplierId/eap/$listingId/$version'
    | '/supporter/$supporterId/eap/requests'
    | '/supporter/$supporterId/eap/requests/$requestId'
    | '/supplier/$supplierId/listings/$listingId/$version'
    | '/supplier/$supplierId/settings/calendars/$calendarId'
    | '/supplier/$supplierId/listings/$listingId/$version/variants'
    | '/supplier/$supplierId/settings/calendars/$calendarId/connect'
    | '/supplier/$supplierId/settings/calendars/$calendarId/disconnect'
    | '/supplier/$supplierId/settings/calendars/$calendarId/external'
    | '/supplier/$supplierId/settings/refunds/cancellation-policy/$policyId'
    | '/supporter/$supporterId/financial-reports/transactions/allowance/$batchId'
    | '/supporter/$supporterId/financial-reports/transactions/details/$version'
    | '/supplier/$supplierId/listings/$listingId/$version/variants/$variantId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/campaigns'
    | '/dashboard'
    | '/demo'
    | '/forgot-password'
    | '/new-account'
    | '/new-supplier'
    | '/sign-in'
    | '/admin/'
    | '/campaigns/'
    | '/dashboard/'
    | '/admin/devtools'
    | '/admin/expiry'
    | '/admin/staff'
    | '/dashboard/cash-flow'
    | '/dashboard/costs'
    | '/dashboard/coverage'
    | '/dashboard/eap-utilisation'
    | '/dashboard/listing-prices'
    | '/dashboard/mrr'
    | '/dashboard/spending'
    | '/dashboard/tv'
    | '/dashboard/tv2'
    | '/dashboard/usage'
    | '/dashboard/utilisation'
    | '/policies/eap-supplier'
    | '/supplier/$supplierId'
    | '/supporter/$supporterId'
    | '/admin/account-owners'
    | '/admin/categories'
    | '/admin/countries'
    | '/admin/legal'
    | '/admin/listing-review'
    | '/admin/members'
    | '/admin/resource-categories'
    | '/admin/resources'
    | '/admin/suppliers'
    | '/admin/supporters'
    | '/admin/surpluses'
    | '/admin/themes'
    | '/admin/user-settings'
    | '/invitation/activate'
    | '/admin/devtools/'
    | '/admin/legal/'
    | '/admin/listing-review/'
    | '/admin/members/'
    | '/admin/resources/'
    | '/admin/suppliers/'
    | '/admin/supporters/'
    | '/campaigns/segments/'
    | '/campaigns/sends/'
    | '/campaigns/templates/'
    | '/campaigns/unsubscribed/'
    | '/supplier/$supplierId/'
    | '/supporter/$supporterId/'
    | '/campaigns/segments/$segmentId'
    | '/campaigns/sends/$sendId'
    | '/campaigns/sends/new'
    | '/campaigns/templates/$templateId'
    | '/supplier/$supplierId/eap-review'
    | '/supporter/$supporterId/allowance-reports'
    | '/supporter/$supporterId/financial-reports'
    | '/supporter/$supporterId/settings'
    | '/admin/claims/'
    | '/admin/claims/$claimId'
    | '/admin/devtools/airwallex'
    | '/admin/devtools/billing-sim'
    | '/admin/devtools/listing-selector'
    | '/admin/devtools/member-lookup'
    | '/admin/devtools/ui'
    | '/admin/legal/$termsId'
    | '/admin/legal/new'
    | '/admin/members/$memberId'
    | '/admin/reports/$countryCode'
    | '/admin/resources/$resourceId'
    | '/admin/suppliers/$supplierId'
    | '/admin/supporters/$supporterId'
    | '/supplier/$supplierId/bookings'
    | '/supplier/$supplierId/eap'
    | '/supplier/$supplierId/listings'
    | '/supplier/$supplierId/messages'
    | '/supplier/$supplierId/orders'
    | '/supplier/$supplierId/passes'
    | '/supplier/$supplierId/payments'
    | '/supplier/$supplierId/sales'
    | '/supplier/$supplierId/settings'
    | '/supplier/$supplierId/sku'
    | '/supplier/$supplierId/subscriptions'
    | '/supplier/$supplierId/user-settings'
    | '/supporter/$supporterId/admins'
    | '/supporter/$supporterId/allowances'
    | '/supporter/$supporterId/eap'
    | '/supporter/$supporterId/history'
    | '/supporter/$supporterId/reports'
    | '/supporter/$supporterId/team'
    | '/supporter/$supporterId/user-settings'
    | '/admin/suppliers/$supplierId/'
    | '/admin/supporters/$supporterId/'
    | '/supplier/$supplierId/eap/'
    | '/supplier/$supplierId/listings/'
    | '/supplier/$supplierId/messages/'
    | '/supplier/$supplierId/sales/'
    | '/supporter/$supporterId/allowance-reports/'
    | '/supporter/$supporterId/eap/'
    | '/supporter/$supporterId/financial-reports/'
    | '/supporter/$supporterId/settings/'
    | '/admin/listing-review/$listingId/$version'
    | '/admin/reports/$countryCode/card-payments'
    | '/admin/reports/$countryCode/current-supporters'
    | '/admin/reports/$countryCode/daily-payouts'
    | '/admin/reports/$countryCode/eap-arrears'
    | '/admin/reports/$countryCode/eap-quality'
    | '/admin/reports/$countryCode/eap-requests'
    | '/admin/reports/$countryCode/eap-unclosed-sessions'
    | '/admin/reports/$countryCode/member-subscriptions'
    | '/admin/reports/$countryCode/projected-mrr'
    | '/admin/reports/$countryCode/supporter'
    | '/admin/reports/$countryCode/supporter-sales'
    | '/admin/supporters/$supporterId/billing'
    | '/admin/supporters/$supporterId/eap'
    | '/admin/supporters/$supporterId/note'
    | '/admin/supporters/$supporterId/settings'
    | '/supplier/$supplierId/eap-review/'
    | '/supplier/$supplierId/settings/'
    | '/admin/members/$memberId/new-claim'
    | '/admin/members/$memberId/new-purchase'
    | '/admin/members/$memberId/transactions'
    | '/admin/suppliers/$supplierId/calendars'
    | '/admin/suppliers/$supplierId/locations'
    | '/admin/suppliers/$supplierId/settings'
    | '/supplier/$supplierId/eap-review/$purchaseId'
    | '/supplier/$supplierId/eap/new'
    | '/supplier/$supplierId/listings/new'
    | '/supplier/$supplierId/messages/$conversationId'
    | '/supplier/$supplierId/sales/$purchaseId'
    | '/supplier/$supplierId/settings/automations'
    | '/supplier/$supplierId/settings/business'
    | '/supplier/$supplierId/settings/calendars'
    | '/supplier/$supplierId/settings/givenwell-terms'
    | '/supplier/$supplierId/settings/legal'
    | '/supplier/$supplierId/settings/locations'
    | '/supplier/$supplierId/settings/markets'
    | '/supplier/$supplierId/settings/payment'
    | '/supplier/$supplierId/settings/refunds'
    | '/supplier/$supplierId/settings/team'
    | '/supporter/$supporterId/admins/$userId'
    | '/supporter/$supporterId/allowance-reports/forecast'
    | '/supporter/$supporterId/allowance-reports/insights'
    | '/supporter/$supporterId/allowance-reports/spend'
    | '/supporter/$supporterId/allowance-reports/utilisation'
    | '/supporter/$supporterId/eap/settings'
    | '/supporter/$supporterId/financial-reports/invoices'
    | '/supporter/$supporterId/financial-reports/transactions'
    | '/supporter/$supporterId/settings/billing'
    | '/supporter/$supporterId/settings/countries'
    | '/supporter/$supporterId/settings/givenwell-terms'
    | '/admin/reports/$countryCode/daily-payouts/'
    | '/supplier/$supplierId/settings/calendars/'
    | '/supplier/$supplierId/settings/refunds/'
    | '/supplier/$supplierId/settings/team/'
    | '/supporter/$supporterId/financial-reports/transactions/'
    | '/admin/reports/$countryCode/daily-payouts/detail'
    | '/supplier/$supplierId/eap/$listingId/$version'
    | '/supplier/$supplierId/listings/$listingId/$version'
    | '/supporter/$supporterId/eap/requests/'
    | '/supplier/$supplierId/settings/calendars/$calendarId'
    | '/supporter/$supporterId/eap/requests/$requestId'
    | '/supplier/$supplierId/listings/$listingId/$version/'
    | '/supplier/$supplierId/settings/calendars/$calendarId/'
    | '/supplier/$supplierId/listings/$listingId/$version/variants'
    | '/supplier/$supplierId/settings/calendars/$calendarId/connect'
    | '/supplier/$supplierId/settings/calendars/$calendarId/disconnect'
    | '/supplier/$supplierId/settings/calendars/$calendarId/external'
    | '/supplier/$supplierId/settings/refunds/cancellation-policy/$policyId'
    | '/supporter/$supporterId/financial-reports/transactions/allowance/$batchId'
    | '/supporter/$supporterId/financial-reports/transactions/details/$version'
    | '/supplier/$supplierId/listings/$listingId/$version/variants/$variantId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Char43HomeRoute: typeof Char43HomeRoute
  adminChar43LayoutRoute: typeof adminChar43LayoutRouteWithChildren
  campaignsChar43LayoutRoute: typeof campaignsChar43LayoutRouteWithChildren
  dashboardChar43LayoutRoute: typeof dashboardChar43LayoutRouteWithChildren
  demoChar43routeRoute: typeof demoChar43routeRoute
  forgotPasswordIndexRoute: typeof forgotPasswordIndexRoute
  newAccountIndexRoute: typeof newAccountIndexRoute
  newSupplierIndexRoute: typeof newSupplierIndexRoute
  signInIndexRoute: typeof signInIndexRoute
  policiesChar43eapSupplierRoute: typeof policiesChar43eapSupplierRoute
  supplierChar43LayoutRoute: typeof supplierChar43LayoutRouteWithChildren
  supporterChar43LayoutRoute: typeof supporterChar43LayoutRouteWithChildren
  invitationActivateIndexRoute: typeof invitationActivateIndexRoute
  supplierEapNewIndexRoute: typeof supplierEapNewIndexRoute
  supplierListingsNewIndexRoute: typeof supplierListingsNewIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof Char43HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof adminChar43LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns': {
      id: '/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof campaignsChar43LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof dashboardChar43LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof demoChar43routeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof forgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new-account': {
      id: '/new-account'
      path: '/new-account'
      fullPath: '/new-account'
      preLoaderRoute: typeof newAccountIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new-supplier': {
      id: '/new-supplier'
      path: '/new-supplier'
      fullPath: '/new-supplier'
      preLoaderRoute: typeof newSupplierIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof signInIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof adminChar43AdminHomeRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/account-owners': {
      id: '/admin/account-owners'
      path: '/account-owners'
      fullPath: '/admin/account-owners'
      preLoaderRoute: typeof adminAccountOwnersIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/categories': {
      id: '/admin/categories'
      path: '/categories'
      fullPath: '/admin/categories'
      preLoaderRoute: typeof adminCategoriesIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/countries': {
      id: '/admin/countries'
      path: '/countries'
      fullPath: '/admin/countries'
      preLoaderRoute: typeof adminCountriesIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/devtools': {
      id: '/admin/devtools'
      path: '/devtools'
      fullPath: '/admin/devtools'
      preLoaderRoute: typeof adminDevtoolsChar43LayoutRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/expiry': {
      id: '/admin/expiry'
      path: '/expiry'
      fullPath: '/admin/expiry'
      preLoaderRoute: typeof adminChar43expiryRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/legal': {
      id: '/admin/legal'
      path: '/legal'
      fullPath: '/admin/legal'
      preLoaderRoute: typeof adminLegalIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/listing-review': {
      id: '/admin/listing-review'
      path: '/listing-review'
      fullPath: '/admin/listing-review'
      preLoaderRoute: typeof adminListingReviewIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/members': {
      id: '/admin/members'
      path: '/members'
      fullPath: '/admin/members'
      preLoaderRoute: typeof adminMembersIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/resource-categories': {
      id: '/admin/resource-categories'
      path: '/resource-categories'
      fullPath: '/admin/resource-categories'
      preLoaderRoute: typeof adminResourceCategoriesIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/resources': {
      id: '/admin/resources'
      path: '/resources'
      fullPath: '/admin/resources'
      preLoaderRoute: typeof adminResourcesIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/staff': {
      id: '/admin/staff'
      path: '/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof adminStaffChar43routeRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/suppliers': {
      id: '/admin/suppliers'
      path: '/suppliers'
      fullPath: '/admin/suppliers'
      preLoaderRoute: typeof adminSuppliersIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/supporters': {
      id: '/admin/supporters'
      path: '/supporters'
      fullPath: '/admin/supporters'
      preLoaderRoute: typeof adminSupportersIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/surpluses': {
      id: '/admin/surpluses'
      path: '/surpluses'
      fullPath: '/admin/surpluses'
      preLoaderRoute: typeof adminSurplusesIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/themes': {
      id: '/admin/themes'
      path: '/themes'
      fullPath: '/admin/themes'
      preLoaderRoute: typeof adminThemesIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/user-settings': {
      id: '/admin/user-settings'
      path: '/user-settings'
      fullPath: '/admin/user-settings'
      preLoaderRoute: typeof adminUserSettingsIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/campaigns/': {
      id: '/campaigns/'
      path: '/'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof campaignsChar43CampaignsOverviewRouteImport
      parentRoute: typeof campaignsChar43LayoutRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof dashboardChar43DashboardRouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/dashboard/cash-flow': {
      id: '/dashboard/cash-flow'
      path: '/cash-flow'
      fullPath: '/dashboard/cash-flow'
      preLoaderRoute: typeof dashboardChar43cashFlowRouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/dashboard/costs': {
      id: '/dashboard/costs'
      path: '/costs'
      fullPath: '/dashboard/costs'
      preLoaderRoute: typeof dashboardChar43CostsDashboardRouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/dashboard/coverage': {
      id: '/dashboard/coverage'
      path: '/coverage'
      fullPath: '/dashboard/coverage'
      preLoaderRoute: typeof dashboardCoverageChar43CoverageDashboardRouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/dashboard/eap-utilisation': {
      id: '/dashboard/eap-utilisation'
      path: '/eap-utilisation'
      fullPath: '/dashboard/eap-utilisation'
      preLoaderRoute: typeof dashboardChar43eapUtilisationRouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/dashboard/listing-prices': {
      id: '/dashboard/listing-prices'
      path: '/listing-prices'
      fullPath: '/dashboard/listing-prices'
      preLoaderRoute: typeof dashboardChar43listingPricesRouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/dashboard/mrr': {
      id: '/dashboard/mrr'
      path: '/mrr'
      fullPath: '/dashboard/mrr'
      preLoaderRoute: typeof dashboardChar43MRRRouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/dashboard/spending': {
      id: '/dashboard/spending'
      path: '/spending'
      fullPath: '/dashboard/spending'
      preLoaderRoute: typeof dashboardChar43spendingRouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/dashboard/tv': {
      id: '/dashboard/tv'
      path: '/tv'
      fullPath: '/dashboard/tv'
      preLoaderRoute: typeof dashboardChar43TVRouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/dashboard/tv2': {
      id: '/dashboard/tv2'
      path: '/tv2'
      fullPath: '/dashboard/tv2'
      preLoaderRoute: typeof dashboardChar43tv2RouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/dashboard/usage': {
      id: '/dashboard/usage'
      path: '/usage'
      fullPath: '/dashboard/usage'
      preLoaderRoute: typeof dashboardChar43UsageDashboardRouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/dashboard/utilisation': {
      id: '/dashboard/utilisation'
      path: '/utilisation'
      fullPath: '/dashboard/utilisation'
      preLoaderRoute: typeof dashboardChar43utilisationRouteImport
      parentRoute: typeof dashboardChar43LayoutRoute
    }
    '/invitation/activate': {
      id: '/invitation/activate'
      path: '/invitation/activate'
      fullPath: '/invitation/activate'
      preLoaderRoute: typeof invitationActivateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies/eap-supplier': {
      id: '/policies/eap-supplier'
      path: '/policies/eap-supplier'
      fullPath: '/policies/eap-supplier'
      preLoaderRoute: typeof policiesChar43eapSupplierRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supplier/$supplierId': {
      id: '/supplier/$supplierId'
      path: '/supplier/$supplierId'
      fullPath: '/supplier/$supplierId'
      preLoaderRoute: typeof supplierChar43LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supporter/$supporterId': {
      id: '/supporter/$supporterId'
      path: '/supporter/$supporterId'
      fullPath: '/supporter/$supporterId'
      preLoaderRoute: typeof supporterChar43LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/claims/': {
      id: '/admin/claims/'
      path: '/claims'
      fullPath: '/admin/claims/'
      preLoaderRoute: typeof adminClaimsIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/claims/$claimId': {
      id: '/admin/claims/$claimId'
      path: '/claims/$claimId'
      fullPath: '/admin/claims/$claimId'
      preLoaderRoute: typeof adminClaimsChar91claimIdChar93IndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/devtools/': {
      id: '/admin/devtools/'
      path: '/'
      fullPath: '/admin/devtools/'
      preLoaderRoute: typeof adminDevtoolsChar43DevToolsRouteImport
      parentRoute: typeof adminDevtoolsChar43LayoutRoute
    }
    '/admin/devtools/airwallex': {
      id: '/admin/devtools/airwallex'
      path: '/airwallex'
      fullPath: '/admin/devtools/airwallex'
      preLoaderRoute: typeof adminDevtoolsAirwallexIndexRouteImport
      parentRoute: typeof adminDevtoolsChar43LayoutRoute
    }
    '/admin/devtools/billing-sim': {
      id: '/admin/devtools/billing-sim'
      path: '/billing-sim'
      fullPath: '/admin/devtools/billing-sim'
      preLoaderRoute: typeof adminDevtoolsBillingSimIndexRouteImport
      parentRoute: typeof adminDevtoolsChar43LayoutRoute
    }
    '/admin/devtools/listing-selector': {
      id: '/admin/devtools/listing-selector'
      path: '/listing-selector'
      fullPath: '/admin/devtools/listing-selector'
      preLoaderRoute: typeof adminDevtoolsListingSelectorIndexRouteImport
      parentRoute: typeof adminDevtoolsChar43LayoutRoute
    }
    '/admin/devtools/member-lookup': {
      id: '/admin/devtools/member-lookup'
      path: '/member-lookup'
      fullPath: '/admin/devtools/member-lookup'
      preLoaderRoute: typeof adminDevtoolsMemberLookupIndexRouteImport
      parentRoute: typeof adminDevtoolsChar43LayoutRoute
    }
    '/admin/devtools/ui': {
      id: '/admin/devtools/ui'
      path: '/ui'
      fullPath: '/admin/devtools/ui'
      preLoaderRoute: typeof adminDevtoolsUiIndexRouteImport
      parentRoute: typeof adminDevtoolsChar43LayoutRoute
    }
    '/admin/legal/': {
      id: '/admin/legal/'
      path: '/'
      fullPath: '/admin/legal/'
      preLoaderRoute: typeof adminLegalChar43LegalTermsListPageRouteImport
      parentRoute: typeof adminLegalIndexRoute
    }
    '/admin/legal/$termsId': {
      id: '/admin/legal/$termsId'
      path: '/$termsId'
      fullPath: '/admin/legal/$termsId'
      preLoaderRoute: typeof adminLegalChar91termsIdChar93IndexRouteImport
      parentRoute: typeof adminLegalIndexRoute
    }
    '/admin/legal/new': {
      id: '/admin/legal/new'
      path: '/new'
      fullPath: '/admin/legal/new'
      preLoaderRoute: typeof adminLegalNewIndexRouteImport
      parentRoute: typeof adminLegalIndexRoute
    }
    '/admin/listing-review/': {
      id: '/admin/listing-review/'
      path: '/'
      fullPath: '/admin/listing-review/'
      preLoaderRoute: typeof adminListingReviewChar43ListingReviewOverviewPageRouteImport
      parentRoute: typeof adminListingReviewIndexRoute
    }
    '/admin/members/': {
      id: '/admin/members/'
      path: '/'
      fullPath: '/admin/members/'
      preLoaderRoute: typeof adminMembersChar43MembersPageRouteImport
      parentRoute: typeof adminMembersIndexRoute
    }
    '/admin/members/$memberId': {
      id: '/admin/members/$memberId'
      path: '/$memberId'
      fullPath: '/admin/members/$memberId'
      preLoaderRoute: typeof adminMembersChar91memberIdChar93IndexRouteImport
      parentRoute: typeof adminMembersIndexRoute
    }
    '/admin/reports/$countryCode': {
      id: '/admin/reports/$countryCode'
      path: '/reports/$countryCode'
      fullPath: '/admin/reports/$countryCode'
      preLoaderRoute: typeof adminReportsIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/resources/': {
      id: '/admin/resources/'
      path: '/'
      fullPath: '/admin/resources/'
      preLoaderRoute: typeof adminResourcesChar43ResourcesPageRouteImport
      parentRoute: typeof adminResourcesIndexRoute
    }
    '/admin/resources/$resourceId': {
      id: '/admin/resources/$resourceId'
      path: '/$resourceId'
      fullPath: '/admin/resources/$resourceId'
      preLoaderRoute: typeof adminResourcesChar91resourceIdChar93IndexRouteImport
      parentRoute: typeof adminResourcesIndexRoute
    }
    '/admin/suppliers/': {
      id: '/admin/suppliers/'
      path: '/'
      fullPath: '/admin/suppliers/'
      preLoaderRoute: typeof adminSuppliersChar43SuppliersPageRouteImport
      parentRoute: typeof adminSuppliersIndexRoute
    }
    '/admin/suppliers/$supplierId': {
      id: '/admin/suppliers/$supplierId'
      path: '/$supplierId'
      fullPath: '/admin/suppliers/$supplierId'
      preLoaderRoute: typeof adminSuppliersChar91supplierIdChar93IndexRouteImport
      parentRoute: typeof adminSuppliersIndexRoute
    }
    '/admin/supporters/': {
      id: '/admin/supporters/'
      path: '/'
      fullPath: '/admin/supporters/'
      preLoaderRoute: typeof adminSupportersChar43SupportersPageRouteImport
      parentRoute: typeof adminSupportersIndexRoute
    }
    '/admin/supporters/$supporterId': {
      id: '/admin/supporters/$supporterId'
      path: '/$supporterId'
      fullPath: '/admin/supporters/$supporterId'
      preLoaderRoute: typeof adminSupportersChar91supporterIdChar93IndexRouteImport
      parentRoute: typeof adminSupportersIndexRoute
    }
    '/campaigns/segments/': {
      id: '/campaigns/segments/'
      path: '/segments'
      fullPath: '/campaigns/segments/'
      preLoaderRoute: typeof campaignsSegmentsChar43SegmentsPageRouteImport
      parentRoute: typeof campaignsChar43LayoutRoute
    }
    '/campaigns/segments/$segmentId': {
      id: '/campaigns/segments/$segmentId'
      path: '/segments/$segmentId'
      fullPath: '/campaigns/segments/$segmentId'
      preLoaderRoute: typeof campaignsSegmentsChar43SegmentEditorRouteImport
      parentRoute: typeof campaignsChar43LayoutRoute
    }
    '/campaigns/sends/': {
      id: '/campaigns/sends/'
      path: '/sends'
      fullPath: '/campaigns/sends/'
      preLoaderRoute: typeof campaignsSendsChar43SendsPageRouteImport
      parentRoute: typeof campaignsChar43LayoutRoute
    }
    '/campaigns/sends/$sendId': {
      id: '/campaigns/sends/$sendId'
      path: '/sends/$sendId'
      fullPath: '/campaigns/sends/$sendId'
      preLoaderRoute: typeof campaignsSendsChar43SendDetailRouteImport
      parentRoute: typeof campaignsChar43LayoutRoute
    }
    '/campaigns/sends/new': {
      id: '/campaigns/sends/new'
      path: '/sends/new'
      fullPath: '/campaigns/sends/new'
      preLoaderRoute: typeof campaignsSendsChar43CreateSendRouteImport
      parentRoute: typeof campaignsChar43LayoutRoute
    }
    '/campaigns/templates/': {
      id: '/campaigns/templates/'
      path: '/templates'
      fullPath: '/campaigns/templates/'
      preLoaderRoute: typeof campaignsTemplatesChar43TemplatesPageRouteImport
      parentRoute: typeof campaignsChar43LayoutRoute
    }
    '/campaigns/templates/$templateId': {
      id: '/campaigns/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/campaigns/templates/$templateId'
      preLoaderRoute: typeof campaignsTemplatesChar43TemplateEditorRouteImport
      parentRoute: typeof campaignsChar43LayoutRoute
    }
    '/campaigns/unsubscribed/': {
      id: '/campaigns/unsubscribed/'
      path: '/unsubscribed'
      fullPath: '/campaigns/unsubscribed/'
      preLoaderRoute: typeof campaignsSuppressionChar43UnsubscribedListRouteImport
      parentRoute: typeof campaignsChar43LayoutRoute
    }
    '/supplier/$supplierId/': {
      id: '/supplier/$supplierId/'
      path: '/'
      fullPath: '/supplier/$supplierId/'
      preLoaderRoute: typeof supplierChar43SupplierHomeRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/bookings': {
      id: '/supplier/$supplierId/bookings'
      path: '/bookings'
      fullPath: '/supplier/$supplierId/bookings'
      preLoaderRoute: typeof supplierBookingsIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/eap': {
      id: '/supplier/$supplierId/eap'
      path: '/eap'
      fullPath: '/supplier/$supplierId/eap'
      preLoaderRoute: typeof supplierEapIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/eap-review': {
      id: '/supplier/$supplierId/eap-review'
      path: '/eap-review'
      fullPath: '/supplier/$supplierId/eap-review'
      preLoaderRoute: typeof supplierEapReviewChar43ReviewListRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/listings': {
      id: '/supplier/$supplierId/listings'
      path: '/listings'
      fullPath: '/supplier/$supplierId/listings'
      preLoaderRoute: typeof supplierListingsIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/messages': {
      id: '/supplier/$supplierId/messages'
      path: '/messages'
      fullPath: '/supplier/$supplierId/messages'
      preLoaderRoute: typeof supplierMessagesIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/orders': {
      id: '/supplier/$supplierId/orders'
      path: '/orders'
      fullPath: '/supplier/$supplierId/orders'
      preLoaderRoute: typeof supplierOrdersIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/passes': {
      id: '/supplier/$supplierId/passes'
      path: '/passes'
      fullPath: '/supplier/$supplierId/passes'
      preLoaderRoute: typeof supplierPassesIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/payments': {
      id: '/supplier/$supplierId/payments'
      path: '/payments'
      fullPath: '/supplier/$supplierId/payments'
      preLoaderRoute: typeof supplierPaymentsIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/sales': {
      id: '/supplier/$supplierId/sales'
      path: '/sales'
      fullPath: '/supplier/$supplierId/sales'
      preLoaderRoute: typeof supplierSalesIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/settings': {
      id: '/supplier/$supplierId/settings'
      path: '/settings'
      fullPath: '/supplier/$supplierId/settings'
      preLoaderRoute: typeof supplierSettingsIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/sku': {
      id: '/supplier/$supplierId/sku'
      path: '/sku'
      fullPath: '/supplier/$supplierId/sku'
      preLoaderRoute: typeof supplierSkuIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/subscriptions': {
      id: '/supplier/$supplierId/subscriptions'
      path: '/subscriptions'
      fullPath: '/supplier/$supplierId/subscriptions'
      preLoaderRoute: typeof supplierSubscriptionsIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supplier/$supplierId/user-settings': {
      id: '/supplier/$supplierId/user-settings'
      path: '/user-settings'
      fullPath: '/supplier/$supplierId/user-settings'
      preLoaderRoute: typeof supplierUserSettingsIndexRouteImport
      parentRoute: typeof supplierChar43LayoutRoute
    }
    '/supporter/$supporterId/': {
      id: '/supporter/$supporterId/'
      path: '/'
      fullPath: '/supporter/$supporterId/'
      preLoaderRoute: typeof supporterChar43SupporterHomeRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/supporter/$supporterId/admins': {
      id: '/supporter/$supporterId/admins'
      path: '/admins'
      fullPath: '/supporter/$supporterId/admins'
      preLoaderRoute: typeof supporterAdminsIndexRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/supporter/$supporterId/allowance-reports': {
      id: '/supporter/$supporterId/allowance-reports'
      path: '/allowance-reports'
      fullPath: '/supporter/$supporterId/allowance-reports'
      preLoaderRoute: typeof supporterAllowanceReportsChar43LayoutRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/supporter/$supporterId/allowances': {
      id: '/supporter/$supporterId/allowances'
      path: '/allowances'
      fullPath: '/supporter/$supporterId/allowances'
      preLoaderRoute: typeof supporterAllowancesIndexRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/supporter/$supporterId/eap': {
      id: '/supporter/$supporterId/eap'
      path: '/eap'
      fullPath: '/supporter/$supporterId/eap'
      preLoaderRoute: typeof supporterEapIndexRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/supporter/$supporterId/financial-reports': {
      id: '/supporter/$supporterId/financial-reports'
      path: '/financial-reports'
      fullPath: '/supporter/$supporterId/financial-reports'
      preLoaderRoute: typeof supporterFinancialReportsChar43reportsRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/supporter/$supporterId/history': {
      id: '/supporter/$supporterId/history'
      path: '/history'
      fullPath: '/supporter/$supporterId/history'
      preLoaderRoute: typeof supporterHistoryIndexRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/supporter/$supporterId/reports': {
      id: '/supporter/$supporterId/reports'
      path: '/reports'
      fullPath: '/supporter/$supporterId/reports'
      preLoaderRoute: typeof supporterReportsIndexRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/supporter/$supporterId/settings': {
      id: '/supporter/$supporterId/settings'
      path: '/settings'
      fullPath: '/supporter/$supporterId/settings'
      preLoaderRoute: typeof supporterSettingsChar43routeRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/supporter/$supporterId/team': {
      id: '/supporter/$supporterId/team'
      path: '/team'
      fullPath: '/supporter/$supporterId/team'
      preLoaderRoute: typeof supporterTeamIndexRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/supporter/$supporterId/user-settings': {
      id: '/supporter/$supporterId/user-settings'
      path: '/user-settings'
      fullPath: '/supporter/$supporterId/user-settings'
      preLoaderRoute: typeof supporterUserSettingsIndexRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/admin/listing-review/$listingId/$version': {
      id: '/admin/listing-review/$listingId/$version'
      path: '/$listingId/$version'
      fullPath: '/admin/listing-review/$listingId/$version'
      preLoaderRoute: typeof adminListingReviewChar43ListingReviewPageRouteImport
      parentRoute: typeof adminListingReviewIndexRoute
    }
    '/admin/members/$memberId/new-claim': {
      id: '/admin/members/$memberId/new-claim'
      path: '/members/$memberId/new-claim'
      fullPath: '/admin/members/$memberId/new-claim'
      preLoaderRoute: typeof adminMembersChar91memberIdChar93NewClaimIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/members/$memberId/new-purchase': {
      id: '/admin/members/$memberId/new-purchase'
      path: '/members/$memberId/new-purchase'
      fullPath: '/admin/members/$memberId/new-purchase'
      preLoaderRoute: typeof adminMembersChar91memberIdChar93NewPurchaseIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/members/$memberId/transactions': {
      id: '/admin/members/$memberId/transactions'
      path: '/members/$memberId/transactions'
      fullPath: '/admin/members/$memberId/transactions'
      preLoaderRoute: typeof adminMembersChar91memberIdChar93TransactionsIndexRouteImport
      parentRoute: typeof adminChar43LayoutRoute
    }
    '/admin/reports/$countryCode/card-payments': {
      id: '/admin/reports/$countryCode/card-payments'
      path: '/card-payments'
      fullPath: '/admin/reports/$countryCode/card-payments'
      preLoaderRoute: typeof adminReportsChar43cardPaymentsRouteImport
      parentRoute: typeof adminReportsIndexRoute
    }
    '/admin/reports/$countryCode/current-supporters': {
      id: '/admin/reports/$countryCode/current-supporters'
      path: '/current-supporters'
      fullPath: '/admin/reports/$countryCode/current-supporters'
      preLoaderRoute: typeof adminReportsChar43CurrentSupportersReportPageRouteImport
      parentRoute: typeof adminReportsIndexRoute
    }
    '/admin/reports/$countryCode/daily-payouts': {
      id: '/admin/reports/$countryCode/daily-payouts'
      path: '/daily-payouts'
      fullPath: '/admin/reports/$countryCode/daily-payouts'
      preLoaderRoute: typeof adminReportsDailyPayoutsChar43layoutRouteImport
      parentRoute: typeof adminReportsIndexRoute
    }
    '/admin/reports/$countryCode/eap-arrears': {
      id: '/admin/reports/$countryCode/eap-arrears'
      path: '/eap-arrears'
      fullPath: '/admin/reports/$countryCode/eap-arrears'
      preLoaderRoute: typeof adminReportsEapChar43SupporterEapArrearsPageRouteImport
      parentRoute: typeof adminReportsIndexRoute
    }
    '/admin/reports/$countryCode/eap-quality': {
      id: '/admin/reports/$countryCode/eap-quality'
      path: '/eap-quality'
      fullPath: '/admin/reports/$countryCode/eap-quality'
      preLoaderRoute: typeof adminReportsEapChar43EapListingQuailityReviewRouteImport
      parentRoute: typeof adminReportsIndexRoute
    }
    '/admin/reports/$countryCode/eap-requests': {
      id: '/admin/reports/$countryCode/eap-requests'
      path: '/eap-requests'
      fullPath: '/admin/reports/$countryCode/eap-requests'
      preLoaderRoute: typeof adminReportsEapChar43EapSessionRequestsPageRouteImport
      parentRoute: typeof adminReportsIndexRoute
    }
    '/admin/reports/$countryCode/eap-unclosed-sessions': {
      id: '/admin/reports/$countryCode/eap-unclosed-sessions'
      path: '/eap-unclosed-sessions'
      fullPath: '/admin/reports/$countryCode/eap-unclosed-sessions'
      preLoaderRoute: typeof adminReportsEapChar43EapUnclosedSessionsPageRouteImport
      parentRoute: typeof adminReportsIndexRoute
    }
    '/admin/reports/$countryCode/member-subscriptions': {
      id: '/admin/reports/$countryCode/member-subscriptions'
      path: '/member-subscriptions'
      fullPath: '/admin/reports/$countryCode/member-subscriptions'
      preLoaderRoute: typeof adminReportsChar43MemberSubscriptionsReportPageRouteImport
      parentRoute: typeof adminReportsIndexRoute
    }
    '/admin/reports/$countryCode/projected-mrr': {
      id: '/admin/reports/$countryCode/projected-mrr'
      path: '/projected-mrr'
      fullPath: '/admin/reports/$countryCode/projected-mrr'
      preLoaderRoute: typeof adminReportsChar43projectedMrrRouteImport
      parentRoute: typeof adminReportsIndexRoute
    }
    '/admin/reports/$countryCode/supporter': {
      id: '/admin/reports/$countryCode/supporter'
      path: '/supporter'
      fullPath: '/admin/reports/$countryCode/supporter'
      preLoaderRoute: typeof adminReportsChar43SupporterMonthlyStatsReportPageRouteImport
      parentRoute: typeof adminReportsIndexRoute
    }
    '/admin/reports/$countryCode/supporter-sales': {
      id: '/admin/reports/$countryCode/supporter-sales'
      path: '/supporter-sales'
      fullPath: '/admin/reports/$countryCode/supporter-sales'
      preLoaderRoute: typeof adminReportsChar43SupporterSalesReportPageRouteImport
      parentRoute: typeof adminReportsIndexRoute
    }
    '/admin/suppliers/$supplierId/': {
      id: '/admin/suppliers/$supplierId/'
      path: '/'
      fullPath: '/admin/suppliers/$supplierId/'
      preLoaderRoute: typeof adminSuppliersChar91supplierIdChar93Char43SupplierPageRouteImport
      parentRoute: typeof adminSuppliersChar91supplierIdChar93IndexRoute
    }
    '/admin/suppliers/$supplierId/calendars': {
      id: '/admin/suppliers/$supplierId/calendars'
      path: '/calendars'
      fullPath: '/admin/suppliers/$supplierId/calendars'
      preLoaderRoute: typeof adminSuppliersChar91supplierIdChar93CalendarsIndexRouteImport
      parentRoute: typeof adminSuppliersChar91supplierIdChar93IndexRoute
    }
    '/admin/suppliers/$supplierId/locations': {
      id: '/admin/suppliers/$supplierId/locations'
      path: '/locations'
      fullPath: '/admin/suppliers/$supplierId/locations'
      preLoaderRoute: typeof adminSuppliersChar91supplierIdChar93LocationsIndexRouteImport
      parentRoute: typeof adminSuppliersChar91supplierIdChar93IndexRoute
    }
    '/admin/suppliers/$supplierId/settings': {
      id: '/admin/suppliers/$supplierId/settings'
      path: '/settings'
      fullPath: '/admin/suppliers/$supplierId/settings'
      preLoaderRoute: typeof adminSuppliersChar91supplierIdChar93SettingsIndexRouteImport
      parentRoute: typeof adminSuppliersChar91supplierIdChar93IndexRoute
    }
    '/admin/supporters/$supporterId/': {
      id: '/admin/supporters/$supporterId/'
      path: '/'
      fullPath: '/admin/supporters/$supporterId/'
      preLoaderRoute: typeof adminSupportersChar91supporterIdChar93Char43SupporterPageRouteImport
      parentRoute: typeof adminSupportersChar91supporterIdChar93IndexRoute
    }
    '/admin/supporters/$supporterId/billing': {
      id: '/admin/supporters/$supporterId/billing'
      path: '/billing'
      fullPath: '/admin/supporters/$supporterId/billing'
      preLoaderRoute: typeof adminSupportersChar91supporterIdChar93Char43BillingPageRouteImport
      parentRoute: typeof adminSupportersChar91supporterIdChar93IndexRoute
    }
    '/admin/supporters/$supporterId/eap': {
      id: '/admin/supporters/$supporterId/eap'
      path: '/eap'
      fullPath: '/admin/supporters/$supporterId/eap'
      preLoaderRoute: typeof adminSupportersChar91supporterIdChar93Char43EAPPageRouteImport
      parentRoute: typeof adminSupportersChar91supporterIdChar93IndexRoute
    }
    '/admin/supporters/$supporterId/note': {
      id: '/admin/supporters/$supporterId/note'
      path: '/note'
      fullPath: '/admin/supporters/$supporterId/note'
      preLoaderRoute: typeof adminSupportersChar91supporterIdChar93Char43NotePageRouteImport
      parentRoute: typeof adminSupportersChar91supporterIdChar93IndexRoute
    }
    '/admin/supporters/$supporterId/settings': {
      id: '/admin/supporters/$supporterId/settings'
      path: '/settings'
      fullPath: '/admin/supporters/$supporterId/settings'
      preLoaderRoute: typeof adminSupportersChar91supporterIdChar93Char43SettingsPageRouteImport
      parentRoute: typeof adminSupportersChar91supporterIdChar93IndexRoute
    }
    '/supplier/$supplierId/eap-review/': {
      id: '/supplier/$supplierId/eap-review/'
      path: '/'
      fullPath: '/supplier/$supplierId/eap-review/'
      preLoaderRoute: typeof supplierEapReviewIndexRouteImport
      parentRoute: typeof supplierEapReviewChar43ReviewListRoute
    }
    '/supplier/$supplierId/eap-review/$purchaseId': {
      id: '/supplier/$supplierId/eap-review/$purchaseId'
      path: '/$purchaseId'
      fullPath: '/supplier/$supplierId/eap-review/$purchaseId'
      preLoaderRoute: typeof supplierEapReviewChar91purchaseIdChar93IndexRouteImport
      parentRoute: typeof supplierEapReviewChar43ReviewListRoute
    }
    '/supplier/$supplierId/eap/': {
      id: '/supplier/$supplierId/eap/'
      path: '/'
      fullPath: '/supplier/$supplierId/eap/'
      preLoaderRoute: typeof supplierEapChar43EAPListRouteImport
      parentRoute: typeof supplierEapIndexRoute
    }
    '/supplier/$supplierId/eap/new': {
      id: '/supplier/$supplierId/eap/new'
      path: '/supplier/$supplierId/eap/new'
      fullPath: '/supplier/$supplierId/eap/new'
      preLoaderRoute: typeof supplierEapNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supplier/$supplierId/listings/': {
      id: '/supplier/$supplierId/listings/'
      path: '/'
      fullPath: '/supplier/$supplierId/listings/'
      preLoaderRoute: typeof supplierListingsChar43ListingsPageRouteImport
      parentRoute: typeof supplierListingsIndexRoute
    }
    '/supplier/$supplierId/listings/new': {
      id: '/supplier/$supplierId/listings/new'
      path: '/supplier/$supplierId/listings/new'
      fullPath: '/supplier/$supplierId/listings/new'
      preLoaderRoute: typeof supplierListingsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supplier/$supplierId/messages/': {
      id: '/supplier/$supplierId/messages/'
      path: '/'
      fullPath: '/supplier/$supplierId/messages/'
      preLoaderRoute: typeof supplierMessagesChar43MessagesRouteImport
      parentRoute: typeof supplierMessagesIndexRoute
    }
    '/supplier/$supplierId/messages/$conversationId': {
      id: '/supplier/$supplierId/messages/$conversationId'
      path: '/$conversationId'
      fullPath: '/supplier/$supplierId/messages/$conversationId'
      preLoaderRoute: typeof supplierMessagesChar91conversationIdChar93IndexRouteImport
      parentRoute: typeof supplierMessagesIndexRoute
    }
    '/supplier/$supplierId/sales/': {
      id: '/supplier/$supplierId/sales/'
      path: '/'
      fullPath: '/supplier/$supplierId/sales/'
      preLoaderRoute: typeof supplierSalesChar43SupplierSalesRouteImport
      parentRoute: typeof supplierSalesIndexRoute
    }
    '/supplier/$supplierId/sales/$purchaseId': {
      id: '/supplier/$supplierId/sales/$purchaseId'
      path: '/$purchaseId'
      fullPath: '/supplier/$supplierId/sales/$purchaseId'
      preLoaderRoute: typeof supplierSalesChar91purchaseIdChar93IndexRouteImport
      parentRoute: typeof supplierSalesIndexRoute
    }
    '/supplier/$supplierId/settings/': {
      id: '/supplier/$supplierId/settings/'
      path: '/'
      fullPath: '/supplier/$supplierId/settings/'
      preLoaderRoute: typeof supplierSettingsProfileIndexRouteImport
      parentRoute: typeof supplierSettingsIndexRoute
    }
    '/supplier/$supplierId/settings/automations': {
      id: '/supplier/$supplierId/settings/automations'
      path: '/automations'
      fullPath: '/supplier/$supplierId/settings/automations'
      preLoaderRoute: typeof supplierSettingsAutomationsIndexRouteImport
      parentRoute: typeof supplierSettingsIndexRoute
    }
    '/supplier/$supplierId/settings/business': {
      id: '/supplier/$supplierId/settings/business'
      path: '/business'
      fullPath: '/supplier/$supplierId/settings/business'
      preLoaderRoute: typeof supplierSettingsBusinessIndexRouteImport
      parentRoute: typeof supplierSettingsIndexRoute
    }
    '/supplier/$supplierId/settings/calendars': {
      id: '/supplier/$supplierId/settings/calendars'
      path: '/calendars'
      fullPath: '/supplier/$supplierId/settings/calendars'
      preLoaderRoute: typeof supplierSettingsCalendarsIndexRouteImport
      parentRoute: typeof supplierSettingsIndexRoute
    }
    '/supplier/$supplierId/settings/givenwell-terms': {
      id: '/supplier/$supplierId/settings/givenwell-terms'
      path: '/givenwell-terms'
      fullPath: '/supplier/$supplierId/settings/givenwell-terms'
      preLoaderRoute: typeof supplierSettingsGivenwellTermsIndexRouteImport
      parentRoute: typeof supplierSettingsIndexRoute
    }
    '/supplier/$supplierId/settings/legal': {
      id: '/supplier/$supplierId/settings/legal'
      path: '/legal'
      fullPath: '/supplier/$supplierId/settings/legal'
      preLoaderRoute: typeof supplierSettingsLegalIndexRouteImport
      parentRoute: typeof supplierSettingsIndexRoute
    }
    '/supplier/$supplierId/settings/locations': {
      id: '/supplier/$supplierId/settings/locations'
      path: '/locations'
      fullPath: '/supplier/$supplierId/settings/locations'
      preLoaderRoute: typeof supplierSettingsLocationsIndexRouteImport
      parentRoute: typeof supplierSettingsIndexRoute
    }
    '/supplier/$supplierId/settings/markets': {
      id: '/supplier/$supplierId/settings/markets'
      path: '/markets'
      fullPath: '/supplier/$supplierId/settings/markets'
      preLoaderRoute: typeof supplierSettingsMarketsIndexRouteImport
      parentRoute: typeof supplierSettingsIndexRoute
    }
    '/supplier/$supplierId/settings/payment': {
      id: '/supplier/$supplierId/settings/payment'
      path: '/payment'
      fullPath: '/supplier/$supplierId/settings/payment'
      preLoaderRoute: typeof supplierSettingsPaymentIndexRouteImport
      parentRoute: typeof supplierSettingsIndexRoute
    }
    '/supplier/$supplierId/settings/refunds': {
      id: '/supplier/$supplierId/settings/refunds'
      path: '/refunds'
      fullPath: '/supplier/$supplierId/settings/refunds'
      preLoaderRoute: typeof supplierSettingsRefundIndexRouteImport
      parentRoute: typeof supplierSettingsIndexRoute
    }
    '/supplier/$supplierId/settings/team': {
      id: '/supplier/$supplierId/settings/team'
      path: '/team'
      fullPath: '/supplier/$supplierId/settings/team'
      preLoaderRoute: typeof supplierSettingsTeamIndexRouteImport
      parentRoute: typeof supplierSettingsIndexRoute
    }
    '/supporter/$supporterId/admins/$userId': {
      id: '/supporter/$supporterId/admins/$userId'
      path: '/admins/$userId'
      fullPath: '/supporter/$supporterId/admins/$userId'
      preLoaderRoute: typeof supporterAdminsChar91userIdChar93IndexRouteImport
      parentRoute: typeof supporterChar43LayoutRoute
    }
    '/supporter/$supporterId/allowance-reports/': {
      id: '/supporter/$supporterId/allowance-reports/'
      path: '/'
      fullPath: '/supporter/$supporterId/allowance-reports/'
      preLoaderRoute: typeof supporterAllowanceReportsChar43indexRouteImport
      parentRoute: typeof supporterAllowanceReportsChar43LayoutRoute
    }
    '/supporter/$supporterId/allowance-reports/forecast': {
      id: '/supporter/$supporterId/allowance-reports/forecast'
      path: '/forecast'
      fullPath: '/supporter/$supporterId/allowance-reports/forecast'
      preLoaderRoute: typeof supporterAllowanceReportsForecastIndexRouteImport
      parentRoute: typeof supporterAllowanceReportsChar43LayoutRoute
    }
    '/supporter/$supporterId/allowance-reports/insights': {
      id: '/supporter/$supporterId/allowance-reports/insights'
      path: '/insights'
      fullPath: '/supporter/$supporterId/allowance-reports/insights'
      preLoaderRoute: typeof supporterAllowanceReportsInsightsIndexRouteImport
      parentRoute: typeof supporterAllowanceReportsChar43LayoutRoute
    }
    '/supporter/$supporterId/allowance-reports/spend': {
      id: '/supporter/$supporterId/allowance-reports/spend'
      path: '/spend'
      fullPath: '/supporter/$supporterId/allowance-reports/spend'
      preLoaderRoute: typeof supporterAllowanceReportsSpendIndexRouteImport
      parentRoute: typeof supporterAllowanceReportsChar43LayoutRoute
    }
    '/supporter/$supporterId/allowance-reports/utilisation': {
      id: '/supporter/$supporterId/allowance-reports/utilisation'
      path: '/utilisation'
      fullPath: '/supporter/$supporterId/allowance-reports/utilisation'
      preLoaderRoute: typeof supporterAllowanceReportsUtilisationIndexRouteImport
      parentRoute: typeof supporterAllowanceReportsChar43LayoutRoute
    }
    '/supporter/$supporterId/eap/': {
      id: '/supporter/$supporterId/eap/'
      path: '/'
      fullPath: '/supporter/$supporterId/eap/'
      preLoaderRoute: typeof supporterEapChar43EAPRouteImport
      parentRoute: typeof supporterEapIndexRoute
    }
    '/supporter/$supporterId/eap/settings': {
      id: '/supporter/$supporterId/eap/settings'
      path: '/settings'
      fullPath: '/supporter/$supporterId/eap/settings'
      preLoaderRoute: typeof supporterEapSettingsIndexRouteImport
      parentRoute: typeof supporterEapIndexRoute
    }
    '/supporter/$supporterId/financial-reports/': {
      id: '/supporter/$supporterId/financial-reports/'
      path: '/'
      fullPath: '/supporter/$supporterId/financial-reports/'
      preLoaderRoute: typeof supporterFinancialReportsChar43indexRouteImport
      parentRoute: typeof supporterFinancialReportsChar43reportsRoute
    }
    '/supporter/$supporterId/financial-reports/invoices': {
      id: '/supporter/$supporterId/financial-reports/invoices'
      path: '/invoices'
      fullPath: '/supporter/$supporterId/financial-reports/invoices'
      preLoaderRoute: typeof supporterFinancialReportsInvoicesIndexRouteImport
      parentRoute: typeof supporterFinancialReportsChar43reportsRoute
    }
    '/supporter/$supporterId/financial-reports/transactions': {
      id: '/supporter/$supporterId/financial-reports/transactions'
      path: '/transactions'
      fullPath: '/supporter/$supporterId/financial-reports/transactions'
      preLoaderRoute: typeof supporterFinancialReportsTransactionsIndexRouteImport
      parentRoute: typeof supporterFinancialReportsChar43reportsRoute
    }
    '/supporter/$supporterId/settings/': {
      id: '/supporter/$supporterId/settings/'
      path: '/'
      fullPath: '/supporter/$supporterId/settings/'
      preLoaderRoute: typeof supporterSettingsChar43indexRouteImport
      parentRoute: typeof supporterSettingsChar43routeRoute
    }
    '/supporter/$supporterId/settings/billing': {
      id: '/supporter/$supporterId/settings/billing'
      path: '/billing'
      fullPath: '/supporter/$supporterId/settings/billing'
      preLoaderRoute: typeof supporterSettingsBillingIndexRouteImport
      parentRoute: typeof supporterSettingsChar43routeRoute
    }
    '/supporter/$supporterId/settings/countries': {
      id: '/supporter/$supporterId/settings/countries'
      path: '/countries'
      fullPath: '/supporter/$supporterId/settings/countries'
      preLoaderRoute: typeof supporterSettingsCountriesIndexRouteImport
      parentRoute: typeof supporterSettingsChar43routeRoute
    }
    '/supporter/$supporterId/settings/givenwell-terms': {
      id: '/supporter/$supporterId/settings/givenwell-terms'
      path: '/givenwell-terms'
      fullPath: '/supporter/$supporterId/settings/givenwell-terms'
      preLoaderRoute: typeof supporterSettingsGivenwellTermsIndexRouteImport
      parentRoute: typeof supporterSettingsChar43routeRoute
    }
    '/admin/reports/$countryCode/daily-payouts/': {
      id: '/admin/reports/$countryCode/daily-payouts/'
      path: '/'
      fullPath: '/admin/reports/$countryCode/daily-payouts/'
      preLoaderRoute: typeof adminReportsDailyPayoutsChar43DailyPayoutsRouteImport
      parentRoute: typeof adminReportsDailyPayoutsChar43layoutRoute
    }
    '/admin/reports/$countryCode/daily-payouts/detail': {
      id: '/admin/reports/$countryCode/daily-payouts/detail'
      path: '/detail'
      fullPath: '/admin/reports/$countryCode/daily-payouts/detail'
      preLoaderRoute: typeof adminReportsDailyPayoutsChar43DailyPayoutsDetailRouteImport
      parentRoute: typeof adminReportsDailyPayoutsChar43layoutRoute
    }
    '/supplier/$supplierId/eap/$listingId/$version': {
      id: '/supplier/$supplierId/eap/$listingId/$version'
      path: '/$listingId/$version'
      fullPath: '/supplier/$supplierId/eap/$listingId/$version'
      preLoaderRoute: typeof supplierEapChar91listingIdChar93Char43pageRouteImport
      parentRoute: typeof supplierEapIndexRoute
    }
    '/supplier/$supplierId/listings/$listingId/$version': {
      id: '/supplier/$supplierId/listings/$listingId/$version'
      path: '/$listingId/$version'
      fullPath: '/supplier/$supplierId/listings/$listingId/$version'
      preLoaderRoute: typeof supplierListingsChar91listingIdChar93Char43EditListingPageRouteImport
      parentRoute: typeof supplierListingsIndexRoute
    }
    '/supplier/$supplierId/settings/calendars/': {
      id: '/supplier/$supplierId/settings/calendars/'
      path: '/'
      fullPath: '/supplier/$supplierId/settings/calendars/'
      preLoaderRoute: typeof supplierSettingsCalendarsChar43CalendarSettingsRouteImport
      parentRoute: typeof supplierSettingsCalendarsIndexRoute
    }
    '/supplier/$supplierId/settings/calendars/$calendarId': {
      id: '/supplier/$supplierId/settings/calendars/$calendarId'
      path: '/$calendarId'
      fullPath: '/supplier/$supplierId/settings/calendars/$calendarId'
      preLoaderRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93IndexRouteImport
      parentRoute: typeof supplierSettingsCalendarsIndexRoute
    }
    '/supplier/$supplierId/settings/refunds/': {
      id: '/supplier/$supplierId/settings/refunds/'
      path: '/'
      fullPath: '/supplier/$supplierId/settings/refunds/'
      preLoaderRoute: typeof supplierSettingsRefundChar43RefundSettingsRouteImport
      parentRoute: typeof supplierSettingsRefundIndexRoute
    }
    '/supplier/$supplierId/settings/team/': {
      id: '/supplier/$supplierId/settings/team/'
      path: '/'
      fullPath: '/supplier/$supplierId/settings/team/'
      preLoaderRoute: typeof supplierSettingsTeamChar43TeamTableRouteImport
      parentRoute: typeof supplierSettingsTeamIndexRoute
    }
    '/supporter/$supporterId/eap/requests/': {
      id: '/supporter/$supporterId/eap/requests/'
      path: '/requests'
      fullPath: '/supporter/$supporterId/eap/requests/'
      preLoaderRoute: typeof supporterEapRequestsIndexRouteImport
      parentRoute: typeof supporterEapIndexRoute
    }
    '/supporter/$supporterId/eap/requests/$requestId': {
      id: '/supporter/$supporterId/eap/requests/$requestId'
      path: '/requests/$requestId'
      fullPath: '/supporter/$supporterId/eap/requests/$requestId'
      preLoaderRoute: typeof supporterEapRequestsChar91requestIdChar93IndexRouteImport
      parentRoute: typeof supporterEapIndexRoute
    }
    '/supporter/$supporterId/financial-reports/transactions/': {
      id: '/supporter/$supporterId/financial-reports/transactions/'
      path: '/'
      fullPath: '/supporter/$supporterId/financial-reports/transactions/'
      preLoaderRoute: typeof supporterFinancialReportsTransactionsChar43WalletRouteImport
      parentRoute: typeof supporterFinancialReportsTransactionsIndexRoute
    }
    '/supplier/$supplierId/listings/$listingId/$version/': {
      id: '/supplier/$supplierId/listings/$listingId/$version/'
      path: '/'
      fullPath: '/supplier/$supplierId/listings/$listingId/$version/'
      preLoaderRoute: typeof supplierListingsChar91listingIdChar93Char43indexRouteImport
      parentRoute: typeof supplierListingsChar91listingIdChar93Char43EditListingPageRoute
    }
    '/supplier/$supplierId/listings/$listingId/$version/variants': {
      id: '/supplier/$supplierId/listings/$listingId/$version/variants'
      path: '/variants'
      fullPath: '/supplier/$supplierId/listings/$listingId/$version/variants'
      preLoaderRoute: typeof supplierListingsChar91listingIdChar93Char43variantsRouteImport
      parentRoute: typeof supplierListingsChar91listingIdChar93Char43EditListingPageRoute
    }
    '/supplier/$supplierId/settings/calendars/$calendarId/': {
      id: '/supplier/$supplierId/settings/calendars/$calendarId/'
      path: '/'
      fullPath: '/supplier/$supplierId/settings/calendars/$calendarId/'
      preLoaderRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93Char43EditCalendarSettingsRouteImport
      parentRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93IndexRoute
    }
    '/supplier/$supplierId/settings/calendars/$calendarId/connect': {
      id: '/supplier/$supplierId/settings/calendars/$calendarId/connect'
      path: '/connect'
      fullPath: '/supplier/$supplierId/settings/calendars/$calendarId/connect'
      preLoaderRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93ConnectIndexRouteImport
      parentRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93IndexRoute
    }
    '/supplier/$supplierId/settings/calendars/$calendarId/disconnect': {
      id: '/supplier/$supplierId/settings/calendars/$calendarId/disconnect'
      path: '/disconnect'
      fullPath: '/supplier/$supplierId/settings/calendars/$calendarId/disconnect'
      preLoaderRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93DisconnectIndexRouteImport
      parentRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93IndexRoute
    }
    '/supplier/$supplierId/settings/calendars/$calendarId/external': {
      id: '/supplier/$supplierId/settings/calendars/$calendarId/external'
      path: '/external'
      fullPath: '/supplier/$supplierId/settings/calendars/$calendarId/external'
      preLoaderRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93ExternalIndexRouteImport
      parentRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93IndexRoute
    }
    '/supplier/$supplierId/settings/refunds/cancellation-policy/$policyId': {
      id: '/supplier/$supplierId/settings/refunds/cancellation-policy/$policyId'
      path: '/cancellation-policy/$policyId'
      fullPath: '/supplier/$supplierId/settings/refunds/cancellation-policy/$policyId'
      preLoaderRoute: typeof supplierSettingsRefundCancellationPolicyChar91policyIdChar93IndexRouteImport
      parentRoute: typeof supplierSettingsRefundIndexRoute
    }
    '/supporter/$supporterId/financial-reports/transactions/allowance/$batchId': {
      id: '/supporter/$supporterId/financial-reports/transactions/allowance/$batchId'
      path: '/allowance/$batchId'
      fullPath: '/supporter/$supporterId/financial-reports/transactions/allowance/$batchId'
      preLoaderRoute: typeof supporterFinancialReportsTransactionsAllowanceChar91batchIdChar93IndexRouteImport
      parentRoute: typeof supporterFinancialReportsTransactionsIndexRoute
    }
    '/supporter/$supporterId/financial-reports/transactions/details/$version': {
      id: '/supporter/$supporterId/financial-reports/transactions/details/$version'
      path: '/details/$version'
      fullPath: '/supporter/$supporterId/financial-reports/transactions/details/$version'
      preLoaderRoute: typeof supporterFinancialReportsTransactionsDetailsChar91versionChar93IndexRouteImport
      parentRoute: typeof supporterFinancialReportsTransactionsIndexRoute
    }
    '/supplier/$supplierId/listings/$listingId/$version/variants/$variantId': {
      id: '/supplier/$supplierId/listings/$listingId/$version/variants/$variantId'
      path: '/$variantId'
      fullPath: '/supplier/$supplierId/listings/$listingId/$version/variants/$variantId'
      preLoaderRoute: typeof supplierListingsChar91listingIdChar93Char43variantRouteImport
      parentRoute: typeof supplierListingsChar91listingIdChar93Char43variantsRoute
    }
  }
}

interface adminDevtoolsChar43LayoutRouteChildren {
  adminDevtoolsChar43DevToolsRoute: typeof adminDevtoolsChar43DevToolsRoute
  adminDevtoolsAirwallexIndexRoute: typeof adminDevtoolsAirwallexIndexRoute
  adminDevtoolsBillingSimIndexRoute: typeof adminDevtoolsBillingSimIndexRoute
  adminDevtoolsListingSelectorIndexRoute: typeof adminDevtoolsListingSelectorIndexRoute
  adminDevtoolsMemberLookupIndexRoute: typeof adminDevtoolsMemberLookupIndexRoute
  adminDevtoolsUiIndexRoute: typeof adminDevtoolsUiIndexRoute
}

const adminDevtoolsChar43LayoutRouteChildren: adminDevtoolsChar43LayoutRouteChildren =
  {
    adminDevtoolsChar43DevToolsRoute: adminDevtoolsChar43DevToolsRoute,
    adminDevtoolsAirwallexIndexRoute: adminDevtoolsAirwallexIndexRoute,
    adminDevtoolsBillingSimIndexRoute: adminDevtoolsBillingSimIndexRoute,
    adminDevtoolsListingSelectorIndexRoute:
      adminDevtoolsListingSelectorIndexRoute,
    adminDevtoolsMemberLookupIndexRoute: adminDevtoolsMemberLookupIndexRoute,
    adminDevtoolsUiIndexRoute: adminDevtoolsUiIndexRoute,
  }

const adminDevtoolsChar43LayoutRouteWithChildren =
  adminDevtoolsChar43LayoutRoute._addFileChildren(
    adminDevtoolsChar43LayoutRouteChildren,
  )

interface adminLegalIndexRouteChildren {
  adminLegalChar43LegalTermsListPageRoute: typeof adminLegalChar43LegalTermsListPageRoute
  adminLegalChar91termsIdChar93IndexRoute: typeof adminLegalChar91termsIdChar93IndexRoute
  adminLegalNewIndexRoute: typeof adminLegalNewIndexRoute
}

const adminLegalIndexRouteChildren: adminLegalIndexRouteChildren = {
  adminLegalChar43LegalTermsListPageRoute:
    adminLegalChar43LegalTermsListPageRoute,
  adminLegalChar91termsIdChar93IndexRoute:
    adminLegalChar91termsIdChar93IndexRoute,
  adminLegalNewIndexRoute: adminLegalNewIndexRoute,
}

const adminLegalIndexRouteWithChildren = adminLegalIndexRoute._addFileChildren(
  adminLegalIndexRouteChildren,
)

interface adminListingReviewIndexRouteChildren {
  adminListingReviewChar43ListingReviewOverviewPageRoute: typeof adminListingReviewChar43ListingReviewOverviewPageRoute
  adminListingReviewChar43ListingReviewPageRoute: typeof adminListingReviewChar43ListingReviewPageRoute
}

const adminListingReviewIndexRouteChildren: adminListingReviewIndexRouteChildren =
  {
    adminListingReviewChar43ListingReviewOverviewPageRoute:
      adminListingReviewChar43ListingReviewOverviewPageRoute,
    adminListingReviewChar43ListingReviewPageRoute:
      adminListingReviewChar43ListingReviewPageRoute,
  }

const adminListingReviewIndexRouteWithChildren =
  adminListingReviewIndexRoute._addFileChildren(
    adminListingReviewIndexRouteChildren,
  )

interface adminMembersIndexRouteChildren {
  adminMembersChar43MembersPageRoute: typeof adminMembersChar43MembersPageRoute
  adminMembersChar91memberIdChar93IndexRoute: typeof adminMembersChar91memberIdChar93IndexRoute
}

const adminMembersIndexRouteChildren: adminMembersIndexRouteChildren = {
  adminMembersChar43MembersPageRoute: adminMembersChar43MembersPageRoute,
  adminMembersChar91memberIdChar93IndexRoute:
    adminMembersChar91memberIdChar93IndexRoute,
}

const adminMembersIndexRouteWithChildren =
  adminMembersIndexRoute._addFileChildren(adminMembersIndexRouteChildren)

interface adminResourcesIndexRouteChildren {
  adminResourcesChar43ResourcesPageRoute: typeof adminResourcesChar43ResourcesPageRoute
  adminResourcesChar91resourceIdChar93IndexRoute: typeof adminResourcesChar91resourceIdChar93IndexRoute
}

const adminResourcesIndexRouteChildren: adminResourcesIndexRouteChildren = {
  adminResourcesChar43ResourcesPageRoute:
    adminResourcesChar43ResourcesPageRoute,
  adminResourcesChar91resourceIdChar93IndexRoute:
    adminResourcesChar91resourceIdChar93IndexRoute,
}

const adminResourcesIndexRouteWithChildren =
  adminResourcesIndexRoute._addFileChildren(adminResourcesIndexRouteChildren)

interface adminSuppliersChar91supplierIdChar93IndexRouteChildren {
  adminSuppliersChar91supplierIdChar93Char43SupplierPageRoute: typeof adminSuppliersChar91supplierIdChar93Char43SupplierPageRoute
  adminSuppliersChar91supplierIdChar93CalendarsIndexRoute: typeof adminSuppliersChar91supplierIdChar93CalendarsIndexRoute
  adminSuppliersChar91supplierIdChar93LocationsIndexRoute: typeof adminSuppliersChar91supplierIdChar93LocationsIndexRoute
  adminSuppliersChar91supplierIdChar93SettingsIndexRoute: typeof adminSuppliersChar91supplierIdChar93SettingsIndexRoute
}

const adminSuppliersChar91supplierIdChar93IndexRouteChildren: adminSuppliersChar91supplierIdChar93IndexRouteChildren =
  {
    adminSuppliersChar91supplierIdChar93Char43SupplierPageRoute:
      adminSuppliersChar91supplierIdChar93Char43SupplierPageRoute,
    adminSuppliersChar91supplierIdChar93CalendarsIndexRoute:
      adminSuppliersChar91supplierIdChar93CalendarsIndexRoute,
    adminSuppliersChar91supplierIdChar93LocationsIndexRoute:
      adminSuppliersChar91supplierIdChar93LocationsIndexRoute,
    adminSuppliersChar91supplierIdChar93SettingsIndexRoute:
      adminSuppliersChar91supplierIdChar93SettingsIndexRoute,
  }

const adminSuppliersChar91supplierIdChar93IndexRouteWithChildren =
  adminSuppliersChar91supplierIdChar93IndexRoute._addFileChildren(
    adminSuppliersChar91supplierIdChar93IndexRouteChildren,
  )

interface adminSuppliersIndexRouteChildren {
  adminSuppliersChar43SuppliersPageRoute: typeof adminSuppliersChar43SuppliersPageRoute
  adminSuppliersChar91supplierIdChar93IndexRoute: typeof adminSuppliersChar91supplierIdChar93IndexRouteWithChildren
}

const adminSuppliersIndexRouteChildren: adminSuppliersIndexRouteChildren = {
  adminSuppliersChar43SuppliersPageRoute:
    adminSuppliersChar43SuppliersPageRoute,
  adminSuppliersChar91supplierIdChar93IndexRoute:
    adminSuppliersChar91supplierIdChar93IndexRouteWithChildren,
}

const adminSuppliersIndexRouteWithChildren =
  adminSuppliersIndexRoute._addFileChildren(adminSuppliersIndexRouteChildren)

interface adminSupportersChar91supporterIdChar93IndexRouteChildren {
  adminSupportersChar91supporterIdChar93Char43SupporterPageRoute: typeof adminSupportersChar91supporterIdChar93Char43SupporterPageRoute
  adminSupportersChar91supporterIdChar93Char43BillingPageRoute: typeof adminSupportersChar91supporterIdChar93Char43BillingPageRoute
  adminSupportersChar91supporterIdChar93Char43EAPPageRoute: typeof adminSupportersChar91supporterIdChar93Char43EAPPageRoute
  adminSupportersChar91supporterIdChar93Char43NotePageRoute: typeof adminSupportersChar91supporterIdChar93Char43NotePageRoute
  adminSupportersChar91supporterIdChar93Char43SettingsPageRoute: typeof adminSupportersChar91supporterIdChar93Char43SettingsPageRoute
}

const adminSupportersChar91supporterIdChar93IndexRouteChildren: adminSupportersChar91supporterIdChar93IndexRouteChildren =
  {
    adminSupportersChar91supporterIdChar93Char43SupporterPageRoute:
      adminSupportersChar91supporterIdChar93Char43SupporterPageRoute,
    adminSupportersChar91supporterIdChar93Char43BillingPageRoute:
      adminSupportersChar91supporterIdChar93Char43BillingPageRoute,
    adminSupportersChar91supporterIdChar93Char43EAPPageRoute:
      adminSupportersChar91supporterIdChar93Char43EAPPageRoute,
    adminSupportersChar91supporterIdChar93Char43NotePageRoute:
      adminSupportersChar91supporterIdChar93Char43NotePageRoute,
    adminSupportersChar91supporterIdChar93Char43SettingsPageRoute:
      adminSupportersChar91supporterIdChar93Char43SettingsPageRoute,
  }

const adminSupportersChar91supporterIdChar93IndexRouteWithChildren =
  adminSupportersChar91supporterIdChar93IndexRoute._addFileChildren(
    adminSupportersChar91supporterIdChar93IndexRouteChildren,
  )

interface adminSupportersIndexRouteChildren {
  adminSupportersChar43SupportersPageRoute: typeof adminSupportersChar43SupportersPageRoute
  adminSupportersChar91supporterIdChar93IndexRoute: typeof adminSupportersChar91supporterIdChar93IndexRouteWithChildren
}

const adminSupportersIndexRouteChildren: adminSupportersIndexRouteChildren = {
  adminSupportersChar43SupportersPageRoute:
    adminSupportersChar43SupportersPageRoute,
  adminSupportersChar91supporterIdChar93IndexRoute:
    adminSupportersChar91supporterIdChar93IndexRouteWithChildren,
}

const adminSupportersIndexRouteWithChildren =
  adminSupportersIndexRoute._addFileChildren(adminSupportersIndexRouteChildren)

interface adminReportsDailyPayoutsChar43layoutRouteChildren {
  adminReportsDailyPayoutsChar43DailyPayoutsRoute: typeof adminReportsDailyPayoutsChar43DailyPayoutsRoute
  adminReportsDailyPayoutsChar43DailyPayoutsDetailRoute: typeof adminReportsDailyPayoutsChar43DailyPayoutsDetailRoute
}

const adminReportsDailyPayoutsChar43layoutRouteChildren: adminReportsDailyPayoutsChar43layoutRouteChildren =
  {
    adminReportsDailyPayoutsChar43DailyPayoutsRoute:
      adminReportsDailyPayoutsChar43DailyPayoutsRoute,
    adminReportsDailyPayoutsChar43DailyPayoutsDetailRoute:
      adminReportsDailyPayoutsChar43DailyPayoutsDetailRoute,
  }

const adminReportsDailyPayoutsChar43layoutRouteWithChildren =
  adminReportsDailyPayoutsChar43layoutRoute._addFileChildren(
    adminReportsDailyPayoutsChar43layoutRouteChildren,
  )

interface adminReportsIndexRouteChildren {
  adminReportsChar43cardPaymentsRoute: typeof adminReportsChar43cardPaymentsRoute
  adminReportsChar43CurrentSupportersReportPageRoute: typeof adminReportsChar43CurrentSupportersReportPageRoute
  adminReportsDailyPayoutsChar43layoutRoute: typeof adminReportsDailyPayoutsChar43layoutRouteWithChildren
  adminReportsEapChar43SupporterEapArrearsPageRoute: typeof adminReportsEapChar43SupporterEapArrearsPageRoute
  adminReportsEapChar43EapListingQuailityReviewRoute: typeof adminReportsEapChar43EapListingQuailityReviewRoute
  adminReportsEapChar43EapSessionRequestsPageRoute: typeof adminReportsEapChar43EapSessionRequestsPageRoute
  adminReportsEapChar43EapUnclosedSessionsPageRoute: typeof adminReportsEapChar43EapUnclosedSessionsPageRoute
  adminReportsChar43MemberSubscriptionsReportPageRoute: typeof adminReportsChar43MemberSubscriptionsReportPageRoute
  adminReportsChar43projectedMrrRoute: typeof adminReportsChar43projectedMrrRoute
  adminReportsChar43SupporterMonthlyStatsReportPageRoute: typeof adminReportsChar43SupporterMonthlyStatsReportPageRoute
  adminReportsChar43SupporterSalesReportPageRoute: typeof adminReportsChar43SupporterSalesReportPageRoute
}

const adminReportsIndexRouteChildren: adminReportsIndexRouteChildren = {
  adminReportsChar43cardPaymentsRoute: adminReportsChar43cardPaymentsRoute,
  adminReportsChar43CurrentSupportersReportPageRoute:
    adminReportsChar43CurrentSupportersReportPageRoute,
  adminReportsDailyPayoutsChar43layoutRoute:
    adminReportsDailyPayoutsChar43layoutRouteWithChildren,
  adminReportsEapChar43SupporterEapArrearsPageRoute:
    adminReportsEapChar43SupporterEapArrearsPageRoute,
  adminReportsEapChar43EapListingQuailityReviewRoute:
    adminReportsEapChar43EapListingQuailityReviewRoute,
  adminReportsEapChar43EapSessionRequestsPageRoute:
    adminReportsEapChar43EapSessionRequestsPageRoute,
  adminReportsEapChar43EapUnclosedSessionsPageRoute:
    adminReportsEapChar43EapUnclosedSessionsPageRoute,
  adminReportsChar43MemberSubscriptionsReportPageRoute:
    adminReportsChar43MemberSubscriptionsReportPageRoute,
  adminReportsChar43projectedMrrRoute: adminReportsChar43projectedMrrRoute,
  adminReportsChar43SupporterMonthlyStatsReportPageRoute:
    adminReportsChar43SupporterMonthlyStatsReportPageRoute,
  adminReportsChar43SupporterSalesReportPageRoute:
    adminReportsChar43SupporterSalesReportPageRoute,
}

const adminReportsIndexRouteWithChildren =
  adminReportsIndexRoute._addFileChildren(adminReportsIndexRouteChildren)

interface adminChar43LayoutRouteChildren {
  adminChar43AdminHomeRoute: typeof adminChar43AdminHomeRoute
  adminDevtoolsChar43LayoutRoute: typeof adminDevtoolsChar43LayoutRouteWithChildren
  adminChar43expiryRoute: typeof adminChar43expiryRoute
  adminStaffChar43routeRoute: typeof adminStaffChar43routeRoute
  adminAccountOwnersIndexRoute: typeof adminAccountOwnersIndexRoute
  adminCategoriesIndexRoute: typeof adminCategoriesIndexRoute
  adminCountriesIndexRoute: typeof adminCountriesIndexRoute
  adminLegalIndexRoute: typeof adminLegalIndexRouteWithChildren
  adminListingReviewIndexRoute: typeof adminListingReviewIndexRouteWithChildren
  adminMembersIndexRoute: typeof adminMembersIndexRouteWithChildren
  adminResourceCategoriesIndexRoute: typeof adminResourceCategoriesIndexRoute
  adminResourcesIndexRoute: typeof adminResourcesIndexRouteWithChildren
  adminSuppliersIndexRoute: typeof adminSuppliersIndexRouteWithChildren
  adminSupportersIndexRoute: typeof adminSupportersIndexRouteWithChildren
  adminSurplusesIndexRoute: typeof adminSurplusesIndexRoute
  adminThemesIndexRoute: typeof adminThemesIndexRoute
  adminUserSettingsIndexRoute: typeof adminUserSettingsIndexRoute
  adminClaimsIndexRoute: typeof adminClaimsIndexRoute
  adminClaimsChar91claimIdChar93IndexRoute: typeof adminClaimsChar91claimIdChar93IndexRoute
  adminReportsIndexRoute: typeof adminReportsIndexRouteWithChildren
  adminMembersChar91memberIdChar93NewClaimIndexRoute: typeof adminMembersChar91memberIdChar93NewClaimIndexRoute
  adminMembersChar91memberIdChar93NewPurchaseIndexRoute: typeof adminMembersChar91memberIdChar93NewPurchaseIndexRoute
  adminMembersChar91memberIdChar93TransactionsIndexRoute: typeof adminMembersChar91memberIdChar93TransactionsIndexRoute
}

const adminChar43LayoutRouteChildren: adminChar43LayoutRouteChildren = {
  adminChar43AdminHomeRoute: adminChar43AdminHomeRoute,
  adminDevtoolsChar43LayoutRoute: adminDevtoolsChar43LayoutRouteWithChildren,
  adminChar43expiryRoute: adminChar43expiryRoute,
  adminStaffChar43routeRoute: adminStaffChar43routeRoute,
  adminAccountOwnersIndexRoute: adminAccountOwnersIndexRoute,
  adminCategoriesIndexRoute: adminCategoriesIndexRoute,
  adminCountriesIndexRoute: adminCountriesIndexRoute,
  adminLegalIndexRoute: adminLegalIndexRouteWithChildren,
  adminListingReviewIndexRoute: adminListingReviewIndexRouteWithChildren,
  adminMembersIndexRoute: adminMembersIndexRouteWithChildren,
  adminResourceCategoriesIndexRoute: adminResourceCategoriesIndexRoute,
  adminResourcesIndexRoute: adminResourcesIndexRouteWithChildren,
  adminSuppliersIndexRoute: adminSuppliersIndexRouteWithChildren,
  adminSupportersIndexRoute: adminSupportersIndexRouteWithChildren,
  adminSurplusesIndexRoute: adminSurplusesIndexRoute,
  adminThemesIndexRoute: adminThemesIndexRoute,
  adminUserSettingsIndexRoute: adminUserSettingsIndexRoute,
  adminClaimsIndexRoute: adminClaimsIndexRoute,
  adminClaimsChar91claimIdChar93IndexRoute:
    adminClaimsChar91claimIdChar93IndexRoute,
  adminReportsIndexRoute: adminReportsIndexRouteWithChildren,
  adminMembersChar91memberIdChar93NewClaimIndexRoute:
    adminMembersChar91memberIdChar93NewClaimIndexRoute,
  adminMembersChar91memberIdChar93NewPurchaseIndexRoute:
    adminMembersChar91memberIdChar93NewPurchaseIndexRoute,
  adminMembersChar91memberIdChar93TransactionsIndexRoute:
    adminMembersChar91memberIdChar93TransactionsIndexRoute,
}

const adminChar43LayoutRouteWithChildren =
  adminChar43LayoutRoute._addFileChildren(adminChar43LayoutRouteChildren)

interface campaignsChar43LayoutRouteChildren {
  campaignsChar43CampaignsOverviewRoute: typeof campaignsChar43CampaignsOverviewRoute
  campaignsSegmentsChar43SegmentsPageRoute: typeof campaignsSegmentsChar43SegmentsPageRoute
  campaignsSendsChar43SendsPageRoute: typeof campaignsSendsChar43SendsPageRoute
  campaignsTemplatesChar43TemplatesPageRoute: typeof campaignsTemplatesChar43TemplatesPageRoute
  campaignsSuppressionChar43UnsubscribedListRoute: typeof campaignsSuppressionChar43UnsubscribedListRoute
  campaignsSegmentsChar43SegmentEditorRoute: typeof campaignsSegmentsChar43SegmentEditorRoute
  campaignsSendsChar43SendDetailRoute: typeof campaignsSendsChar43SendDetailRoute
  campaignsSendsChar43CreateSendRoute: typeof campaignsSendsChar43CreateSendRoute
  campaignsTemplatesChar43TemplateEditorRoute: typeof campaignsTemplatesChar43TemplateEditorRoute
}

const campaignsChar43LayoutRouteChildren: campaignsChar43LayoutRouteChildren = {
  campaignsChar43CampaignsOverviewRoute: campaignsChar43CampaignsOverviewRoute,
  campaignsSegmentsChar43SegmentsPageRoute:
    campaignsSegmentsChar43SegmentsPageRoute,
  campaignsSendsChar43SendsPageRoute: campaignsSendsChar43SendsPageRoute,
  campaignsTemplatesChar43TemplatesPageRoute:
    campaignsTemplatesChar43TemplatesPageRoute,
  campaignsSuppressionChar43UnsubscribedListRoute:
    campaignsSuppressionChar43UnsubscribedListRoute,
  campaignsSegmentsChar43SegmentEditorRoute:
    campaignsSegmentsChar43SegmentEditorRoute,
  campaignsSendsChar43SendDetailRoute: campaignsSendsChar43SendDetailRoute,
  campaignsSendsChar43CreateSendRoute: campaignsSendsChar43CreateSendRoute,
  campaignsTemplatesChar43TemplateEditorRoute:
    campaignsTemplatesChar43TemplateEditorRoute,
}

const campaignsChar43LayoutRouteWithChildren =
  campaignsChar43LayoutRoute._addFileChildren(
    campaignsChar43LayoutRouteChildren,
  )

interface dashboardChar43LayoutRouteChildren {
  dashboardChar43DashboardRoute: typeof dashboardChar43DashboardRoute
  dashboardChar43cashFlowRoute: typeof dashboardChar43cashFlowRoute
  dashboardChar43CostsDashboardRoute: typeof dashboardChar43CostsDashboardRoute
  dashboardCoverageChar43CoverageDashboardRoute: typeof dashboardCoverageChar43CoverageDashboardRoute
  dashboardChar43eapUtilisationRoute: typeof dashboardChar43eapUtilisationRoute
  dashboardChar43listingPricesRoute: typeof dashboardChar43listingPricesRoute
  dashboardChar43MRRRoute: typeof dashboardChar43MRRRoute
  dashboardChar43spendingRoute: typeof dashboardChar43spendingRoute
  dashboardChar43TVRoute: typeof dashboardChar43TVRoute
  dashboardChar43tv2Route: typeof dashboardChar43tv2Route
  dashboardChar43UsageDashboardRoute: typeof dashboardChar43UsageDashboardRoute
  dashboardChar43utilisationRoute: typeof dashboardChar43utilisationRoute
}

const dashboardChar43LayoutRouteChildren: dashboardChar43LayoutRouteChildren = {
  dashboardChar43DashboardRoute: dashboardChar43DashboardRoute,
  dashboardChar43cashFlowRoute: dashboardChar43cashFlowRoute,
  dashboardChar43CostsDashboardRoute: dashboardChar43CostsDashboardRoute,
  dashboardCoverageChar43CoverageDashboardRoute:
    dashboardCoverageChar43CoverageDashboardRoute,
  dashboardChar43eapUtilisationRoute: dashboardChar43eapUtilisationRoute,
  dashboardChar43listingPricesRoute: dashboardChar43listingPricesRoute,
  dashboardChar43MRRRoute: dashboardChar43MRRRoute,
  dashboardChar43spendingRoute: dashboardChar43spendingRoute,
  dashboardChar43TVRoute: dashboardChar43TVRoute,
  dashboardChar43tv2Route: dashboardChar43tv2Route,
  dashboardChar43UsageDashboardRoute: dashboardChar43UsageDashboardRoute,
  dashboardChar43utilisationRoute: dashboardChar43utilisationRoute,
}

const dashboardChar43LayoutRouteWithChildren =
  dashboardChar43LayoutRoute._addFileChildren(
    dashboardChar43LayoutRouteChildren,
  )

interface supplierEapReviewChar43ReviewListRouteChildren {
  supplierEapReviewIndexRoute: typeof supplierEapReviewIndexRoute
  supplierEapReviewChar91purchaseIdChar93IndexRoute: typeof supplierEapReviewChar91purchaseIdChar93IndexRoute
}

const supplierEapReviewChar43ReviewListRouteChildren: supplierEapReviewChar43ReviewListRouteChildren =
  {
    supplierEapReviewIndexRoute: supplierEapReviewIndexRoute,
    supplierEapReviewChar91purchaseIdChar93IndexRoute:
      supplierEapReviewChar91purchaseIdChar93IndexRoute,
  }

const supplierEapReviewChar43ReviewListRouteWithChildren =
  supplierEapReviewChar43ReviewListRoute._addFileChildren(
    supplierEapReviewChar43ReviewListRouteChildren,
  )

interface supplierEapIndexRouteChildren {
  supplierEapChar43EAPListRoute: typeof supplierEapChar43EAPListRoute
  supplierEapChar91listingIdChar93Char43pageRoute: typeof supplierEapChar91listingIdChar93Char43pageRoute
}

const supplierEapIndexRouteChildren: supplierEapIndexRouteChildren = {
  supplierEapChar43EAPListRoute: supplierEapChar43EAPListRoute,
  supplierEapChar91listingIdChar93Char43pageRoute:
    supplierEapChar91listingIdChar93Char43pageRoute,
}

const supplierEapIndexRouteWithChildren =
  supplierEapIndexRoute._addFileChildren(supplierEapIndexRouteChildren)

interface supplierListingsChar91listingIdChar93Char43variantsRouteChildren {
  supplierListingsChar91listingIdChar93Char43variantRoute: typeof supplierListingsChar91listingIdChar93Char43variantRoute
}

const supplierListingsChar91listingIdChar93Char43variantsRouteChildren: supplierListingsChar91listingIdChar93Char43variantsRouteChildren =
  {
    supplierListingsChar91listingIdChar93Char43variantRoute:
      supplierListingsChar91listingIdChar93Char43variantRoute,
  }

const supplierListingsChar91listingIdChar93Char43variantsRouteWithChildren =
  supplierListingsChar91listingIdChar93Char43variantsRoute._addFileChildren(
    supplierListingsChar91listingIdChar93Char43variantsRouteChildren,
  )

interface supplierListingsChar91listingIdChar93Char43EditListingPageRouteChildren {
  supplierListingsChar91listingIdChar93Char43indexRoute: typeof supplierListingsChar91listingIdChar93Char43indexRoute
  supplierListingsChar91listingIdChar93Char43variantsRoute: typeof supplierListingsChar91listingIdChar93Char43variantsRouteWithChildren
}

const supplierListingsChar91listingIdChar93Char43EditListingPageRouteChildren: supplierListingsChar91listingIdChar93Char43EditListingPageRouteChildren =
  {
    supplierListingsChar91listingIdChar93Char43indexRoute:
      supplierListingsChar91listingIdChar93Char43indexRoute,
    supplierListingsChar91listingIdChar93Char43variantsRoute:
      supplierListingsChar91listingIdChar93Char43variantsRouteWithChildren,
  }

const supplierListingsChar91listingIdChar93Char43EditListingPageRouteWithChildren =
  supplierListingsChar91listingIdChar93Char43EditListingPageRoute._addFileChildren(
    supplierListingsChar91listingIdChar93Char43EditListingPageRouteChildren,
  )

interface supplierListingsIndexRouteChildren {
  supplierListingsChar43ListingsPageRoute: typeof supplierListingsChar43ListingsPageRoute
  supplierListingsChar91listingIdChar93Char43EditListingPageRoute: typeof supplierListingsChar91listingIdChar93Char43EditListingPageRouteWithChildren
}

const supplierListingsIndexRouteChildren: supplierListingsIndexRouteChildren = {
  supplierListingsChar43ListingsPageRoute:
    supplierListingsChar43ListingsPageRoute,
  supplierListingsChar91listingIdChar93Char43EditListingPageRoute:
    supplierListingsChar91listingIdChar93Char43EditListingPageRouteWithChildren,
}

const supplierListingsIndexRouteWithChildren =
  supplierListingsIndexRoute._addFileChildren(
    supplierListingsIndexRouteChildren,
  )

interface supplierMessagesIndexRouteChildren {
  supplierMessagesChar43MessagesRoute: typeof supplierMessagesChar43MessagesRoute
  supplierMessagesChar91conversationIdChar93IndexRoute: typeof supplierMessagesChar91conversationIdChar93IndexRoute
}

const supplierMessagesIndexRouteChildren: supplierMessagesIndexRouteChildren = {
  supplierMessagesChar43MessagesRoute: supplierMessagesChar43MessagesRoute,
  supplierMessagesChar91conversationIdChar93IndexRoute:
    supplierMessagesChar91conversationIdChar93IndexRoute,
}

const supplierMessagesIndexRouteWithChildren =
  supplierMessagesIndexRoute._addFileChildren(
    supplierMessagesIndexRouteChildren,
  )

interface supplierSalesIndexRouteChildren {
  supplierSalesChar43SupplierSalesRoute: typeof supplierSalesChar43SupplierSalesRoute
  supplierSalesChar91purchaseIdChar93IndexRoute: typeof supplierSalesChar91purchaseIdChar93IndexRoute
}

const supplierSalesIndexRouteChildren: supplierSalesIndexRouteChildren = {
  supplierSalesChar43SupplierSalesRoute: supplierSalesChar43SupplierSalesRoute,
  supplierSalesChar91purchaseIdChar93IndexRoute:
    supplierSalesChar91purchaseIdChar93IndexRoute,
}

const supplierSalesIndexRouteWithChildren =
  supplierSalesIndexRoute._addFileChildren(supplierSalesIndexRouteChildren)

interface supplierSettingsCalendarsChar91calendarIdChar93IndexRouteChildren {
  supplierSettingsCalendarsChar91calendarIdChar93Char43EditCalendarSettingsRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93Char43EditCalendarSettingsRoute
  supplierSettingsCalendarsChar91calendarIdChar93ConnectIndexRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93ConnectIndexRoute
  supplierSettingsCalendarsChar91calendarIdChar93DisconnectIndexRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93DisconnectIndexRoute
  supplierSettingsCalendarsChar91calendarIdChar93ExternalIndexRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93ExternalIndexRoute
}

const supplierSettingsCalendarsChar91calendarIdChar93IndexRouteChildren: supplierSettingsCalendarsChar91calendarIdChar93IndexRouteChildren =
  {
    supplierSettingsCalendarsChar91calendarIdChar93Char43EditCalendarSettingsRoute:
      supplierSettingsCalendarsChar91calendarIdChar93Char43EditCalendarSettingsRoute,
    supplierSettingsCalendarsChar91calendarIdChar93ConnectIndexRoute:
      supplierSettingsCalendarsChar91calendarIdChar93ConnectIndexRoute,
    supplierSettingsCalendarsChar91calendarIdChar93DisconnectIndexRoute:
      supplierSettingsCalendarsChar91calendarIdChar93DisconnectIndexRoute,
    supplierSettingsCalendarsChar91calendarIdChar93ExternalIndexRoute:
      supplierSettingsCalendarsChar91calendarIdChar93ExternalIndexRoute,
  }

const supplierSettingsCalendarsChar91calendarIdChar93IndexRouteWithChildren =
  supplierSettingsCalendarsChar91calendarIdChar93IndexRoute._addFileChildren(
    supplierSettingsCalendarsChar91calendarIdChar93IndexRouteChildren,
  )

interface supplierSettingsCalendarsIndexRouteChildren {
  supplierSettingsCalendarsChar43CalendarSettingsRoute: typeof supplierSettingsCalendarsChar43CalendarSettingsRoute
  supplierSettingsCalendarsChar91calendarIdChar93IndexRoute: typeof supplierSettingsCalendarsChar91calendarIdChar93IndexRouteWithChildren
}

const supplierSettingsCalendarsIndexRouteChildren: supplierSettingsCalendarsIndexRouteChildren =
  {
    supplierSettingsCalendarsChar43CalendarSettingsRoute:
      supplierSettingsCalendarsChar43CalendarSettingsRoute,
    supplierSettingsCalendarsChar91calendarIdChar93IndexRoute:
      supplierSettingsCalendarsChar91calendarIdChar93IndexRouteWithChildren,
  }

const supplierSettingsCalendarsIndexRouteWithChildren =
  supplierSettingsCalendarsIndexRoute._addFileChildren(
    supplierSettingsCalendarsIndexRouteChildren,
  )

interface supplierSettingsRefundIndexRouteChildren {
  supplierSettingsRefundChar43RefundSettingsRoute: typeof supplierSettingsRefundChar43RefundSettingsRoute
  supplierSettingsRefundCancellationPolicyChar91policyIdChar93IndexRoute: typeof supplierSettingsRefundCancellationPolicyChar91policyIdChar93IndexRoute
}

const supplierSettingsRefundIndexRouteChildren: supplierSettingsRefundIndexRouteChildren =
  {
    supplierSettingsRefundChar43RefundSettingsRoute:
      supplierSettingsRefundChar43RefundSettingsRoute,
    supplierSettingsRefundCancellationPolicyChar91policyIdChar93IndexRoute:
      supplierSettingsRefundCancellationPolicyChar91policyIdChar93IndexRoute,
  }

const supplierSettingsRefundIndexRouteWithChildren =
  supplierSettingsRefundIndexRoute._addFileChildren(
    supplierSettingsRefundIndexRouteChildren,
  )

interface supplierSettingsTeamIndexRouteChildren {
  supplierSettingsTeamChar43TeamTableRoute: typeof supplierSettingsTeamChar43TeamTableRoute
}

const supplierSettingsTeamIndexRouteChildren: supplierSettingsTeamIndexRouteChildren =
  {
    supplierSettingsTeamChar43TeamTableRoute:
      supplierSettingsTeamChar43TeamTableRoute,
  }

const supplierSettingsTeamIndexRouteWithChildren =
  supplierSettingsTeamIndexRoute._addFileChildren(
    supplierSettingsTeamIndexRouteChildren,
  )

interface supplierSettingsIndexRouteChildren {
  supplierSettingsProfileIndexRoute: typeof supplierSettingsProfileIndexRoute
  supplierSettingsAutomationsIndexRoute: typeof supplierSettingsAutomationsIndexRoute
  supplierSettingsBusinessIndexRoute: typeof supplierSettingsBusinessIndexRoute
  supplierSettingsCalendarsIndexRoute: typeof supplierSettingsCalendarsIndexRouteWithChildren
  supplierSettingsGivenwellTermsIndexRoute: typeof supplierSettingsGivenwellTermsIndexRoute
  supplierSettingsLegalIndexRoute: typeof supplierSettingsLegalIndexRoute
  supplierSettingsLocationsIndexRoute: typeof supplierSettingsLocationsIndexRoute
  supplierSettingsMarketsIndexRoute: typeof supplierSettingsMarketsIndexRoute
  supplierSettingsPaymentIndexRoute: typeof supplierSettingsPaymentIndexRoute
  supplierSettingsRefundIndexRoute: typeof supplierSettingsRefundIndexRouteWithChildren
  supplierSettingsTeamIndexRoute: typeof supplierSettingsTeamIndexRouteWithChildren
}

const supplierSettingsIndexRouteChildren: supplierSettingsIndexRouteChildren = {
  supplierSettingsProfileIndexRoute: supplierSettingsProfileIndexRoute,
  supplierSettingsAutomationsIndexRoute: supplierSettingsAutomationsIndexRoute,
  supplierSettingsBusinessIndexRoute: supplierSettingsBusinessIndexRoute,
  supplierSettingsCalendarsIndexRoute:
    supplierSettingsCalendarsIndexRouteWithChildren,
  supplierSettingsGivenwellTermsIndexRoute:
    supplierSettingsGivenwellTermsIndexRoute,
  supplierSettingsLegalIndexRoute: supplierSettingsLegalIndexRoute,
  supplierSettingsLocationsIndexRoute: supplierSettingsLocationsIndexRoute,
  supplierSettingsMarketsIndexRoute: supplierSettingsMarketsIndexRoute,
  supplierSettingsPaymentIndexRoute: supplierSettingsPaymentIndexRoute,
  supplierSettingsRefundIndexRoute:
    supplierSettingsRefundIndexRouteWithChildren,
  supplierSettingsTeamIndexRoute: supplierSettingsTeamIndexRouteWithChildren,
}

const supplierSettingsIndexRouteWithChildren =
  supplierSettingsIndexRoute._addFileChildren(
    supplierSettingsIndexRouteChildren,
  )

interface supplierChar43LayoutRouteChildren {
  supplierChar43SupplierHomeRoute: typeof supplierChar43SupplierHomeRoute
  supplierEapReviewChar43ReviewListRoute: typeof supplierEapReviewChar43ReviewListRouteWithChildren
  supplierBookingsIndexRoute: typeof supplierBookingsIndexRoute
  supplierEapIndexRoute: typeof supplierEapIndexRouteWithChildren
  supplierListingsIndexRoute: typeof supplierListingsIndexRouteWithChildren
  supplierMessagesIndexRoute: typeof supplierMessagesIndexRouteWithChildren
  supplierOrdersIndexRoute: typeof supplierOrdersIndexRoute
  supplierPassesIndexRoute: typeof supplierPassesIndexRoute
  supplierPaymentsIndexRoute: typeof supplierPaymentsIndexRoute
  supplierSalesIndexRoute: typeof supplierSalesIndexRouteWithChildren
  supplierSettingsIndexRoute: typeof supplierSettingsIndexRouteWithChildren
  supplierSkuIndexRoute: typeof supplierSkuIndexRoute
  supplierSubscriptionsIndexRoute: typeof supplierSubscriptionsIndexRoute
  supplierUserSettingsIndexRoute: typeof supplierUserSettingsIndexRoute
}

const supplierChar43LayoutRouteChildren: supplierChar43LayoutRouteChildren = {
  supplierChar43SupplierHomeRoute: supplierChar43SupplierHomeRoute,
  supplierEapReviewChar43ReviewListRoute:
    supplierEapReviewChar43ReviewListRouteWithChildren,
  supplierBookingsIndexRoute: supplierBookingsIndexRoute,
  supplierEapIndexRoute: supplierEapIndexRouteWithChildren,
  supplierListingsIndexRoute: supplierListingsIndexRouteWithChildren,
  supplierMessagesIndexRoute: supplierMessagesIndexRouteWithChildren,
  supplierOrdersIndexRoute: supplierOrdersIndexRoute,
  supplierPassesIndexRoute: supplierPassesIndexRoute,
  supplierPaymentsIndexRoute: supplierPaymentsIndexRoute,
  supplierSalesIndexRoute: supplierSalesIndexRouteWithChildren,
  supplierSettingsIndexRoute: supplierSettingsIndexRouteWithChildren,
  supplierSkuIndexRoute: supplierSkuIndexRoute,
  supplierSubscriptionsIndexRoute: supplierSubscriptionsIndexRoute,
  supplierUserSettingsIndexRoute: supplierUserSettingsIndexRoute,
}

const supplierChar43LayoutRouteWithChildren =
  supplierChar43LayoutRoute._addFileChildren(supplierChar43LayoutRouteChildren)

interface supporterAllowanceReportsChar43LayoutRouteChildren {
  supporterAllowanceReportsChar43indexRoute: typeof supporterAllowanceReportsChar43indexRoute
  supporterAllowanceReportsForecastIndexRoute: typeof supporterAllowanceReportsForecastIndexRoute
  supporterAllowanceReportsInsightsIndexRoute: typeof supporterAllowanceReportsInsightsIndexRoute
  supporterAllowanceReportsSpendIndexRoute: typeof supporterAllowanceReportsSpendIndexRoute
  supporterAllowanceReportsUtilisationIndexRoute: typeof supporterAllowanceReportsUtilisationIndexRoute
}

const supporterAllowanceReportsChar43LayoutRouteChildren: supporterAllowanceReportsChar43LayoutRouteChildren =
  {
    supporterAllowanceReportsChar43indexRoute:
      supporterAllowanceReportsChar43indexRoute,
    supporterAllowanceReportsForecastIndexRoute:
      supporterAllowanceReportsForecastIndexRoute,
    supporterAllowanceReportsInsightsIndexRoute:
      supporterAllowanceReportsInsightsIndexRoute,
    supporterAllowanceReportsSpendIndexRoute:
      supporterAllowanceReportsSpendIndexRoute,
    supporterAllowanceReportsUtilisationIndexRoute:
      supporterAllowanceReportsUtilisationIndexRoute,
  }

const supporterAllowanceReportsChar43LayoutRouteWithChildren =
  supporterAllowanceReportsChar43LayoutRoute._addFileChildren(
    supporterAllowanceReportsChar43LayoutRouteChildren,
  )

interface supporterFinancialReportsTransactionsIndexRouteChildren {
  supporterFinancialReportsTransactionsChar43WalletRoute: typeof supporterFinancialReportsTransactionsChar43WalletRoute
  supporterFinancialReportsTransactionsAllowanceChar91batchIdChar93IndexRoute: typeof supporterFinancialReportsTransactionsAllowanceChar91batchIdChar93IndexRoute
  supporterFinancialReportsTransactionsDetailsChar91versionChar93IndexRoute: typeof supporterFinancialReportsTransactionsDetailsChar91versionChar93IndexRoute
}

const supporterFinancialReportsTransactionsIndexRouteChildren: supporterFinancialReportsTransactionsIndexRouteChildren =
  {
    supporterFinancialReportsTransactionsChar43WalletRoute:
      supporterFinancialReportsTransactionsChar43WalletRoute,
    supporterFinancialReportsTransactionsAllowanceChar91batchIdChar93IndexRoute:
      supporterFinancialReportsTransactionsAllowanceChar91batchIdChar93IndexRoute,
    supporterFinancialReportsTransactionsDetailsChar91versionChar93IndexRoute:
      supporterFinancialReportsTransactionsDetailsChar91versionChar93IndexRoute,
  }

const supporterFinancialReportsTransactionsIndexRouteWithChildren =
  supporterFinancialReportsTransactionsIndexRoute._addFileChildren(
    supporterFinancialReportsTransactionsIndexRouteChildren,
  )

interface supporterFinancialReportsChar43reportsRouteChildren {
  supporterFinancialReportsChar43indexRoute: typeof supporterFinancialReportsChar43indexRoute
  supporterFinancialReportsInvoicesIndexRoute: typeof supporterFinancialReportsInvoicesIndexRoute
  supporterFinancialReportsTransactionsIndexRoute: typeof supporterFinancialReportsTransactionsIndexRouteWithChildren
}

const supporterFinancialReportsChar43reportsRouteChildren: supporterFinancialReportsChar43reportsRouteChildren =
  {
    supporterFinancialReportsChar43indexRoute:
      supporterFinancialReportsChar43indexRoute,
    supporterFinancialReportsInvoicesIndexRoute:
      supporterFinancialReportsInvoicesIndexRoute,
    supporterFinancialReportsTransactionsIndexRoute:
      supporterFinancialReportsTransactionsIndexRouteWithChildren,
  }

const supporterFinancialReportsChar43reportsRouteWithChildren =
  supporterFinancialReportsChar43reportsRoute._addFileChildren(
    supporterFinancialReportsChar43reportsRouteChildren,
  )

interface supporterSettingsChar43routeRouteChildren {
  supporterSettingsChar43indexRoute: typeof supporterSettingsChar43indexRoute
  supporterSettingsBillingIndexRoute: typeof supporterSettingsBillingIndexRoute
  supporterSettingsCountriesIndexRoute: typeof supporterSettingsCountriesIndexRoute
  supporterSettingsGivenwellTermsIndexRoute: typeof supporterSettingsGivenwellTermsIndexRoute
}

const supporterSettingsChar43routeRouteChildren: supporterSettingsChar43routeRouteChildren =
  {
    supporterSettingsChar43indexRoute: supporterSettingsChar43indexRoute,
    supporterSettingsBillingIndexRoute: supporterSettingsBillingIndexRoute,
    supporterSettingsCountriesIndexRoute: supporterSettingsCountriesIndexRoute,
    supporterSettingsGivenwellTermsIndexRoute:
      supporterSettingsGivenwellTermsIndexRoute,
  }

const supporterSettingsChar43routeRouteWithChildren =
  supporterSettingsChar43routeRoute._addFileChildren(
    supporterSettingsChar43routeRouteChildren,
  )

interface supporterEapIndexRouteChildren {
  supporterEapChar43EAPRoute: typeof supporterEapChar43EAPRoute
  supporterEapSettingsIndexRoute: typeof supporterEapSettingsIndexRoute
  supporterEapRequestsIndexRoute: typeof supporterEapRequestsIndexRoute
  supporterEapRequestsChar91requestIdChar93IndexRoute: typeof supporterEapRequestsChar91requestIdChar93IndexRoute
}

const supporterEapIndexRouteChildren: supporterEapIndexRouteChildren = {
  supporterEapChar43EAPRoute: supporterEapChar43EAPRoute,
  supporterEapSettingsIndexRoute: supporterEapSettingsIndexRoute,
  supporterEapRequestsIndexRoute: supporterEapRequestsIndexRoute,
  supporterEapRequestsChar91requestIdChar93IndexRoute:
    supporterEapRequestsChar91requestIdChar93IndexRoute,
}

const supporterEapIndexRouteWithChildren =
  supporterEapIndexRoute._addFileChildren(supporterEapIndexRouteChildren)

interface supporterChar43LayoutRouteChildren {
  supporterChar43SupporterHomeRoute: typeof supporterChar43SupporterHomeRoute
  supporterAllowanceReportsChar43LayoutRoute: typeof supporterAllowanceReportsChar43LayoutRouteWithChildren
  supporterFinancialReportsChar43reportsRoute: typeof supporterFinancialReportsChar43reportsRouteWithChildren
  supporterSettingsChar43routeRoute: typeof supporterSettingsChar43routeRouteWithChildren
  supporterAdminsIndexRoute: typeof supporterAdminsIndexRoute
  supporterAllowancesIndexRoute: typeof supporterAllowancesIndexRoute
  supporterEapIndexRoute: typeof supporterEapIndexRouteWithChildren
  supporterHistoryIndexRoute: typeof supporterHistoryIndexRoute
  supporterReportsIndexRoute: typeof supporterReportsIndexRoute
  supporterTeamIndexRoute: typeof supporterTeamIndexRoute
  supporterUserSettingsIndexRoute: typeof supporterUserSettingsIndexRoute
  supporterAdminsChar91userIdChar93IndexRoute: typeof supporterAdminsChar91userIdChar93IndexRoute
}

const supporterChar43LayoutRouteChildren: supporterChar43LayoutRouteChildren = {
  supporterChar43SupporterHomeRoute: supporterChar43SupporterHomeRoute,
  supporterAllowanceReportsChar43LayoutRoute:
    supporterAllowanceReportsChar43LayoutRouteWithChildren,
  supporterFinancialReportsChar43reportsRoute:
    supporterFinancialReportsChar43reportsRouteWithChildren,
  supporterSettingsChar43routeRoute:
    supporterSettingsChar43routeRouteWithChildren,
  supporterAdminsIndexRoute: supporterAdminsIndexRoute,
  supporterAllowancesIndexRoute: supporterAllowancesIndexRoute,
  supporterEapIndexRoute: supporterEapIndexRouteWithChildren,
  supporterHistoryIndexRoute: supporterHistoryIndexRoute,
  supporterReportsIndexRoute: supporterReportsIndexRoute,
  supporterTeamIndexRoute: supporterTeamIndexRoute,
  supporterUserSettingsIndexRoute: supporterUserSettingsIndexRoute,
  supporterAdminsChar91userIdChar93IndexRoute:
    supporterAdminsChar91userIdChar93IndexRoute,
}

const supporterChar43LayoutRouteWithChildren =
  supporterChar43LayoutRoute._addFileChildren(
    supporterChar43LayoutRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  Char43HomeRoute: Char43HomeRoute,
  adminChar43LayoutRoute: adminChar43LayoutRouteWithChildren,
  campaignsChar43LayoutRoute: campaignsChar43LayoutRouteWithChildren,
  dashboardChar43LayoutRoute: dashboardChar43LayoutRouteWithChildren,
  demoChar43routeRoute: demoChar43routeRoute,
  forgotPasswordIndexRoute: forgotPasswordIndexRoute,
  newAccountIndexRoute: newAccountIndexRoute,
  newSupplierIndexRoute: newSupplierIndexRoute,
  signInIndexRoute: signInIndexRoute,
  policiesChar43eapSupplierRoute: policiesChar43eapSupplierRoute,
  supplierChar43LayoutRoute: supplierChar43LayoutRouteWithChildren,
  supporterChar43LayoutRoute: supporterChar43LayoutRouteWithChildren,
  invitationActivateIndexRoute: invitationActivateIndexRoute,
  supplierEapNewIndexRoute: supplierEapNewIndexRoute,
  supplierListingsNewIndexRoute: supplierListingsNewIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
